/** @jsxImportSource @emotion/react */
import tw, { theme } from 'twin.macro';

const DynamicSvg = ({ iconName, size, fill, cssStyle }) => {
  const cssHeroSectionImage = cssStyle === true && tw`w-[47rem] h-[28.25rem]`;
  const cssGender = cssStyle === 'gender' && tw`m-[1rem auto 0]`;
  const cssDirection =
    cssStyle === 'bigDirection'
      ? tw`ml-[1rem] mr-[-0.25rem]`
      : cssStyle === 'smallDirection'
      ? tw`m-[1rem auto 0]`
      : '';

  return (
    <span>
      {
        {
          FifteenToTwentyfourInactiveMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_50946)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_837_50946)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_837_50946)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_837_50946)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_50946" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_50946)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint4_linear_837_50946)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#E8AE45"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M488.709 256.724C471.913 253.477 463.48 252.135 446.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.473 257.305C525.173 253.595 533.565 252.021 550.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_837_50946)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_50946"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_50946"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_50946"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_50946"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_50946"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_837_50946"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourEmployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_44903)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_44903)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_44903)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_44903)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_44903)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_44903" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_44903)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_44903)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.681L337.702 478.265L361.485 382.638Z"
                fill="#3A7CC5"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L487 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.95 370.899 500.128 370.899C480.307 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.81 285.006C430.202 279.72 434.424 273.994 437.36 271.792C437.544 270.14 436.81 266.176 432.405 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.601 271.234C556.601 292.097 549.952 318.718 544.966 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.332 325.469C446.899 319.843 440.251 292.097 440.251 271.234C440.251 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.601 226.532 556.601 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M523.804 325.75L505.634 321.345L499.027 322.997L492.42 321.345L475.351 324.649L472.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.804 325.75L527.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M488.708 253.74C471.915 250.48 463.483 249.132 446.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.447 253.997C525.199 250.532 533.613 249.081 550.468 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.06 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M487 267C479 261.5 463.5 255 449.5 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.174 267C519.174 261.5 534.674 255 548.674 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.489 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_44903)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_44903"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_44903"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_44903"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_44903"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_44903"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_44903"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_44903"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourUnemployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_55967)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_837_55967)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_837_55967)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_837_55967)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_55967" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_55967)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.149 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.149 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.149 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.149 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint4_linear_837_55967)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#FF6600"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.06 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.06 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.06 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.06 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M488.501 253.857C473.633 256.674 463.613 252.023 446.719 254.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.493 254.182C519.368 257.609 533.483 251.963 550.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_837_55967)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_55967"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_55967"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_55967"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_55967"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_55967"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_837_55967"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourUnemployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_53459)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_837_53459)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_837_53459)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_837_53459)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_53459" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_53459)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint4_linear_837_53459)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.389L497.569 525.065L356.616 503.389L383.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M398.461 413.642L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M430.156 361.988L440.593 314.5L467.105 343.5L467.105 369.5L455.834 400L467.443 417.594L455.834 430.74L467.105 448.597L452.513 464.616L460.553 476.8L434.396 491.633L451.513 476.8L439.593 466.517L453.969 449.395L437.921 432.468L449 416L436.25 398.419L440.593 383.5L430.156 361.988Z"
                fill="#543422"
              />
              <path
                d="M558.546 361.988L548.109 314.5L521.597 343.5L521.597 374L529.5 398.419L521.258 417.594L532.867 430.74L521.597 448.597L536.189 464.616L528.149 476.8L554.306 491.633L536.189 476.8L548.109 466.517L533.732 449.395L549.78 432.468L539.5 413.5L551.5 396L543.181 379.048L558.546 361.988Z"
                fill="#543422"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.257 493.777 215.257C526.59 215.257 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.555 280.999C467.706 283.711 459.438 277.988 442.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.258 280.438C518.806 283.105 528.286 277.997 545.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 397L437.5 416.5L427.489 431.5L431.5 447.5L420.5 459L424.5 447L418.5 427.5L427.489 415L420.5 394L426.5 381L416.5 390.5L422 408L409.5 419.5L413.5 431.5L393 440L402.5 431.5L395.5 420.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L573 419.5L568 432.5L573 445L556 434.5L562 422.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.163)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.73 477.455 342.73L478.721 343.364L490.118 340.831L493.917 342.097L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.499 494.55 333.866 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.306L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.306L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.951 478.721 343.997L489.485 340.831L493.917 342.097L498.349 340.831L510.379 343.997C506.369 346.529 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.022L498.063 340.598L509.5 344"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.728C490.621 351.684 493.731 353.022 497.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.293 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.642L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_837_53459)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_53459"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_53459"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_53459"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_53459"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_53459"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_837_53459"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourEmployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_792_55973)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_792_55973)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_792_55973)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_792_55973)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_792_55973)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <g clipPath="url(#clip0_792_55973)">
                <path
                  d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                  fill="#9ACDF2"
                />
                <path
                  d="M289 213H374.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M611 213H696.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M289 288H374.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M611 288H696.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M289 363H374.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M611 363H696.5"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <mask id="path-22-inside-1_792_55973" fill="white">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                  />
                </mask>
                <path
                  d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                  fill="#DEF1FF"
                  mask="url(#path-22-inside-1_792_55973)"
                />
                <circle
                  cx="339"
                  cy="172"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <path
                  d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <path
                  d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="647"
                  cy="172"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="361"
                  cy="125"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="625"
                  cy="125"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="397"
                  cy="89"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="589"
                  cy="89"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="443"
                  cy="64"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="492"
                  cy="46"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle
                  cx="543"
                  cy="64"
                  r="18"
                  stroke="#DEF1FF"
                  strokeWidth="2"
                />
                <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
                <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 618 201)"
                  fill="#DEF1FF"
                />
                <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 682 193)"
                  fill="#DEF1FF"
                />
                <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 662 136)"
                  fill="#DEF1FF"
                />
                <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 628 87)"
                  fill="#DEF1FF"
                />
                <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 579 50)"
                  fill="#DEF1FF"
                />
                <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 528 27)"
                  fill="#DEF1FF"
                />
                <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 607 161)"
                  fill="#DEF1FF"
                />
                <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 585 127)"
                  fill="#DEF1FF"
                />
                <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 551 101)"
                  fill="#DEF1FF"
                />
                <circle cx="477" cy="82" r="4" fill="white" />
                <circle
                  r="4"
                  transform="matrix(-1 0 0 1 507 82)"
                  fill="#DEF1FF"
                />
                <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
                <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
                <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
                <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
                <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
                <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
                <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
                <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
                <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
                <path
                  d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                  fill="#DEF1FF"
                />
                <path
                  d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                  stroke="#DEF1FF"
                  strokeWidth="1.85508"
                />
                <path
                  opacity="0.1"
                  d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                  fill="url(#pattern0)"
                />
                <rect
                  x="288"
                  y="287"
                  width="409"
                  height="167"
                  fill="url(#paint5_linear_792_55973)"
                />
              </g>
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M465.634 346.47H521.795V374.551L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.551C521.795 374.551 516 393.578 493.714 393.5C471.429 393.423 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M430.156 361.989L440.593 314.5L467.105 343.5L467.105 369.5L455.834 400L467.443 417.595L455.834 430.74L467.105 448.598L452.513 464.616L460.553 476.8L434.396 491.633L451.513 476.8L439.593 466.517L453.969 449.395L437.921 432.468L449 416L436.25 398.419L440.593 383.5L430.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M558.546 361.989L548.109 314.5L521.597 343.5L521.597 374L529.5 398.419L521.258 417.595L532.867 430.74L521.597 448.598L536.189 464.616L528.149 476.8L554.306 491.633L536.189 476.8L548.109 466.517L533.732 449.395L549.78 432.468L539.5 413.5L551.5 396L543.181 379.048L558.546 361.989Z"
                fill="#543422"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.598 278.941C467.855 275.434 459.444 273.963 442.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.168 279.267C519.854 275.501 528.242 273.899 545.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 397L437.5 416.5L427.489 431.5L431.5 447.5L420.5 459L424.5 447L418.5 427.5L427.489 415L420.5 394L426.5 381L416.5 390.5L422 408L409.5 419.5L413.5 431.5L393 440L402.5 431.5L395.5 420.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L573 419.5L568 432.5L573 445L556 434.5L562 422.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.735 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M476.821 342.023L478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997L511.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.554V511.852"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_792_55973)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_792_55973"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_792_55973"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_792_55973"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_792_55973"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_792_55973"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_792_55973"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_792_55973"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
                <clipPath id="clip0_792_55973">
                  <rect
                    width="410"
                    height="433.406"
                    fill="white"
                    transform="translate(288)"
                  />
                </clipPath>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourInactiveFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_48433)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_837_48433)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_837_48433)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_837_48433)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_48433" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_48433)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint4_linear_837_48433)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.389L497.569 525.065L356.616 503.389L383.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M398.461 413.642L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M430.156 361.988L440.593 314.5L467.105 343.5L467.105 369.5L455.834 400L467.443 417.594L455.834 430.74L467.105 448.597L452.513 464.616L460.553 476.8L434.396 491.633L451.513 476.8L439.593 466.517L453.969 449.395L437.921 432.468L449 416L436.25 398.419L440.593 383.5L430.156 361.988Z"
                fill="#543422"
              />
              <path
                d="M558.546 361.988L548.109 314.5L521.597 343.5L521.597 374L529.5 398.419L521.258 417.594L532.867 430.74L521.597 448.597L536.189 464.616L528.149 476.8L554.306 491.633L536.189 476.8L548.109 466.517L533.732 449.395L549.78 432.468L539.5 413.5L551.5 396L543.181 379.048L558.546 361.988Z"
                fill="#543422"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.257 493.777 215.257C526.59 215.257 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.581 282.131C467.871 278.473 459.473 276.925 442.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.166 282.25C519.856 278.497 528.245 276.902 545.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 397L437.5 416.5L427.489 431.5L431.5 447.5L420.5 459L424.5 447L418.5 427.5L427.489 415L420.5 394L426.5 381L416.5 390.5L422 408L409.5 419.5L413.5 431.5L393 440L402.5 431.5L395.5 420.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L573 419.5L568 432.5L573 445L556 434.5L562 422.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.163)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.73 477.455 342.73L478.721 343.364L490.118 340.831L493.917 342.097L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.866 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.306L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.306L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.097L498.349 340.831L510.379 343.997C506.369 346.529 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.022L498.063 340.598L509.5 344"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.728C490.621 351.684 493.731 353.022 497.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.293 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.642L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_837_48433)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_48433"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_48433"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_48433"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_48433"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_48433"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_837_48433"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourInactiveAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_707_34019)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_707_34019)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_707_34019)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_707_34019)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_707_34019" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_707_34019)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#E8AE45"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M350.238 340.065H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.851 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.059 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.059 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.059 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.059 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M375.709 256.724C358.913 253.477 350.48 252.135 333.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.473 257.305C412.173 253.595 420.565 252.021 437.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.557L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.557L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.732 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M263.794 409.44L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.754H640.051L716.332 391.292L743.363 503.389L609.569 525.065L468.616 503.389L495.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern4)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M542.156 361.988L552.593 314.5L579.105 343.5L579.105 369.5L567.834 400L579.443 417.594L567.834 430.74L579.105 448.597L564.513 464.616L572.553 476.8L546.396 491.633L563.513 476.8L551.593 466.517L565.969 449.395L549.921 432.468L561 416L548.25 398.419L552.593 383.5L542.156 361.988Z"
                fill="#543422"
              />
              <path
                d="M670.546 361.988L660.109 314.5L633.597 343.5L633.597 374L641.5 398.419L633.258 417.594L644.867 430.74L633.597 448.597L648.189 464.616L640.149 476.8L666.306 491.633L648.189 476.8L660.109 466.517L645.732 449.395L661.78 432.468L651.5 413.5L663.5 396L655.181 379.048L670.546 361.988Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.581 282.131C579.871 278.473 571.473 276.925 554.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.166 282.25C631.856 278.497 640.245 276.902 657.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 397L549.5 416.5L539.489 431.5L543.5 447.5L532.5 459L536.5 447L530.5 427.5L539.489 415L532.5 394L538.5 381L528.5 390.5L534 408L521.5 419.5L525.5 431.5L505 440L514.5 431.5L507.5 420.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L685 419.5L680 432.5L685 445L668 434.5L674 422.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.5 344"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint4_radial_707_34019)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_707_34019"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_707_34019"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_707_34019"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_707_34019"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint4_radial_707_34019"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourUnemployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_707_34279)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint1_linear_707_34279)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint2_linear_707_34279)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint3_linear_707_34279)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_707_34279" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_707_34279)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.05"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#FF6600"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M350.238 340.066H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.066Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.852 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M375.501 253.857C360.633 256.674 350.613 252.023 333.719 254.968"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.493 254.182C406.368 257.609 420.483 251.963 437.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.558L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.558L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern4)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M542.156 361.989L552.593 314.5L579.105 343.5L579.105 369.5L567.834 400L579.443 417.594L567.834 430.74L579.105 448.597L564.513 464.616L572.553 476.8L546.396 491.633L563.513 476.8L551.593 466.517L565.969 449.395L549.921 432.468L561 416L548.25 398.419L552.593 383.5L542.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M670.546 361.989L660.109 314.5L633.597 343.5L633.597 374L641.5 398.419L633.258 417.594L644.867 430.74L633.597 448.597L648.189 464.616L640.149 476.8L666.306 491.633L648.189 476.8L660.109 466.517L645.732 449.395L661.78 432.468L651.5 413.5L663.5 396L655.181 379.048L670.546 361.989Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.555 280.999C579.706 283.712 571.438 277.988 554.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.258 280.438C630.806 283.105 640.286 277.997 657.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 397L549.5 416.5L539.489 431.5L543.5 447.5L532.5 459L536.5 447L530.5 427.5L539.489 415L532.5 394L538.5 381L528.5 390.5L534 408L521.5 419.5L525.5 431.5L505 440L514.5 431.5L507.5 420.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L685 419.5L680 432.5L685 445L668 434.5L674 422.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.5 344"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint4_radial_707_34279)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_707_34279"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_707_34279"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_707_34279"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_707_34279"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint4_radial_707_34279"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FifteenToTwentyfourEmployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_707_33759)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_707_33759)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_707_33759)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_707_33759)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_707_33759)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_707_33759" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_707_33759)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.224C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.224L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.058C318.359 268.376 320.131 263.736 320.842 261.372C318.477 262.083 313.838 263.854 310.156 267.536C306.474 271.217 304.703 275.857 303.992 278.222C306.357 277.51 310.996 275.739 314.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.323 309.982 242.296 311.294 243.489C311.782 243.933 311.584 244.674 310.939 244.814C309.206 245.192 306.014 245.627 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.995 300.856 238.56 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.323 351.612 242.296 350.3 243.489C349.812 243.933 350.01 244.674 350.655 244.814C352.388 245.192 355.581 245.627 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.995 360.739 238.56 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.058C344.872 268.376 343.101 263.736 342.389 261.372C344.754 262.083 349.394 263.854 353.075 267.536C356.757 271.217 358.528 275.857 359.24 278.222C356.875 277.51 352.235 275.739 348.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.224C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.224L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.058C640.359 268.376 642.131 263.736 642.842 261.372C640.477 262.083 635.838 263.854 632.156 267.536C628.474 271.217 626.703 275.857 625.992 278.222C628.357 277.51 632.996 275.739 636.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.323 631.982 242.296 633.294 243.489C633.782 243.933 633.584 244.674 632.939 244.814C631.206 245.192 628.014 245.627 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.995 622.856 238.56 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.323 673.612 242.296 672.3 243.489C671.812 243.933 672.01 244.674 672.655 244.814C674.388 245.192 677.581 245.627 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.995 682.739 238.56 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.058C666.872 268.376 665.101 263.736 664.389 261.372C666.754 262.083 671.394 263.854 675.075 267.536C678.757 271.217 680.528 275.857 681.24 278.222C678.875 277.51 674.235 275.739 670.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.204 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.204 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.143 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.917 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.104C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.899 323.489 309.41C322.295 308.099 320.322 305.551 319.441 302.262C318.56 298.972 318.995 295.779 319.372 294.047C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.899 339.248 309.41C340.441 308.099 342.414 305.551 343.296 302.262C344.177 298.972 343.742 295.779 343.365 294.047C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.104C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.143 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.917 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.204 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.204 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.143 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.917 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.104C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.899 645.489 309.41C644.295 308.099 642.322 305.551 641.441 302.262C640.56 298.972 640.995 295.779 641.372 294.047C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.899 661.248 309.41C662.441 308.099 664.414 305.551 665.296 302.262C666.177 298.972 665.742 295.779 665.365 294.047C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.104C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.143 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.917 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.204 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.204 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.143 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.917 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.104C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.899 323.489 384.41C322.295 383.099 320.322 380.551 319.441 377.262C318.56 373.972 318.995 370.779 319.372 369.047C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.899 339.248 384.41C340.441 383.099 342.414 380.551 343.296 377.262C344.177 373.972 343.742 370.779 343.365 369.047C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.104C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.143 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.917 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.204 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.204 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.143 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.917 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.104C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.899 645.489 384.41C644.295 383.099 642.322 380.551 641.441 377.262C640.56 373.972 640.995 370.779 641.372 369.047C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.899 661.248 384.41C662.441 383.099 664.414 380.551 665.296 377.262C666.177 373.972 665.742 370.779 665.365 369.047C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.104C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.143 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.917 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#3A7CC5"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.6"
                d="M350.238 340.065H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.851 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M410.804 325.75L392.634 321.345L386.027 322.997L379.42 321.345L362.351 324.649L359.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.803 325.75L414.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M375.708 253.74C358.915 250.48 350.483 249.132 333.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.446 253.997C412.198 250.532 420.613 249.081 437.467 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.557L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.557L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.169L386.027 211.226L420.714 205.169L434.5 218Z"
                fill="url(#pattern3)"
              />
              <path
                d="M263.794 409.44L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M577.634 346.47H633.795V374.551L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.551C633.795 374.551 628 393.578 605.714 393.5C583.429 393.423 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern4)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M542.156 361.989L552.593 314.5L579.105 343.5L579.105 369.5L567.834 400L579.443 417.595L567.834 430.74L579.105 448.598L564.513 464.616L572.553 476.8L546.396 491.633L563.513 476.8L551.593 466.517L565.969 449.395L549.921 432.468L561 416L548.25 398.419L552.593 383.5L542.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M670.546 361.989L660.109 314.5L633.597 343.5L633.597 374L641.5 398.419L633.258 417.595L644.867 430.74L633.597 448.598L648.189 464.616L640.149 476.8L666.306 491.633L648.189 476.8L660.109 466.517L645.732 449.395L661.78 432.468L651.5 413.5L663.5 396L655.181 379.048L670.546 361.989Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.992 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.598 278.941C579.855 275.434 571.444 273.963 554.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.168 279.267C631.854 275.501 640.242 273.899 657.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 397L549.5 416.5L539.489 431.5L543.5 447.5L532.5 459L536.5 447L530.5 427.5L539.489 415L532.5 394L538.5 381L528.5 390.5L534 408L521.5 419.5L525.5 431.5L505 440L514.5 431.5L507.5 420.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L685 419.5L680 432.5L685 445L668 434.5L674 422.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.731 589.455 342.731L590.721 343.364L602.118 340.831L605.917 342.098L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.867 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.307L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.307L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M588.821 342.023L590.591 343.447L601.566 340.598L605.814 342.023L610.062 340.598L621.112 343.997L623.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.729C602.621 351.684 605.731 353.022 609.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_707_33759)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_707_33759"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_707_33759"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_707_33759"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_707_33759"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_707_33759"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_707_33759"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourInactiveMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_49934)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_49934)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_49934)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_49934)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_49934)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_49934" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_49934)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_49934)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#E8AE45"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M479.74 301.309C476.5 302 473 306 473 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C521 302.5 524 305.5 524 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 359.899 499.027 361C543.537 362.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 359.899 499.577 361C544.087 362.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.709 256.725C471.913 253.477 463.48 252.135 446.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.473 257.305C525.173 253.594 533.565 252.02 550.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_49934)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_49934"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_49934"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_49934"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_49934"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_49934"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_49934"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_49934"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourInactiveFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_47421)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_47421)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_47421)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_47421)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_47421)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_47421" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_47421)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_47421)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M430.156 361.989L440.593 314.5L467.105 343.5L467.105 369.5L457.5 398.419L460.5 411L445.5 426.5L450 409L441 397.5L448 385.5L430.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M556.732 361.989L546.295 314.5L519.783 343.5L519.783 369.5L529.388 398.419L526.388 411L541.388 426.5L536.888 409L545.888 397.5L538.888 385.5L556.732 361.989Z"
                fill="#543422"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.581 282.131C467.871 278.473 459.473 276.925 442.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.166 282.249C519.856 278.497 528.245 276.902 545.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 398L437.5 416.5L418.5 427.5L426.5 414L420 397L426.5 381L413.5 394L418.5 409L402.5 419.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L570.5 426.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.735 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.843 434 244.509L431 204.509C437.333 198.843 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.023L498.063 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_47421)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_47421"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_47421"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_47421"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_47421"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_47421"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_47421"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_47421"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourInactiveAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_43294)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_43294)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_43294)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_43294)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_43294)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_43294" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_830_43294)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#E8AE45"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.066H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.066Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.852 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M366.74 301.309C363.5 302 360 306 360 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C408 302.5 411 305.5 411 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.468L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.468C329.866 313.637 340.327 359.899 386.027 361C430.537 362.073 441.453 315.105 441.086 295.468ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.84L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.468L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.468C329.866 313.637 340.878 359.899 386.577 361C431.087 362.073 441.453 315.105 441.086 295.468ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.84L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.825L324.5 216.558L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.558L443.839 255.274L431.621 225.359L434.555 218.025L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.492L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.075"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.334 324.5 222L321.5 182C327.833 176.334 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.709 256.725C358.913 253.477 350.48 252.136 333.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.473 257.305C412.173 253.595 420.565 252.021 437.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.754H640.051L716.332 391.292L743.363 503.389L609.569 525.065L468.616 503.389L495.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M542.156 361.988L552.593 314.5L579.105 343.5L579.105 369.5L569.5 398.419L572.5 411L557.5 426.5L562 409L553 397.5L560 385.5L542.156 361.988Z"
                fill="#543422"
              />
              <path
                d="M668.732 361.988L658.295 314.5L631.783 343.5L631.783 369.5L641.388 398.419L638.388 411L653.388 426.5L648.888 409L657.888 397.5L650.888 385.5L668.732 361.988Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.581 282.131C579.871 278.472 571.473 276.925 554.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.166 282.249C631.856 278.497 640.245 276.902 657.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 398L549.5 416.5L530.5 427.5L538.5 414L532 397L538.5 381L525.5 394L530.5 409L514.5 419.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L682.5 426.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_43294)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_43294"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_43294"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_43294"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_43294"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_43294"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_43294"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourUnemployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_54955)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_54955)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_54955)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_54955)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_54955)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_54955" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_54955)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.149 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.149 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.149 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.149 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_54955)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#FF6600"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M479.74 301.309C476.5 302 473 306 473 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C521 302.5 524 305.5 524 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 359.899 499.027 361C543.537 362.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 359.899 499.577 361C544.087 362.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.501 253.857C473.633 256.674 463.613 252.022 446.719 254.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.493 254.182C519.368 257.609 533.483 251.963 550.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_54955)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_54955"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_54955"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_54955"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_54955"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_54955"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_54955"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_54955"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourUnemployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_52447)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_52447)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_52447)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_52447)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_52447)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_52447" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_52447)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_52447)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M430.156 361.989L440.593 314.5L467.105 343.5L467.105 369.5L457.5 398.419L460.5 411L445.5 426.5L450 409L441 397.5L448 385.5L430.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M556.732 361.989L546.295 314.5L519.783 343.5L519.783 369.5L529.388 398.419L526.388 411L541.388 426.5L536.888 409L545.888 397.5L538.888 385.5L556.732 361.989Z"
                fill="#543422"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.555 281C467.706 283.712 459.438 277.988 442.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.258 280.438C518.806 283.105 528.286 277.997 545.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 398L437.5 416.5L418.5 427.5L426.5 414L420 397L426.5 381L413.5 394L418.5 409L402.5 419.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L570.5 426.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.843 434 244.509L431 204.509C437.333 198.843 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.023L498.063 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.728C490.621 351.684 493.731 353.022 497.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_52447)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_52447"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_52447"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_52447"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_52447"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_52447"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_52447"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_52447"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourUnemployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_833_50193)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_833_50193)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_833_50193)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_833_50193)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_833_50193)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_833_50193" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_833_50193)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#FF6600"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.066H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.066Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.852 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M366.74 301.309C363.5 302 360 306 360 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C408 302.5 411 305.5 411 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.327 359.899 386.027 361C430.537 362.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.878 359.899 386.577 361C431.087 362.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.558L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.558L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.501 253.857C360.633 256.674 350.613 252.023 333.719 254.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.493 254.182C406.368 257.609 420.483 251.963 437.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M542.156 361.989L552.593 314.5L579.105 343.5L579.105 369.5L569.5 398.419L572.5 411L557.5 426.5L562 409L553 397.5L560 385.5L542.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M668.732 361.989L658.295 314.5L631.783 343.5L631.783 369.5L641.388 398.419L638.388 411L653.388 426.5L648.888 409L657.888 397.5L650.888 385.5L668.732 361.989Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.555 280.999C579.706 283.711 571.438 277.987 554.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.258 280.438C630.806 283.105 640.286 277.997 657.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 398L549.5 416.5L530.5 427.5L538.5 414L532 397L538.5 381L525.5 394L530.5 409L514.5 419.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L682.5 426.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_833_50193)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_833_50193"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_833_50193"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_833_50193"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_833_50193"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_833_50193"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_833_50193"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourEmployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_45146)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_45146)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_45146)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_45146)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_45146)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_45146" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_45146)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_45146)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.681L337.702 478.265L361.485 382.638Z"
                fill="#3A7CC5"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M479.74 301.309C476.5 302 473 306 473 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C521 302.5 524 305.5 524 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M523.804 325.75L505.634 321.345L499.027 322.997L492.42 321.345L475.351 324.649L472.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.803 325.75L527.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M488.708 253.74C471.915 250.48 463.483 249.132 446.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.446 253.997C525.198 250.532 533.613 249.081 550.467 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 359.899 499.027 361C543.537 362.073 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 359.899 499.577 361C544.087 362.073 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_45146)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_45146"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_45146"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_45146"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_45146"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_45146"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_45146"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_45146"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourEmployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_48502)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_48502)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_48502)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_48502)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_48502)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_48502" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_830_48502)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_830_48502)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M445 453.5L467 370.5L433.5 375.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M542 453.5L520 370.5L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M465.634 346.47H521.795V374.551L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.551C521.795 374.551 516 393.578 493.714 393.5C471.429 393.423 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M430.156 361.989L440.593 314.5L467.105 343.5L467.105 369.5L457.5 398.419L460.5 411L445.5 426.5L450 409L441 397.5L448 385.5L430.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M556.732 361.989L546.295 314.5L519.783 343.5L519.783 369.5L529.388 398.419L526.388 411L541.388 426.5L536.888 409L545.888 397.5L538.888 385.5L556.732 361.989Z"
                fill="#543422"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 289.5L499.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.598 278.941C467.855 275.434 459.444 273.963 442.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.168 279.267C519.854 275.501 528.242 273.899 545.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L448.5 343.5L438.5 362.5L444.5 383L433 398L437.5 416.5L418.5 427.5L426.5 414L420 397L426.5 381L413.5 394L418.5 409L402.5 419.5L408 408L399 390.5L411 376L402.5 360.5L411 345L399 321L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L577 310L565.5 339.5L575 364.5L562 383L569.5 394L563.5 410L570.5 426.5L552.5 415.5V398L540.5 383L549 362.5L539.5 345L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.735 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M476.821 342.023L478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997L511.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.554V511.852"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_830_48502)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_48502"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_48502"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_48502"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_48502"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_48502"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_830_48502"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_830_48502"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          TwentyfiveToThirtyfourEmployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_40704)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_40704)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_40704)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_40704)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_40704)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_40704" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_830_40704)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.224C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.224L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.058C318.359 268.376 320.131 263.736 320.842 261.372C318.477 262.083 313.838 263.854 310.156 267.536C306.474 271.217 304.703 275.857 303.992 278.222C306.357 277.51 310.996 275.739 314.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.323 309.982 242.296 311.294 243.489C311.782 243.933 311.584 244.674 310.939 244.814C309.206 245.192 306.014 245.627 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.995 300.856 238.56 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.323 351.612 242.296 350.3 243.489C349.812 243.933 350.01 244.674 350.655 244.814C352.388 245.192 355.581 245.627 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.995 360.739 238.56 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.058C344.872 268.376 343.101 263.736 342.389 261.372C344.754 262.083 349.394 263.854 353.075 267.536C356.757 271.217 358.528 275.857 359.24 278.222C356.875 277.51 352.235 275.739 348.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.224C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.224L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.058C640.359 268.376 642.131 263.736 642.842 261.372C640.477 262.083 635.838 263.854 632.156 267.536C628.474 271.217 626.703 275.857 625.992 278.222C628.357 277.51 632.996 275.739 636.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.323 631.982 242.296 633.294 243.489C633.782 243.933 633.584 244.674 632.939 244.814C631.206 245.192 628.014 245.627 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.995 622.856 238.56 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.323 673.612 242.296 672.3 243.489C671.812 243.933 672.01 244.674 672.655 244.814C674.388 245.192 677.581 245.627 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.995 682.739 238.56 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.058C666.872 268.376 665.101 263.736 664.389 261.372C666.754 262.083 671.394 263.854 675.075 267.536C678.757 271.217 680.528 275.857 681.24 278.222C678.875 277.51 674.235 275.739 670.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.204 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.204 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.143 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.917 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.104C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.899 323.489 309.41C322.295 308.099 320.322 305.551 319.441 302.262C318.56 298.972 318.995 295.779 319.372 294.047C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.899 339.248 309.41C340.441 308.099 342.414 305.551 343.296 302.262C344.177 298.972 343.742 295.779 343.365 294.047C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.104C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.143 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.917 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.204 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.204 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.143 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.917 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.104C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.899 645.489 309.41C644.295 308.099 642.322 305.551 641.441 302.262C640.56 298.972 640.995 295.779 641.372 294.047C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.899 661.248 309.41C662.441 308.099 664.414 305.551 665.296 302.262C666.177 298.972 665.742 295.779 665.365 294.047C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.104C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.143 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.917 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.204 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.204 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.143 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.917 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.104C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.899 323.489 384.41C322.295 383.099 320.322 380.551 319.441 377.262C318.56 373.972 318.995 370.779 319.372 369.047C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.899 339.248 384.41C340.441 383.099 342.414 380.551 343.296 377.262C344.177 373.972 343.742 370.779 343.365 369.047C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.104C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.143 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.917 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.204 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.204 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.143 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.917 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.104C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.899 645.489 384.41C644.295 383.099 642.322 380.551 641.441 377.262C640.56 373.972 640.995 370.779 641.372 369.047C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.899 661.248 384.41C662.441 383.099 664.414 380.551 665.296 377.262C666.177 373.972 665.742 370.779 665.365 369.047C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.104C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.143 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.917 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#3A7CC5"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.065H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.851 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M366.74 301.308C363.5 302 360 306 360 306"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.308C408 302.5 411 305.5 411 305.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M410.804 325.75L392.634 321.345L386.027 322.997L379.42 321.345L362.351 324.649L359.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.803 325.75L414.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M375.708 253.74C358.915 250.48 350.483 249.132 333.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.446 253.997C412.198 250.532 420.613 249.081 437.467 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.94L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.327 359.899 386.027 361C430.537 362.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.065L382.723 332.357L390.982 332.908L392.634 340.065L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.94L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.878 359.899 386.577 361C431.087 362.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.065L382.723 332.357L390.982 332.908L392.634 340.065L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.557L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.557L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.169L386.027 211.226L420.714 205.169L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.44L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M557 453.5L579 370.5L545.5 375.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M654 453.5L632 370.5L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M577.634 346.47H633.795V374.551L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.551C633.795 374.551 628 393.578 605.714 393.5C583.429 393.423 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M542.156 361.989L552.593 314.5L579.105 343.5L579.105 369.5L569.5 398.419L572.5 411L557.5 426.5L562 409L553 397.5L560 385.5L542.156 361.989Z"
                fill="#543422"
              />
              <path
                d="M668.732 361.989L658.295 314.5L631.783 343.5L631.783 369.5L641.388 398.419L638.388 411L653.388 426.5L648.888 409L657.888 397.5L650.888 385.5L668.732 361.989Z"
                fill="#543422"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.992 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M612.5 289.5L611.5 296.5V317.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.598 278.941C579.855 275.434 571.444 273.963 554.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.168 279.267C631.854 275.501 640.242 273.899 657.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L560.5 343.5L550.5 362.5L556.5 383L545 398L549.5 416.5L530.5 427.5L538.5 414L532 397L538.5 381L525.5 394L530.5 409L514.5 419.5L520 408L511 390.5L523 376L514.5 360.5L523 345L511 321L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L689 310L677.5 339.5L687 364.5L674 383L681.5 394L675.5 410L682.5 426.5L664.5 415.5V398L652.5 383L661 362.5L651.5 345L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.731 589.455 342.731L590.721 343.364L602.118 340.831L605.917 342.098L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.867 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.307L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.307L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M588.821 342.023L590.591 343.447L601.566 340.598L605.814 342.023L610.062 340.598L621.112 343.997L623.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.729C602.621 351.684 605.731 353.022 609.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_40704)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.352622) scale(0.00166667 0.00284207)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_40704"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_40704"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_40704"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_40704"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_40704"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_40704"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourInactiveMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_50182)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_50182)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_50182)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_50182)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_50182)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_50182" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_50182)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_50182)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#E8AE45"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M491.921 233.5L506.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 263.475C488.869 261.94 485.703 258.688 482 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 263.475C508.12 261.94 511.287 258.688 514.989 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 364.899 499.027 366C543.537 367.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 364.399 499.577 365.5C544.087 366.572 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.709 256.725C471.913 253.477 463.48 252.135 446.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.473 257.305C525.173 253.594 533.565 252.02 550.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_50182)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_50182"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_50182"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_50182"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_50182"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_50182"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_50182"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_50182"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourInactiveFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_47669)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_47669)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_47669)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_47669)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_47669)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_47669" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_47669)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_47669)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M445 453.5L466.5 370.5H458.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#F8BF56"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501.167 287.834 503 284.5 506.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.581 282.131C467.871 278.473 459.473 276.925 442.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.166 282.249C519.856 278.497 528.245 276.902 545.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L447.5 343.5L434.5 362.5L438 377.5L418.5 394L421 377.5L409.5 360.5L417.5 343.5L402.5 318L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L572.5 314L553.5 334L554.5 350L539.5 330.5L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.735 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.843 434 244.509L431 204.509C437.333 198.843 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.023L498.063 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_47669)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_47669"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_47669"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_47669"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_47669"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_47669"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_47669"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_47669"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourInactiveAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_45043)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_45043)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_45043)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_45043)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_45043)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_45043" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_830_45043)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#E8AE45"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.066H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.066Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.852 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M378.921 233.5L393.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 263.475C375.869 261.94 372.703 258.688 369 257.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 263.475C395.12 261.94 398.287 258.688 401.989 257.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.468L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.468C329.866 313.637 340.327 364.899 386.027 366C430.537 367.073 441.453 315.105 441.086 295.468ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.84L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.468L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.468C329.866 313.637 340.878 364.399 386.577 365.5C431.087 366.573 441.453 315.105 441.086 295.468ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.84L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.825L324.5 216.558L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.558L443.839 255.274L431.621 225.359L434.555 218.025L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.492L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.075"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.334 324.5 222L321.5 182C327.833 176.334 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.709 256.725C358.913 253.477 350.48 252.136 333.668 255.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.473 257.305C412.173 253.595 420.565 252.021 437.464 254.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.754H640.051L716.332 391.292L743.363 503.389L609.569 525.065L468.616 503.389L495.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M557 453.5L578.5 370.5H570.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#F8BF56"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598 291C597.5 289.166 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613.167 287.833 615 284.5 618.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.581 282.131C579.871 278.472 571.473 276.925 554.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.166 282.249C631.856 278.497 640.245 276.902 657.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L559.5 343.5L546.5 362.5L550 377.5L530.5 394L533 377.5L521.5 360.5L529.5 343.5L514.5 318L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L684.5 314L665.5 334L666.5 350L651.5 330.5L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_45043)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_45043"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_45043"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_45043"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_45043"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_45043"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_45043"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourUnemployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_55203)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_55203)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_55203)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_55203)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_55203)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_55203" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_55203)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.149 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.149 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.149 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.149 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_55203)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#FF6600"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M491.921 233.5L506.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 263.475C488.869 261.94 485.703 258.688 482 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 263.475C508.12 261.94 511.287 258.688 514.989 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M475.351 324.649L492.42 321.345L499.027 322.997L505.634 321.345L523.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 364.899 499.027 366C543.537 367.072 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 364.399 499.577 365.5C544.087 366.572 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.501 253.857C473.633 256.674 463.613 252.022 446.719 254.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.493 254.182C519.368 257.609 533.483 251.963 550.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_55203)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_55203"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_55203"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_55203"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_55203"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_55203"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_55203"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_55203"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourUnemployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_52695)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_52695)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_52695)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_52695)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_52695)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_52695" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_52695)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_52695)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M445 453.5L466.5 370.5H458.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#FEB444"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.55C521.795 374.55 516 393.578 493.714 393.5C471.429 393.422 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501.167 287.834 503 284.5 506.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.555 281C467.706 283.712 459.438 277.988 442.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.258 280.438C518.806 283.105 528.286 277.997 545.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L447.5 343.5L434.5 362.5L438 377.5L418.5 394L421 377.5L409.5 360.5L417.5 343.5L402.5 318L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L572.5 314L553.5 334L554.5 350L539.5 330.5L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.843 434 244.509L431 204.509C437.333 198.843 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 343.447L489.566 340.598L493.815 342.023L498.063 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.728C490.621 351.684 493.731 353.022 497.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_52695)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_52695"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_52695"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_52695"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_52695"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_52695"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_52695"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_52695"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourUnemployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_833_50441)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_833_50441)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_833_50441)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_833_50441)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_833_50441)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_833_50441" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_833_50441)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#FF6600"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.066H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.066Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.852 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M378.921 233.5L393.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 263.475C375.869 261.94 372.703 258.688 369 257.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 263.475C395.12 261.94 398.287 258.688 401.989 257.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.199L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M362.351 324.649L379.42 321.345L386.027 322.997L392.634 321.345L410.803 325.75"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.327 364.899 386.027 366C430.537 367.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.941L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.878 364.399 386.577 365.5C431.087 366.573 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.066L382.723 332.357L390.982 332.908L392.634 340.066L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.558L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.558L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.17L386.027 211.226L420.714 205.17L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.501 253.857C360.633 256.674 350.613 252.023 333.719 254.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.493 254.182C406.368 257.609 420.483 251.963 437.422 254.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M557 453.5L578.5 370.5H570.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#FEB444"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.55C633.795 374.55 628 393.578 605.714 393.5C583.429 393.422 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.257 605.777 215.257C638.59 215.257 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598 291C597.5 289.166 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613.167 287.833 615 284.5 618.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.555 280.999C579.706 283.711 571.438 277.987 554.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.258 280.438C630.806 283.105 640.286 277.997 657.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L559.5 343.5L546.5 362.5L550 377.5L530.5 394L533 377.5L521.5 360.5L529.5 343.5L514.5 318L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L684.5 314L665.5 334L666.5 350L651.5 330.5L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 343.447L601.566 340.598L605.815 342.022L610.063 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_833_50441)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_833_50441"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_833_50441"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_833_50441"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_833_50441"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_833_50441"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_833_50441"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourEmployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_45397)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_45397)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_45397)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_45397)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_45397)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_45397" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_45397)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_45397)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.681L337.702 478.265L361.485 382.638Z"
                fill="#3A7CC5"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 340.065H537.018V353.724C537.018 353.724 519.949 370.899 500.128 370.899C480.306 370.899 463.238 353.724 463.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="440.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 440.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M436.809 285.006C430.202 279.72 434.423 273.994 437.36 271.792C437.543 270.14 436.809 266.176 432.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="557.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 557.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M556.6 271.234C556.6 292.097 549.952 318.718 544.965 325.469C539.979 332.22 530.461 361.298 499 361C467.539 360.702 455.764 331.095 451.331 325.469C446.899 319.843 440.25 292.097 440.25 271.234C440.25 226.532 434.395 183.542 499.099 183.697C563.803 183.851 556.6 226.532 556.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M491.921 233.5L506.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 263.475C488.869 261.94 485.703 258.688 482 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 263.475C508.12 261.94 511.287 258.688 514.989 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M475 279.5C478.798 279.363 483 277 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M520 279C517 279 513 277 511 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 285.006C567.326 279.72 563.105 273.994 560.168 271.792C559.985 270.14 560.719 266.176 565.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 314.738C485.262 316.059 477.921 322.263 475.351 325.199L492.42 321.345L499.027 322.997L506.184 321.345L523.803 325.75C514.994 318.262 506.919 315.289 503.982 314.738C501.339 316.059 496.274 315.289 494.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M523.804 325.75L505.634 321.345L499.027 322.997L492.42 321.345L475.351 324.649L472.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.803 325.75L527.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M488.708 253.74C471.915 250.48 463.483 249.132 446.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.446 253.997C525.198 250.532 533.613 249.081 550.467 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.327 364.899 499.027 366C543.537 367.073 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M554.086 295.467L534.815 316.94L505.634 306.479L498.476 309.232L491.318 306.479L465.44 315.289L442.315 295.467C442.866 313.637 453.878 364.399 499.577 365.5C544.087 366.573 554.453 315.105 554.086 295.467ZM467.526 321.867L472.598 337.863L494.071 340.065L495.723 332.357L503.982 332.908L505.634 340.065L524.905 338.414L531.81 323.453L505.634 313.637L499.027 315.839L492.42 313.637L467.643 321.896L467.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 225.359L440.113 255.824L437.5 216.557L441 205.5L446 198L453.67 189.5L467.5 180.5L488.5 175.5L510 174.5L530.5 182.5L547.555 195L555 205.5L557.39 216.557L556.839 255.274L544.621 225.359L547.555 218.024L532.885 212.89H516L499 220.5L481 212.89H462.471L450.736 219.491L453.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 331.256C494.782 332.087 499.741 333.25 505.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 314.738C495.554 315.569 499.611 316.732 503.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.5 298L483.059 302.625L499.177 305.929L514.994 302.625L514 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 266.286)"
                fill="#573420"
              />
              <path
                d="M486.999 267C478.999 261.5 463.5 255 449.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 267C519.173 261.5 534.673 255 548.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 218L533 212.878H516L499.027 220.5L481 212.878H462.5L450.574 219.485L461.036 205.17L499.027 211.226L533.714 205.17L547.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 269.433L491.006 281.119L492.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 269.435L506.495 281.109L505.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 221C501 205.5 457.333 217.333 437.5 222L434.5 182C440.833 176.333 465.8 164.9 497 164.5C528.2 164.1 552.333 177 560 183.5L557.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M438 222C454.5 215.667 501.4 206.6 557 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_45397)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_45397"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_45397"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_45397"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_45397"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_45397"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_45397"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_45397"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourEmployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_42364)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_42364)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_42364)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_42364)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_42364)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_42364" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_42364)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_42364)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M465.634 346.47H521.795V374.551L535.5 413.5L493.714 428.5L451 413.5L465.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M445 453.5L466.5 370.5H458.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#89B7E9"
              />
              <path
                opacity="0.5"
                d="M465.634 346.47H521.795V374.551C521.795 374.551 516 393.578 493.714 393.5C471.429 393.423 465.634 373 465.634 373V346.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M550.5 299C544.311 349.895 516.5 370.5 494.5 370.5C472.5 370.5 443.134 347.395 435.5 294.5C435.5 253.991 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 325L478.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M506 325L509.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 304.5C475.833 304 480 302.2 482 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 304.5C512.167 304 508 302.2 506 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501.167 287.834 503 284.5 506.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.598 278.941C467.855 275.434 459.444 273.963 442.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.168 279.267C519.854 275.501 528.242 273.899 545.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L440.5 316L447.5 343.5L434.5 362.5L438 377.5L418.5 394L421 377.5L409.5 360.5L417.5 343.5L402.5 318L416.5 294.5L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L554.5 244L562.5 277.5L572.5 314L553.5 334L554.5 350L539.5 330.5L546.5 316L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.164" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.164)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.735 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.098L498.349 340.831L510.379 343.997C506.369 346.53 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M476.821 342.023L478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997L511.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.294 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.554V511.852"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_42364)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_42364"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_42364"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_42364"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_42364"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_42364"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_42364"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_42364"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          ThirtyfiveToFourtyfourEmployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_40995)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_40995)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_40995)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_40995)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_40995)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_40995" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_830_40995)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.224C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.224L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.058C318.359 268.376 320.131 263.736 320.842 261.372C318.477 262.083 313.838 263.854 310.156 267.536C306.474 271.217 304.703 275.857 303.992 278.222C306.357 277.51 310.996 275.739 314.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.323 309.982 242.296 311.294 243.489C311.782 243.933 311.584 244.674 310.939 244.814C309.206 245.192 306.014 245.627 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.995 300.856 238.56 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.323 351.612 242.296 350.3 243.489C349.812 243.933 350.01 244.674 350.655 244.814C352.388 245.192 355.581 245.627 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.995 360.739 238.56 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.058C344.872 268.376 343.101 263.736 342.389 261.372C344.754 262.083 349.394 263.854 353.075 267.536C356.757 271.217 358.528 275.857 359.24 278.222C356.875 277.51 352.235 275.739 348.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.224C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.224L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.058C640.359 268.376 642.131 263.736 642.842 261.372C640.477 262.083 635.838 263.854 632.156 267.536C628.474 271.217 626.703 275.857 625.992 278.222C628.357 277.51 632.996 275.739 636.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.323 631.982 242.296 633.294 243.489C633.782 243.933 633.584 244.674 632.939 244.814C631.206 245.192 628.014 245.627 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.995 622.856 238.56 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.323 673.612 242.296 672.3 243.489C671.812 243.933 672.01 244.674 672.655 244.814C674.388 245.192 677.581 245.627 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.995 682.739 238.56 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.058C666.872 268.376 665.101 263.736 664.389 261.372C666.754 262.083 671.394 263.854 675.075 267.536C678.757 271.217 680.528 275.857 681.24 278.222C678.875 277.51 674.235 275.739 670.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.204 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.204 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.143 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.917 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.104C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.899 323.489 309.41C322.295 308.099 320.322 305.551 319.441 302.262C318.56 298.972 318.995 295.779 319.372 294.047C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.899 339.248 309.41C340.441 308.099 342.414 305.551 343.296 302.262C344.177 298.972 343.742 295.779 343.365 294.047C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.104C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.143 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.917 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.204 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.204 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.143 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.917 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.104C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.899 645.489 309.41C644.295 308.099 642.322 305.551 641.441 302.262C640.56 298.972 640.995 295.779 641.372 294.047C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.899 661.248 309.41C662.441 308.099 664.414 305.551 665.296 302.262C666.177 298.972 665.742 295.779 665.365 294.047C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.104C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.143 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.917 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.204 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.204 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.143 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.917 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.104C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.899 323.489 384.41C322.295 383.099 320.322 380.551 319.441 377.262C318.56 373.972 318.995 370.779 319.372 369.047C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.899 339.248 384.41C340.441 383.099 342.414 380.551 343.296 377.262C344.177 373.972 343.742 370.779 343.365 369.047C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.104C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.143 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.917 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.204 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.204 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.143 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.917 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.104C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.899 645.489 384.41C644.295 383.099 642.322 380.551 641.441 377.262C640.56 373.972 640.995 370.779 641.372 369.047C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.899 661.248 384.41C662.441 383.099 664.414 380.551 665.296 377.262C666.177 373.972 665.742 370.779 665.365 369.047C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.104C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.143 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.917 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#3A7CC5"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 340.065H424.018V353.724C424.018 353.724 406.949 370.899 387.128 370.899C367.306 370.899 350.238 353.724 350.238 353.724V340.065Z"
                fill="url(#pattern1)"
              />
              <ellipse
                cx="327.441"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(-9.49929 327.441 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M323.809 285.006C317.202 279.72 321.423 273.994 324.36 271.792C324.543 270.14 323.809 266.176 319.404 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <ellipse
                cx="444.669"
                cy="274.502"
                rx="16.87"
                ry="21.2708"
                transform="rotate(7.64502 444.669 274.502)"
                fill="#E7A17C"
              />
              <path
                d="M443.6 271.234C443.6 292.097 436.952 318.718 431.965 325.469C426.979 332.22 417.461 361.298 386 361C354.539 360.702 342.764 331.095 338.331 325.469C333.899 319.843 327.25 292.097 327.25 271.234C327.25 226.532 321.395 183.542 386.099 183.697C450.803 183.851 443.6 226.532 443.6 271.234Z"
                fill="#EFB799"
              />
              <path
                d="M378.921 233.5L393.079 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 263.475C375.869 261.94 372.703 258.688 369 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 263.475C395.12 261.94 398.287 258.688 401.989 257.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M362 279.5C365.798 279.363 370 277 372.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M407 279C404 279 400 277 398 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 285.006C454.326 279.72 450.105 273.994 447.168 271.792C446.985 270.14 447.719 266.176 452.124 263.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 314.738C372.262 316.06 364.921 322.263 362.351 325.2L379.42 321.345L386.027 322.997L393.184 321.345L410.803 325.75C401.994 318.262 393.919 315.289 390.982 314.738C388.339 316.06 383.274 315.289 381.071 314.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M410.804 325.75L392.634 321.345L386.027 322.997L379.42 321.345L362.351 324.649L359.598 322.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.803 325.75L414.107 324.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M375.708 253.74C358.915 250.48 350.483 249.132 333.668 252.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.446 253.997C412.198 250.532 420.613 249.081 437.467 252.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.94L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.327 364.899 386.027 366C430.537 367.073 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.065L382.723 332.357L390.982 332.908L392.634 340.065L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="#663F2B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M441.086 295.467L421.815 316.94L392.634 306.479L385.476 309.232L378.318 306.479L352.44 315.289L329.315 295.467C329.866 313.637 340.878 364.399 386.577 365.5C431.087 366.573 441.453 315.105 441.086 295.467ZM354.526 321.867L359.598 337.863L381.071 340.065L382.723 332.357L390.982 332.908L392.634 340.065L411.905 338.414L418.81 323.453L392.634 313.637L386.027 315.839L379.42 313.637L354.643 321.896L354.526 321.867Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 225.359L327.113 255.824L324.5 216.557L328 205.5L333 198L340.67 189.5L354.5 180.5L375.5 175.5L397 174.5L417.5 182.5L434.555 195L442 205.5L444.39 216.557L443.839 255.274L431.621 225.359L434.555 218.024L419.885 212.89H403L386 220.5L368 212.89H349.471L337.736 219.491L340.67 225.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 331.256C381.782 332.087 386.741 333.25 392.083 331.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 314.738C382.554 315.569 386.611 316.733 390.982 314.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.5 298L370.059 302.625L386.177 305.929L401.994 302.625L401 298"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="266.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 266.286)"
                fill="#573420"
              />
              <path
                d="M373.999 267C365.999 261.5 350.5 255 336.499 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 267C406.173 261.5 421.673 255 435.673 270.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 218L420 212.878H403L386.027 220.5L368 212.878H349.5L337.574 219.485L348.036 205.169L386.027 211.226L420.714 205.169L434.5 218Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.44L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 269.433L378.006 281.119L379.101 292.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 269.435L393.495 281.109L392.488 292.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 221C388 205.5 344.333 217.333 324.5 222L321.5 182C327.833 176.333 352.8 164.9 384 164.5C415.2 164.1 439.333 177 447 183.5L444.5 221Z"
                fill="#F56E6E"
              />
              <path
                d="M325 222C341.5 215.667 388.4 206.6 444 221"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M577.634 346.47H633.795V374.551L647.5 413.5L605.714 428.5L563 413.5L577.634 373V346.47Z"
                fill="#E7A17C"
              />
              <path
                d="M557 453.5L578.5 370.5H570.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#89B7E9"
              />
              <path
                opacity="0.5"
                d="M577.634 346.47H633.795V374.551C633.795 374.551 628 393.578 605.714 393.5C583.429 393.423 577.634 373 577.634 373V346.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M662.5 299C656.311 349.895 628.5 370.5 606.5 370.5C584.5 370.5 555.134 347.395 547.5 294.5C547.5 253.992 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598 291C597.5 289.167 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M594 325L590.5 329.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M618 325L621.5 330"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 304.5C587.833 304 592 302.2 594 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 304.5C624.167 304 620 302.2 618 299"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613.167 287.833 615 284.5 618.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.598 278.941C579.855 275.434 571.444 273.963 554.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.168 279.267C631.854 275.501 640.242 273.899 657.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L552.5 316L559.5 343.5L546.5 362.5L550 377.5L530.5 394L533 377.5L521.5 360.5L529.5 343.5L514.5 318L528.5 294.5L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L666.5 244L674.5 277.5L684.5 314L665.5 334L666.5 350L651.5 330.5L658.5 316L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.731 589.455 342.731L590.721 343.364L602.118 340.831L605.917 342.098L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.867 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.307L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.307L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M588.821 342.023L590.591 343.447L601.566 340.598L605.814 342.023L610.062 340.598L621.112 343.997L623.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.729C602.621 351.684 605.731 353.022 609.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_40995)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.297868) scale(0.00166667 0.00265956)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_40995"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_40995"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_40995"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_40995"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_40995"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_40995"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourInactiveMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_50690)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_50690)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_50690)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_50690)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_50690)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_50690" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_50690)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_50690)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#E8AE45"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 344.065H537.018V357.724C537.018 357.724 519.949 374.899 500.128 374.899C480.306 374.899 463.238 357.724 463.238 357.724V344.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 270.718C459.018 282.304 453.14 299.962 443.951 301.5C434.762 303.038 425.5 295 423.802 276.286C421.863 264.7 427.741 254.061 436.93 252.523C446.119 250.985 455.14 259.131 457.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 284.006C430.202 278.72 434.423 272.994 437.36 270.792C437.543 269.14 436.809 265.176 432.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 275.747C572.5 295.5 564.073 302.739 554.839 301.5C545.605 300.261 539.386 282.901 540.949 271.258C542.511 259.615 551.264 251.181 560.498 252.421C569.733 253.66 575.608 263 574.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 270.234C556.6 291.097 552.5 327 547.5 336C542.5 345 530.461 360.298 499 360C467.539 359.702 456.668 345.5 451 336C445.331 326.5 440.25 291.097 440.25 270.234C440.25 225.532 434.395 182.542 499.099 182.697C563.803 182.851 556.6 225.532 556.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M482 233.5L499.257 237.915L516 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 262.475C488.869 260.94 485.703 257.688 482 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 262.475C508.12 260.94 511.287 257.688 514.989 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 280.71C470.798 280.572 479.733 278.968 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 280.71C526.289 280.572 517.354 278.968 512 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.718 284.006C567.325 278.72 563.104 272.994 560.168 270.792C559.984 269.14 560.718 265.176 565.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M494.071 313.738C495.554 314.569 499.611 315.733 503.982 313.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 324.75L505.633 320.345L499.026 321.997L492.419 320.345L475.351 323.649L472.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.804 324.75L527.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M531.145 320.789L555.5 295.5C555.867 315.138 555 366.5 499.027 366C444.344 364.03 442.557 315.339 442 296.5C441.991 296.21 442.008 295.776 442 295.5L466.151 320.631L473 309.5L485 303L499.5 305.979L514 303L525.5 309.5L531.145 320.789ZM470 329.5L475.5 326.5L492 325L499 322.5L506 325L524 326.5L527.5 329L524.905 338.414L505.634 340.066L503.5 331.5H495.5L494.072 340.066L472.598 337.863L470 329.5Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M555.5 295.5L531 320.5L525.5 309.5L513 302.5L499.5 305L487 302L473 309.5L466 320.5L442 295.5C442.551 313.67 444 364.663 499.5 366C551.5 367.253 555.867 315.138 555.5 295.5ZM470 329.5L472.598 337.863L494.071 340.065L495.5 332L503.5 331.5L505.634 340.065L524.905 338.414L527.5 329L524 326.5L506 325L499 322.5L492 325L475.5 326.5L470 329.5Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 224.359L440.113 254.824L437.5 215.557L441 204.5L446 197L453.67 188.5L467.5 179.5L488.5 174.5L510 173.5L530.5 181.5L547.555 194L555 204.5L557.39 215.557L556.839 254.274L544.621 224.359L547.555 217.024L532.885 211.89H516L499 219.5L481 211.89H462.471L450.736 218.491L453.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 330.256C494.782 331.087 499.741 332.25 505.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 297L483 301.667L499.15 305L515 301.667L514.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 265.286)"
                fill="#573420"
              />
              <path
                d="M486.999 266C478.999 260.5 463.5 254 449.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 266C519.173 260.5 534.673 254 548.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 217L533 211.878H516L499.027 219.5L481 211.878H462.5L450.574 218.485L461.036 204.169L499.027 210.226L533.714 204.169L547.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 268.433L491.006 280.119L492.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 268.435L506.495 280.109L505.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 220C501 204.5 457.333 216.333 437.5 221L434.5 181C440.833 175.333 465.8 163.9 497 163.5C528.2 163.1 552.333 176 560 182.5L557.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M438 221C454.5 214.667 501.4 205.6 557 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.709 255.725C471.913 252.477 463.48 251.135 446.668 254.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.473 256.305C525.173 252.594 533.565 251.02 550.464 253.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_50690)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_50690"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_50690"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_50690"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_50690"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_50690"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_50690"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_50690"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourInactiveFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_48177)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_48177)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_48177)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_48177)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_48177)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_48177" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_48177)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_48177)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M437 308.044L464.104 336.543L468 359L461 368L456 357L446.5 352.5L445 341.999L438 333.499L437 321.999L437 308.044Z"
                fill="#543422"
              />
              <path
                d="M551.893 308.044L524.788 336.543L520.893 359L527.893 368L532.893 357L542.393 352.5L543.892 341.999L550.893 333.499L551.893 321.999L551.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 341.47H521.795V369.551C521.795 369.551 516 388.578 493.714 388.5C471.429 388.423 465.634 368 465.634 368V341.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M550.5 299C544.311 349.895 528 370.5 494.5 370.5C461 370.5 443.134 347.395 435.5 294.5C435.5 253.992 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486.921 261.5L501.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 327L471.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 327L517 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501 288.167 503.3 285 508.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.581 282.131C467.871 278.473 459.473 276.925 442.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.166 282.249C519.856 278.497 528.245 276.902 545.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L439.5 302.5L441 318L434.5 327L436.5 336.5L429 346L430.5 354.5L422 362.5L424.5 353.25L420.5 346L425 336.5L418 326L422 316.5L414 301L424 283L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L557.5 250L562.5 277.5L570.5 296L562.5 320.5L566.5 331L559 348L562.5 362.5L548.5 348L550.5 333.5L544.5 320.5L546.5 305L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.163)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.097L498.349 340.831L510.379 343.997C506.369 346.529 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.293 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 305.5C475.833 305 480 303.2 482 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 305.5C512.167 305 508 303.2 506 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_48177)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_48177"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_48177"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_48177"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_48177"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_48177"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_48177"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_48177"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourInactiveAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_45333)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_45333)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_45333)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_45333)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_45333)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_45333" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_830_45333)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#E8AE45"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 344.066H424.018V357.724C424.018 357.724 406.949 374.899 387.128 374.899C367.306 374.899 350.238 357.724 350.238 357.724V344.066Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 270.718C346.018 282.305 340.14 299.963 330.951 301.5C321.762 303.038 312.5 295 310.802 276.286C308.863 264.7 314.741 254.061 323.93 252.523C333.119 250.986 342.14 259.132 344.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.809 284.006C317.202 278.72 321.423 272.994 324.36 270.792C324.543 269.14 323.809 265.176 319.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 275.747C459.5 295.5 451.073 302.74 441.839 301.5C432.605 300.261 426.386 282.901 427.949 271.258C429.511 259.615 438.264 251.181 447.498 252.421C456.733 253.66 462.608 263 461.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 270.234C443.6 291.097 439.5 327 434.5 336C429.5 345 417.461 360.298 386 360C354.539 359.702 343.668 345.5 338 336C332.331 326.5 327.25 291.097 327.25 270.234C327.25 225.532 321.395 182.542 386.099 182.697C450.803 182.852 443.6 225.532 443.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M369 233.5L386.257 237.915L403 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 262.475C375.869 260.94 372.703 257.688 369 256.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 262.475C395.12 260.94 398.287 257.688 401.989 256.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 280.71C357.798 280.573 366.733 278.968 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 280.71C413.289 280.573 404.354 278.968 399 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.718 284.006C454.325 278.72 450.104 272.994 447.168 270.792C446.984 269.14 447.718 265.176 452.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 313.739C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.346L386.027 321.997L393.184 320.346L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.739C388.339 315.06 383.274 314.289 381.071 313.739Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 313.739C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.346L386.027 321.997L393.184 320.346L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.739C388.339 315.06 383.274 314.289 381.071 313.739Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M381.071 313.739C382.554 314.57 386.611 315.733 390.982 313.739"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.803 324.75L392.633 320.345L386.026 321.997L379.419 320.345L362.351 323.649L359.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 324.75L414.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M418.145 320.789L442.5 295.5C442.867 315.138 442 366.5 386.027 366C331.344 364.031 329.557 315.339 329 296.5C328.991 296.21 329.008 295.777 329 295.5L353.151 320.631L360 309.5L372 303L386.5 305.979L401 303L412.5 309.5L418.145 320.789ZM357 329.5L362.5 326.5L379 325L386 322.5L393 325L411 326.5L414.5 329L411.905 338.414L392.634 340.066L390.5 331.5H382.5L381.072 340.066L359.598 337.864L357 329.5Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M442.5 295.5L418 320.5L412.5 309.5L400 302.5L386.5 305L374 302L360 309.5L353 320.5L329 295.5C329.551 313.67 331 364.663 386.5 366C438.5 367.253 442.867 315.138 442.5 295.5ZM357 329.5L359.598 337.863L381.071 340.066L382.5 332L390.5 331.5L392.634 340.066L411.905 338.414L414.5 329L411 326.5L393 325L386 322.5L379 325L362.5 326.5L357 329.5Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 224.359L327.113 254.825L324.5 215.558L328 204.5L333 197L340.67 188.5L354.5 179.5L375.5 174.5L397 173.5L417.5 181.5L434.555 194L442 204.5L444.39 215.558L443.839 254.274L431.621 224.359L434.555 217.025L419.885 211.89H403L386 219.5L368 211.89H349.471L337.736 218.492L340.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 330.256C381.782 331.087 386.741 332.25 392.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 297L370 301.667L386.15 305L402 301.667L401.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 265.286)"
                fill="#573420"
              />
              <path
                d="M373.999 266C365.999 260.5 350.5 254 336.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 266C406.173 260.5 421.673 254 435.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 217L420 211.878H403L386.027 219.5L368 211.878H349.5L337.574 218.485L348.036 204.17L386.027 210.226L420.714 204.17L434.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.075"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 268.433L378.006 280.119L379.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 268.435L393.495 280.109L392.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 220C388 204.5 344.333 216.333 324.5 221L321.5 181C327.833 175.333 352.8 163.9 384 163.5C415.2 163.1 439.333 176 447 182.5L444.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M325 221C341.5 214.667 388.4 205.6 444 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.709 255.725C358.913 252.477 350.48 251.136 333.668 254.518"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.473 256.305C412.173 252.595 420.565 251.021 437.464 253.937"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.754H640.051L716.332 391.292L743.363 503.389L609.569 525.065L468.616 503.389L495.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M549 308.044L576.104 336.543L580 359L573 368L568 357L558.5 352.5L557 341.999L550 333.499L549 321.999L549 308.044Z"
                fill="#543422"
              />
              <path
                d="M663.893 308.044L636.788 336.543L632.893 359L639.893 368L644.893 357L654.393 352.5L655.892 341.999L662.893 333.499L663.893 321.999L663.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 341.47H633.795V369.55C633.795 369.55 628 388.578 605.714 388.5C583.429 388.422 577.634 368 577.634 368V341.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M662.5 299C656.311 349.895 640 370.5 606.5 370.5C573 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598.921 261.5L613.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 327L583.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 327L629 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613 288.166 615.3 285 620.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.581 282.131C579.871 278.472 571.473 276.925 554.583 279.894"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.166 282.249C631.856 278.497 640.245 276.902 657.151 279.776"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L551.5 302.5L553 318L546.5 327L548.5 336.5L541 346L542.5 354.5L534 362.5L536.5 353.25L532.5 346L537 336.5L530 326L534 316.5L526 301L536 283L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L669.5 250L674.5 277.5L682.5 296L674.5 320.5L678.5 331L671 348L674.5 362.5L660.5 348L662.5 333.5L656.5 320.5L658.5 305L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.73 589.455 342.73L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.951 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.591 343.447L601.566 340.598L605.814 342.022L610.062 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.955 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 291C597.5 289.166 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 305.5C587.833 305 592 303.2 594 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 305.5C624.167 305 620 303.2 618 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_45333)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_45333"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_45333"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_45333"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_45333"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_45333"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_45333"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourUnemployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_55711)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_55711)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_55711)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_55711)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_55711)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_55711" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_55711)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.149 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.149 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.149 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.149 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_55711)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#FF6600"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 344.065H537.018V357.724C537.018 357.724 519.949 374.899 500.128 374.899C480.306 374.899 463.238 357.724 463.238 357.724V344.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 270.718C459.018 282.304 453.14 299.962 443.951 301.5C434.762 303.038 425.5 295 423.802 276.286C421.863 264.7 427.741 254.061 436.93 252.523C446.119 250.985 455.14 259.131 457.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 284.006C430.202 278.72 434.423 272.994 437.36 270.792C437.543 269.14 436.809 265.176 432.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 275.747C572.5 295.5 564.073 302.739 554.839 301.5C545.605 300.261 539.386 282.901 540.949 271.258C542.511 259.615 551.264 251.181 560.498 252.421C569.733 253.66 575.608 263 574.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 270.234C556.6 291.097 552.5 327 547.5 336C542.5 345 530.461 360.298 499 360C467.539 359.702 456.668 345.5 451 336C445.331 326.5 440.25 291.097 440.25 270.234C440.25 225.532 434.395 182.542 499.099 182.697C563.803 182.851 556.6 225.532 556.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M482 233.5L499.257 237.915L516 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 262.475C488.869 260.94 485.703 257.688 482 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 262.475C508.12 260.94 511.287 257.688 514.989 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 280.71C470.798 280.572 479.733 278.968 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 280.71C526.289 280.572 517.354 278.968 512 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.718 284.006C567.325 278.72 563.104 272.994 560.168 270.792C559.984 269.14 560.718 265.176 565.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M494.071 313.738C495.554 314.569 499.611 315.733 503.982 313.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 324.75L505.633 320.345L499.026 321.997L492.419 320.345L475.351 323.649L472.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.804 324.75L527.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M531.145 320.789L555.5 295.5C555.867 315.138 555 366.5 499.027 366C444.344 364.03 442.557 315.339 442 296.5C441.991 296.21 442.008 295.776 442 295.5L466.151 320.631L473 309.5L485 303L499.5 305.979L514 303L525.5 309.5L531.145 320.789ZM470 329.5L475.5 326.5L492 325L499 322.5L506 325L524 326.5L527.5 329L524.905 338.414L505.634 340.066L503.5 331.5H495.5L494.072 340.066L472.598 337.863L470 329.5Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M555.5 295.5L531 320.5L525.5 309.5L513 302.5L499.5 305L487 302L473 309.5L466 320.5L442 295.5C442.551 313.67 444 364.663 499.5 366C551.5 367.253 555.867 315.138 555.5 295.5ZM470 329.5L472.598 337.863L494.071 340.065L495.5 332L503.5 331.5L505.634 340.065L524.905 338.414L527.5 329L524 326.5L506 325L499 322.5L492 325L475.5 326.5L470 329.5Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 224.359L440.113 254.824L437.5 215.557L441 204.5L446 197L453.67 188.5L467.5 179.5L488.5 174.5L510 173.5L530.5 181.5L547.555 194L555 204.5L557.39 215.557L556.839 254.274L544.621 224.359L547.555 217.024L532.885 211.89H516L499 219.5L481 211.89H462.471L450.736 218.491L453.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 330.256C494.782 331.087 499.741 332.25 505.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 297L483 301.667L499.15 305L515 301.667L514.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 265.286)"
                fill="#573420"
              />
              <path
                d="M486.999 266C478.999 260.5 463.5 254 449.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 266C519.173 260.5 534.673 254 548.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 217L533 211.878H516L499.027 219.5L481 211.878H462.5L450.574 218.485L461.036 204.169L499.027 210.226L533.714 204.169L547.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 268.433L491.006 280.119L492.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 268.435L506.495 280.109L505.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 220C501 204.5 457.333 216.333 437.5 221L434.5 181C440.833 175.333 465.8 163.9 497 163.5C528.2 163.1 552.333 176 560 182.5L557.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M438 221C454.5 214.667 501.4 205.6 557 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.501 252.857C473.633 255.674 463.613 251.022 446.719 253.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.493 253.182C519.368 256.609 533.483 250.963 550.422 253.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_55711)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_55711"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_55711"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_55711"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_55711"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_55711"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_55711"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_55711"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourUnemployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_53203)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_53203)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_53203)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_53203)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_53203)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_53203" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_53203)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_53203)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M437 308.044L464.104 336.543L468 359L461 368L456 357L446.5 352.5L445 341.999L438 333.499L437 321.999L437 308.044Z"
                fill="#543422"
              />
              <path
                d="M551.893 308.044L524.788 336.543L520.893 359L527.893 368L532.893 357L542.393 352.5L543.892 341.999L550.893 333.499L551.893 321.999L551.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 341.47H521.795V369.551C521.795 369.551 516 388.578 493.714 388.5C471.429 388.423 465.634 368 465.634 368V341.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M550.5 299C544.311 349.895 528 370.5 494.5 370.5C461 370.5 443.134 347.395 435.5 294.5C435.5 253.992 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486.921 261.5L501.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 327L471.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 327L517 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501 288.167 503.3 285 508.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.555 281C467.706 283.712 459.438 277.988 442.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.258 280.438C518.806 283.105 528.286 277.997 545.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L439.5 302.5L441 318L434.5 327L436.5 336.5L429 346L430.5 354.5L422 362.5L424.5 353.25L420.5 346L425 336.5L418 326L422 316.5L414 301L424 283L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L557.5 250L562.5 277.5L570.5 296L562.5 320.5L566.5 331L559 348L562.5 362.5L548.5 348L550.5 333.5L544.5 320.5L546.5 305L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.163)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.097L498.349 340.831L510.379 343.997C506.369 346.529 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.293 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 305.5C475.833 305 480 303.2 482 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 305.5C512.167 305 508 303.2 506 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_53203)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_53203"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_53203"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_53203"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_53203"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_53203"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_53203"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_53203"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourUnemployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_833_50949)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_833_50949)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_833_50949)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_833_50949)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_833_50949)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_833_50949" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_833_50949)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.161L331.449 279.389L326.469 258.161C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.161L653.449 279.389L648.469 258.161C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#FF6600"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 344.066H424.018V357.724C424.018 357.724 406.949 374.899 387.128 374.899C367.306 374.899 350.238 357.724 350.238 357.724V344.066Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 270.718C346.018 282.305 340.14 299.962 330.951 301.5C321.762 303.038 312.5 295 310.802 276.286C308.863 264.7 314.741 254.061 323.93 252.523C333.119 250.985 342.14 259.132 344.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.809 284.006C317.202 278.72 321.423 272.994 324.36 270.792C324.543 269.14 323.809 265.176 319.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 275.747C459.5 295.5 451.073 302.74 441.839 301.5C432.605 300.261 426.386 282.901 427.949 271.258C429.511 259.615 438.264 251.181 447.498 252.421C456.733 253.66 462.608 263 461.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 270.234C443.6 291.097 439.5 327 434.5 336C429.5 345 417.461 360.298 386 360C354.539 359.702 343.668 345.5 338 336C332.331 326.5 327.25 291.097 327.25 270.234C327.25 225.532 321.395 182.542 386.099 182.697C450.803 182.851 443.6 225.532 443.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M369 233.5L386.257 237.915L403 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 262.475C375.869 260.94 372.703 257.688 369 256.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 262.475C395.12 260.94 398.287 257.688 401.989 256.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 280.71C357.798 280.573 366.733 278.968 372.087 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 280.71C413.289 280.573 404.354 278.968 399 273.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.718 284.006C454.325 278.72 450.104 272.994 447.168 270.792C446.984 269.14 447.718 265.176 452.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 313.738C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.346L386.027 321.997L393.184 320.346L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.738C388.339 315.06 383.274 314.289 381.071 313.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 313.738C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.346L386.027 321.997L393.184 320.346L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.738C388.339 315.06 383.274 314.289 381.071 313.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M381.071 313.738C382.554 314.569 386.611 315.733 390.982 313.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.803 324.75L392.633 320.345L386.026 321.997L379.419 320.345L362.351 323.649L359.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 324.75L414.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M418.145 320.789L442.5 295.5C442.867 315.138 442 366.5 386.027 366C331.344 364.031 329.557 315.339 329 296.5C328.991 296.21 329.008 295.776 329 295.5L353.151 320.631L360 309.5L372 303L386.5 305.979L401 303L412.5 309.5L418.145 320.789ZM357 329.5L362.5 326.5L379 325L386 322.5L393 325L411 326.5L414.5 329L411.905 338.414L392.634 340.066L390.5 331.5H382.5L381.072 340.066L359.598 337.863L357 329.5Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M442.5 295.5L418 320.5L412.5 309.5L400 302.5L386.5 305L374 302L360 309.5L353 320.5L329 295.5C329.551 313.67 331 364.663 386.5 366C438.5 367.253 442.867 315.138 442.5 295.5ZM357 329.5L359.598 337.863L381.071 340.066L382.5 332L390.5 331.5L392.634 340.066L411.905 338.414L414.5 329L411 326.5L393 325L386 322.5L379 325L362.5 326.5L357 329.5Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 224.359L327.113 254.825L324.5 215.558L328 204.5L333 197L340.67 188.5L354.5 179.5L375.5 174.5L397 173.5L417.5 181.5L434.555 194L442 204.5L444.39 215.558L443.839 254.274L431.621 224.359L434.555 217.025L419.885 211.89H403L386 219.5L368 211.89H349.471L337.736 218.492L340.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 330.256C381.782 331.087 386.741 332.25 392.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 297L370 301.667L386.15 305L402 301.667L401.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 265.286)"
                fill="#573420"
              />
              <path
                d="M373.999 266C365.999 260.5 350.5 254 336.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 266C406.173 260.5 421.673 254 435.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 217L420 211.878H403L386.027 219.5L368 211.878H349.5L337.574 218.485L348.036 204.17L386.027 210.226L420.714 204.17L434.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.441L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 268.433L378.006 280.119L379.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 268.435L393.495 280.109L392.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 220C388 204.5 344.333 216.333 324.5 221L321.5 181C327.833 175.333 352.8 163.9 384 163.5C415.2 163.1 439.333 176 447 182.5L444.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M325 221C341.5 214.667 388.4 205.6 444 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.501 252.857C360.633 255.674 350.613 251.023 333.719 253.967"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.493 253.182C406.368 256.609 420.483 250.963 437.422 253.642"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M549 308.044L576.104 336.543L580 359L573 368L568 357L558.5 352.5L557 341.999L550 333.499L549 321.999L549 308.044Z"
                fill="#543422"
              />
              <path
                d="M663.893 308.044L636.788 336.543L632.893 359L639.893 368L644.893 357L654.393 352.5L655.892 341.999L662.893 333.499L663.893 321.999L663.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 341.47H633.795V369.55C633.795 369.55 628 388.578 605.714 388.5C583.429 388.422 577.634 368 577.634 368V341.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M662.5 299C656.311 349.895 640 370.5 606.5 370.5C573 370.5 555.134 347.395 547.5 294.5C547.5 253.991 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598.921 261.5L613.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 327L583.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 327L629 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613 288.166 615.3 285 620.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.555 280.999C579.706 283.711 571.438 277.987 554.596 281.217"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.258 280.438C630.806 283.105 640.286 277.997 657.119 281.278"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L551.5 302.5L553 318L546.5 327L548.5 336.5L541 346L542.5 354.5L534 362.5L536.5 353.25L532.5 346L537 336.5L530 326L534 316.5L526 301L536 283L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L669.5 250L674.5 277.5L682.5 296L674.5 320.5L678.5 331L671 348L674.5 362.5L660.5 348L662.5 333.5L656.5 320.5L658.5 305L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.731 589.455 342.731L590.721 343.364L602.118 340.831L605.917 342.097L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.866 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.306L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.306L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.951 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.591 343.447L601.566 340.598L605.814 342.023L610.062 340.598L621.112 343.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.728C602.621 351.684 605.731 353.022 609.082 350.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.955 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 291C597.5 289.166 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 305.5C587.833 305 592 303.2 594 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 305.5C624.167 305 620 303.2 618 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_833_50949)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_833_50949"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_833_50949"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_833_50949"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_833_50949"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_833_50949"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_833_50949"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourEmployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_45906)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_45906)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_45906)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_45906)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_45906)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_45906" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_45906)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_45906)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.681L337.702 478.265L361.485 382.638Z"
                fill="#3A7CC5"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L486.999 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 344.065H537.018V357.724C537.018 357.724 519.949 374.899 500.128 374.899C480.306 374.899 463.238 357.724 463.238 357.724V344.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 270.718C459.018 282.304 453.14 299.962 443.951 301.5C434.762 303.038 425.5 295 423.802 276.286C421.863 264.7 427.741 254.061 436.93 252.523C446.119 250.985 455.14 259.131 457.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 284.006C430.202 278.72 434.423 272.994 437.36 270.792C437.543 269.14 436.809 265.176 432.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 275.747C572.5 295.5 564.073 302.739 554.839 301.5C545.605 300.261 539.386 282.901 540.949 271.258C542.511 259.615 551.264 251.181 560.498 252.421C569.733 253.66 575.608 263 574.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 270.234C556.6 291.097 552.5 327 547.5 336C542.5 345 530.461 360.298 499 360C467.539 359.702 456.668 345.5 451 336C445.331 326.5 440.25 291.097 440.25 270.234C440.25 225.532 434.395 182.542 499.099 182.697C563.803 182.851 556.6 225.532 556.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M482 233.5L499.257 237.915L516 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M489.989 262.475C488.869 260.94 485.703 257.688 482 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 262.475C508.12 260.94 511.287 257.688 514.989 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 280.71C470.798 280.572 479.733 278.968 485.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 280.71C526.289 280.572 517.354 278.968 512 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.74 301.309C470.5 306.5 468.184 311.926 468.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M517.999 301.309C527.5 306.5 529.555 311.926 529.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.718 284.006C567.325 278.72 563.104 272.994 560.168 270.792C559.984 269.14 560.718 265.176 565.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 313.738C485.262 315.06 477.921 321.263 475.351 324.2L492.42 320.345L499.027 321.997L506.184 320.345L523.803 324.75C514.994 317.262 506.919 314.289 503.982 313.738C501.339 315.06 496.274 314.289 494.071 313.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M488.708 252.74C471.915 249.48 463.483 248.132 446.668 251.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.446 252.997C525.198 249.532 533.613 248.081 550.467 251.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M494.071 313.738C495.554 314.569 499.611 315.733 503.982 313.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 324.75L505.633 320.345L499.026 321.997L492.419 320.345L475.351 323.649L472.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.804 324.75L527.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M531.145 320.789L555.5 295.5C555.867 315.138 555 366.5 499.027 366C444.344 364.031 442.557 315.339 442 296.5C441.991 296.21 442.008 295.776 442 295.5L466.151 320.631L473 309.5L485 303L499.5 305.979L514 303L525.5 309.5L531.145 320.789ZM467.115 323.306L475.5 326.5L492 325L499 322.5L506 325L524 326.5L528.694 324.153L524.905 338.414L505.634 340.066L503.5 331.5H495.5L494.072 340.066L472.598 337.863L467.115 323.306Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M555.5 295.5L531 320.5L525.5 309.5L513 302.5L499.5 305L487 302L473 309.5L466 320.5L442 295.5C442.551 313.67 444 364.663 499.5 366C551.5 367.253 555.867 315.138 555.5 295.5ZM467 323L472.598 337.863L494.071 340.065L495.5 332L503.5 331.5L505.634 340.065L524.905 338.414L529 324L524 326.5L506 325L499 322.5L492 325L475.5 326.5L467 323Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 224.359L440.113 254.824L437.5 215.557L441 204.5L446 197L453.67 188.5L467.5 179.5L488.5 174.5L510 173.5L530.5 181.5L547.555 194L555 204.5L557.39 215.557L556.839 254.274L544.621 224.359L547.555 217.024L532.885 211.89H516L499 219.5L481 211.89H462.471L450.736 218.491L453.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M492.97 330.256C494.782 331.087 499.741 332.25 505.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 297L483 301.667L499.15 305L515 301.667L514.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 265.286)"
                fill="#573420"
              />
              <path
                d="M486.999 266C478.999 260.5 463.5 254 449.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.173 266C519.173 260.5 534.673 254 548.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M547.5 217L533 211.878H516L499.027 219.5L481 211.878H462.5L450.574 218.485L461.036 204.169L499.027 210.226L533.714 204.169L547.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 268.433L491.006 280.119L492.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 268.435L506.495 280.109L505.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 220C501 204.5 457.333 216.333 437.5 221L434.5 181C440.833 175.333 465.8 163.9 497 163.5C528.2 163.1 552.333 176 560 182.5L557.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M438 221C454.5 214.667 501.4 205.6 557 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_45906)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_45906"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_45906"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_45906"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_45906"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_45906"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_45906"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_45906"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourEmployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_42874)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_42874)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_42874)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_42874)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_42874)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_42874" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_42874)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.581 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.739 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.581 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.739 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_42874)"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M437 308.044L464.104 336.543L468 359L461 368L456 357L446.5 352.5L445 341.999L438 333.499L437 321.999L437 308.044Z"
                fill="#543422"
              />
              <path
                d="M551.893 308.044L524.788 336.543L520.893 359L527.893 368L532.893 357L542.393 352.5L543.892 341.999L550.893 333.499L551.893 321.999L551.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M465.634 346.47H521.795V374.551L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 341.47H521.795V369.551C521.795 369.551 516 388.578 493.714 388.5C471.429 388.423 465.634 368 465.634 368V341.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M550.5 299C544.311 349.895 528 370.5 494.5 370.5C461 370.5 443.134 347.395 435.5 294.5C435.5 253.992 460.965 215.258 493.777 215.258C526.59 215.258 547.311 257.895 550.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M486.921 261.5L501.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 327L471.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 327L517 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 317.5V296.5L500.5 289.5C501 288.167 503.3 285 508.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 305L488 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.598 278.941C467.855 275.434 459.444 273.963 442.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.168 279.267C519.854 275.501 528.242 273.899 545.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 224L512 241.5L456 265.5L439.5 302.5L441 318L434.5 327L436.5 336.5L429 346L430.5 354.5L422 362.5L424.5 353.25L420.5 346L425 336.5L418 326L422 316.5L414 301L424 283L430.5 250.5L451.5 222L489 210.5L515 212L524 222L539.5 226.5L557.5 250L562.5 277.5L570.5 296L562.5 320.5L566.5 331L559 348L562.5 362.5L548.5 348L550.5 333.5L544.5 320.5L546.5 305L534.5 260.5L515 241.5L518 224Z"
                fill="#623D28"
              />
              <circle cx="467.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 292.163)"
                fill="#835338"
              />
              <path
                d="M490.118 333.233C485.686 332.6 477.455 342.731 477.455 342.731L478.721 343.364L490.118 340.831L493.917 342.098L498.982 340.831L510.379 343.364C510.379 343.364 501.515 331.967 497.083 333.233C492.651 334.5 494.55 333.867 490.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M483 292.5C474.5 285.5 459.732 284.382 448.153 294.307L444.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 292.5C513.5 285.5 528.268 284.382 539.847 294.307L543.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 352.228C490.371 352.734 482.309 346.952 478.721 343.997L489.485 340.831L493.917 342.097L498.349 340.831L510.379 343.997C506.369 346.529 497.462 351.721 493.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M554 243.509C497.5 228.009 453.833 239.842 434 244.509L431 204.509C437.333 198.842 462.3 187.409 493.5 187.009C524.7 186.609 548.833 199.509 556.5 206.009L554 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 244.509C451 238.176 497.9 229.109 553.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M476.821 342.023L478.591 343.447L489.566 340.598L493.814 342.023L498.062 340.598L509.112 343.997L511.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.484 350.729C490.621 351.684 493.731 353.022 497.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 333C491.698 333.956 494.29 335.293 497.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 324.446L493.903 325.547L503.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.554V511.852"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 291C485.5 289.167 483.7 285 480.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 305.5C475.833 305 480 303.2 482 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 305.5C512.167 305 508 303.2 506 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_42874)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_42874"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_42874"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_42874"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_42874"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_42874"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_42874"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_42874"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FourtyfiveToFivtyfourEmployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_40399)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_40399)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_40399)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_40399)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_40399)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_40399" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_830_40399)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.587 245.405 337.099 245.932 337.762 246.107L357.966 251.449L337.762 256.791C337.099 256.966 336.587 257.493 336.43 258.16L331.449 279.389L326.469 258.16C326.312 257.493 325.8 256.966 325.137 256.791L304.933 251.449L325.137 246.107C325.8 245.932 326.312 245.405 326.469 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.224C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.224L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.058C318.359 268.376 320.131 263.736 320.842 261.372C318.477 262.083 313.838 263.854 310.156 267.536C306.474 271.217 304.703 275.857 303.992 278.222C306.357 277.51 310.996 275.739 314.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.323 309.982 242.296 311.294 243.489C311.782 243.933 311.584 244.674 310.939 244.814C309.206 245.192 306.014 245.627 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.995 300.856 238.56 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.581 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.739 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.323 351.612 242.296 350.3 243.489C349.812 243.933 350.01 244.674 350.655 244.814C352.388 245.192 355.581 245.627 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.995 360.739 238.56 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.058C344.872 268.376 343.101 263.736 342.389 261.372C344.754 262.083 349.394 263.854 353.075 267.536C356.757 271.217 358.528 275.857 359.24 278.222C356.875 277.51 352.235 275.739 348.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.587 245.405 659.099 245.932 659.762 246.107L679.966 251.449L659.762 256.791C659.099 256.966 658.587 257.493 658.43 258.16L653.449 279.389L648.469 258.16C648.312 257.493 647.8 256.966 647.137 256.791L626.933 251.449L647.137 246.107C647.8 245.932 648.312 245.405 648.469 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.224C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.224L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.058C640.359 268.376 642.131 263.736 642.842 261.372C640.477 262.083 635.838 263.854 632.156 267.536C628.474 271.217 626.703 275.857 625.992 278.222C628.357 277.51 632.996 275.739 636.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.323 631.982 242.296 633.294 243.489C633.782 243.933 633.584 244.674 632.939 244.814C631.206 245.192 628.014 245.627 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.995 622.856 238.56 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.581 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.739 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.323 673.612 242.296 672.3 243.489C671.812 243.933 672.01 244.674 672.655 244.814C674.388 245.192 677.581 245.627 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.995 682.739 238.56 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.058C666.872 268.376 665.101 263.736 664.389 261.372C666.754 262.083 671.394 263.854 675.075 267.536C678.757 271.217 680.528 275.857 681.24 278.222C678.875 277.51 674.235 275.739 670.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.587 319.811 337.099 320.338 337.762 320.513L357.966 325.855L337.762 331.197C337.099 331.372 336.587 331.899 336.43 332.567L331.449 353.795L326.469 332.567C326.312 331.899 325.8 331.372 325.137 331.197L304.933 325.855L325.137 320.513C325.8 320.338 326.312 319.811 326.469 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.204 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.204 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.143 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.917 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.104C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.899 323.489 309.41C322.295 308.099 320.322 305.551 319.441 302.262C318.56 298.972 318.995 295.779 319.372 294.047C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.899 339.248 309.41C340.441 308.099 342.414 305.551 343.296 302.262C344.177 298.972 343.742 295.779 343.365 294.047C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.581 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.739 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.581 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.104C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.739 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.143 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.917 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.587 319.811 659.099 320.338 659.762 320.513L679.966 325.855L659.762 331.197C659.099 331.372 658.587 331.899 658.43 332.567L653.449 353.795L648.469 332.567C648.312 331.899 647.8 331.372 647.137 331.197L626.933 325.855L647.137 320.513C647.8 320.338 648.312 319.811 648.469 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.204 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.204 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.143 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.917 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.104C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.899 645.489 309.41C644.295 308.099 642.322 305.551 641.441 302.262C640.56 298.972 640.995 295.779 641.372 294.047C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.899 661.248 309.41C662.441 308.099 664.414 305.551 665.296 302.262C666.177 298.972 665.742 295.779 665.365 294.047C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.581 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.739 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.581 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.104C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.739 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.143 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.917 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.587 394.811 337.099 395.338 337.762 395.513L357.966 400.855L337.762 406.197C337.099 406.372 336.587 406.899 336.43 407.567L331.449 428.795L326.469 407.567C326.312 406.899 325.8 406.372 325.137 406.197L304.933 400.855L325.137 395.513C325.8 395.338 326.312 394.811 326.469 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.204 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.204 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.143 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.917 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.104C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.899 323.489 384.41C322.295 383.099 320.322 380.551 319.441 377.262C318.56 373.972 318.995 370.779 319.372 369.047C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.899 339.248 384.41C340.441 383.099 342.414 380.551 343.296 377.262C344.177 373.972 343.742 370.779 343.365 369.047C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.581 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.739 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.581 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.104C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.739 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.143 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.917 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.587 394.811 659.099 395.338 659.762 395.513L679.966 400.855L659.762 406.197C659.099 406.372 658.587 406.899 658.43 407.567L653.449 428.795L648.469 407.567C648.312 406.899 647.8 406.372 647.137 406.197L626.933 400.855L647.137 395.513C647.8 395.338 648.312 394.811 648.469 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.204 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.204 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.143 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.917 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.104C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.899 645.489 384.41C644.295 383.099 642.322 380.551 641.441 377.262C640.56 373.972 640.995 370.779 641.372 369.047C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.899 661.248 384.41C662.441 383.099 664.414 380.551 665.296 377.262C666.177 373.972 665.742 370.779 665.365 369.047C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.581 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.739 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.581 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.104C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.739 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.143 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.917 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.843 382.639L535.788 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#3A7CC5"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L373.999 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 344.065H424.018V357.724C424.018 357.724 406.949 374.899 387.128 374.899C367.306 374.899 350.238 357.724 350.238 357.724V344.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 270.718C346.018 282.304 340.14 299.962 330.951 301.5C321.762 303.038 312.5 295 310.802 276.286C308.863 264.7 314.741 254.061 323.93 252.523C333.119 250.985 342.14 259.131 344.079 270.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.809 284.006C317.202 278.72 321.423 272.994 324.36 270.792C324.543 269.14 323.809 265.176 319.404 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 275.747C459.5 295.5 451.073 302.739 441.839 301.5C432.605 300.261 426.386 282.901 427.949 271.258C429.511 259.615 438.264 251.181 447.498 252.421C456.733 253.66 462.608 263 461.389 275.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 270.234C443.6 291.097 439.5 327 434.5 336C429.5 345 417.461 360.298 386 360C354.539 359.702 343.668 345.5 338 336C332.331 326.5 327.25 291.097 327.25 270.234C327.25 225.532 321.395 182.542 386.099 182.697C450.803 182.851 443.6 225.532 443.6 270.234Z"
                fill="#EFB799"
              />
              <path
                d="M369 233.5L386.257 237.915L403 233.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M376.989 262.475C375.869 260.94 372.703 257.688 369 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 262.475C395.12 260.94 398.287 257.688 401.989 256.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 280.71C357.798 280.572 366.733 278.968 372.087 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 280.71C413.289 280.572 404.354 278.968 399 273.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 301.309C357.5 306.5 355.184 311.926 355.184 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M404.999 301.309C414.5 306.5 416.555 311.926 416.555 311.926"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.718 284.006C454.325 278.72 450.104 272.994 447.168 270.792C446.984 269.14 447.718 265.176 452.123 262.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.071 313.738C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.345L386.027 321.997L393.184 320.345L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.738C388.339 315.06 383.274 314.289 381.071 313.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.071 313.738C372.262 315.06 364.921 321.263 362.351 324.2L379.42 320.345L386.027 321.997L393.184 320.345L410.803 324.75C401.994 317.262 393.919 314.289 390.982 313.738C388.339 315.06 383.274 314.289 381.071 313.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M375.708 252.74C358.915 249.48 350.483 248.132 333.668 251.502"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.446 252.997C412.198 249.532 420.613 248.081 437.467 251.245"
                stroke="black"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M381.071 313.738C382.554 314.569 386.611 315.733 390.982 313.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.803 324.75L392.633 320.345L386.026 321.997L379.419 320.345L362.351 323.649L359.598 321.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 324.75L414.107 323.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M418.145 320.789L442.5 295.5C442.867 315.138 442 366.5 386.027 366C331.344 364.03 329.557 315.339 329 296.5C328.991 296.209 329.008 295.776 329 295.5L353.151 320.631L360 309.5L372 303L386.5 305.979L401 303L412.5 309.5L418.145 320.789ZM354.115 323.306L362.5 326.5L379 325L386 322.5L393 325L411 326.5L415.694 324.153L411.905 338.414L392.634 340.065L390.5 331.5H382.5L381.072 340.065L359.598 337.863L354.115 323.306Z"
                fill="#663F2A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M442.5 295.5L418 320.5L412.5 309.5L400 302.5L386.5 305L374 302L360 309.5L353 320.5L329 295.5C329.551 313.67 331 364.663 386.5 366C438.5 367.253 442.867 315.138 442.5 295.5ZM354 323L359.598 337.863L381.071 340.065L382.5 332L390.5 331.5L392.634 340.065L411.905 338.414L416 324L411 326.5L393 325L386 322.5L379 325L362.5 326.5L354 323Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 224.359L327.113 254.824L324.5 215.557L328 204.5L333 197L340.67 188.5L354.5 179.5L375.5 174.5L397 173.5L417.5 181.5L434.555 194L442 204.5L444.39 215.557L443.839 254.274L431.621 224.359L434.555 217.024L419.885 211.89H403L386 219.5L368 211.89H349.471L337.736 218.491L340.67 224.359Z"
                fill="#533322"
              />
              <path
                d="M379.97 330.256C381.782 331.087 386.741 332.25 392.083 330.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 297L370 301.667L386.15 305L402 301.667L401.004 297"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="265.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 265.286)"
                fill="#573420"
              />
              <path
                d="M373.999 266C365.999 260.5 350.5 254 336.499 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.173 266C406.173 260.5 421.673 254 435.673 269.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M434.5 217L420 211.878H403L386.027 219.5L368 211.878H349.5L337.574 218.485L348.036 204.169L386.027 210.226L420.714 204.169L434.5 217Z"
                fill="url(#pattern4)"
              />
              <path
                d="M263.794 409.44L269.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 268.433L378.006 280.119L379.101 291.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 268.435L393.495 280.109L392.488 291.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 220C388 204.5 344.333 216.333 324.5 221L321.5 181C327.833 175.333 352.8 163.9 384 163.5C415.2 163.1 439.333 176 447 182.5L444.5 220Z"
                fill="#F56E6E"
              />
              <path
                d="M325 221C341.5 214.667 388.4 205.6 444 220"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M549 308.044L576.104 336.543L580 359L573 368L568 357L558.5 352.5L557 341.999L550 333.499L549 321.999L549 308.044Z"
                fill="#543422"
              />
              <path
                d="M663.893 308.044L636.788 336.543L632.893 359L639.893 368L644.893 357L654.393 352.5L655.892 341.999L662.893 333.499L663.893 321.999L663.893 308.044Z"
                fill="#543422"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M577.634 346.47H633.795V374.551L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 341.47H633.795V369.551C633.795 369.551 628 388.578 605.714 388.5C583.429 388.423 577.634 368 577.634 368V341.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M662.5 299C656.311 349.895 640 370.5 606.5 370.5C573 370.5 555.134 347.395 547.5 294.5C547.5 253.992 572.965 215.258 605.777 215.258C638.59 215.258 659.311 257.895 662.5 299Z"
                fill="#EFB799"
              />
              <path
                d="M598.921 261.5L613.079 261.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 327L583.5 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 327L629 340.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 317.5V296.5L612.5 289.5C613 288.167 615.3 285 620.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 305L600 318"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.598 278.941C579.855 275.434 571.444 273.963 554.581 277.085"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.168 279.267C631.854 275.501 640.242 273.899 657.151 276.758"
                stroke="black"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 224L624 241.5L568 265.5L551.5 302.5L553 318L546.5 327L548.5 336.5L541 346L542.5 354.5L534 362.5L536.5 353.25L532.5 346L537 336.5L530 326L534 316.5L526 301L536 283L542.5 250.5L563.5 222L601 210.5L627 212L636 222L651.5 226.5L669.5 250L674.5 277.5L682.5 296L674.5 320.5L678.5 331L671 348L674.5 362.5L660.5 348L662.5 333.5L656.5 320.5L658.5 305L646.5 260.5L627 241.5L630 224Z"
                fill="#623D28"
              />
              <circle cx="579.285" cy="292.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 292.163)"
                fill="#835338"
              />
              <path
                d="M602.118 333.233C597.686 332.6 589.455 342.731 589.455 342.731L590.721 343.364L602.118 340.831L605.917 342.098L610.982 340.831L622.379 343.364C622.379 343.364 613.515 331.967 609.083 333.233C604.651 334.5 606.55 333.867 602.118 333.233Z"
                fill="#E68054"
              />
              <path
                d="M595 292.5C586.5 285.5 571.732 284.382 560.153 294.307L556.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 292.5C625.5 285.5 640.268 284.382 651.847 294.307L655.5 293.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 352.228C602.371 352.734 594.309 346.952 590.721 343.997L601.485 340.831L605.917 342.097L610.349 340.831L622.379 343.997C618.369 346.529 609.462 351.721 605.917 352.228Z"
                fill="#E49278"
              />
              <path
                d="M666 243.509C609.5 228.009 565.833 239.842 546 244.509L543 204.509C549.333 198.842 574.3 187.409 605.5 187.009C636.7 186.609 660.833 199.509 668.5 206.009L666 243.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 244.509C563 238.176 609.9 229.109 665.5 243.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M588.821 342.023L590.591 343.447L601.566 340.598L605.814 342.023L610.062 340.598L621.112 343.997L623.011 342.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.484 350.729C602.621 351.684 605.731 353.022 609.082 350.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 333C603.698 333.956 606.29 335.293 609.082 333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 324.446L605.903 325.547L615.175 324.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 291C597.5 289.167 595.7 285 592.5 283"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 305.5C587.833 305 592 303.2 594 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 305.5C624.167 305 620 303.2 618 300"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_40399)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.304848) scale(0.00166667 0.00268283)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -2.66123) scale(0.00166667 0.0105374)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_40399"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_40399"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_40399"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_40399"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_40399"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_40399"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourInactiveMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_50434)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_50434)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_50434)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_50434)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_50434)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_50434" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_50434)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.161L331.449 279.389L326.468 258.161C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.161L653.449 279.389L648.468 258.161C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_50434)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#E8AE45"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L487 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 355.065H537.018V368.724C537.018 368.724 519.949 385.899 500.128 385.899C480.306 385.899 463.238 368.724 463.238 368.724V355.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 286.718C459.018 298.304 453.14 315.962 443.951 317.5C434.762 319.038 425.5 311 423.802 292.286C421.863 280.7 427.741 270.061 436.93 268.523C446.119 266.985 455.14 275.131 457.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 300.006C430.202 294.72 434.423 288.994 437.36 286.792C437.543 285.14 436.809 281.176 432.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 291.747C572.5 311.5 564.073 318.739 554.839 317.5C545.605 316.261 539.386 298.901 540.949 287.258C542.512 275.615 551.264 267.181 560.499 268.421C569.733 269.66 575.608 279 574.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 286.234C556.6 307.097 552.5 343 547.5 352C542.5 361 530.461 376.298 499 376C467.539 375.702 456.668 361.5 451 352C445.331 342.5 440.25 307.097 440.25 286.234C440.25 241.532 434.395 198.542 499.099 198.697C563.803 198.851 556.6 241.532 556.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M489.989 278.475C488.869 276.94 485.703 273.688 482 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 278.475C508.12 276.94 511.287 273.688 514.989 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 296.71C470.798 296.572 479.733 294.968 485.087 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 296.71C526.289 296.572 517.354 294.968 512 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.739 317.309L468.184 327.926L464 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 246.5L499.257 250.915L516 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M518 317.309L529.555 327.926L533.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 300.006C567.326 294.72 563.104 288.994 560.168 286.792C559.984 285.14 560.719 281.176 565.123 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M494.071 329.738C495.553 330.569 499.611 331.733 503.982 329.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 340.75L505.634 336.345L499.026 337.997L492.419 336.345L475.351 339.649L472.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.803 340.75L527.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M524 342L532 343L525.5 325L514 318.5L499.5 321.479L485 318.5L473 325L465 343L475.5 342L492 340.5L499 338L506 340.5L524 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M532 343L525.5 325L513.5 318L499.157 321.253L485 318.5L473 325L465 343L475.5 342L492 340.5L499.157 338L506 340.5L524.5 342L532 343Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 240.359L440.113 270.824L437.5 231.557L441 220.5L446 213L453.67 204.5L467.5 195.5L488.5 190.5L510 189.5L530.5 197.5L547.555 210L555 220.5L557.389 231.557L556.839 270.274L544.621 240.359L547.555 233.024L532.885 227.89H516L499 235.5L481 227.89H462.471L450.736 234.491L453.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.3"
                d="M547.5 233L533 227.878H516L499.027 235.5L481 227.878L447.5 229L454 240L440 271L436.5 221.5L499.027 226.226L557.5 219.5L557 270.5L544.5 240.5L547.5 233Z"
                fill="url(#pattern4)"
              />
              <path
                d="M492.97 346.256C494.782 347.087 499.741 348.25 505.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 313L483 317.667L499.15 321L515 317.667L514.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 281.286)"
                fill="#573420"
              />
              <path
                d="M487 282C479 276.5 463.5 270 449.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.174 282C519.174 276.5 534.674 270 548.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 284.433L491.005 296.119L492.1 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 284.435L506.495 296.109L505.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 236C501 220.5 457.333 232.333 437.5 237L434.5 197C440.833 191.333 465.8 179.9 497 179.5C528.2 179.1 552.333 192 560 198.5L557.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M438 237C454.5 230.667 501.4 221.6 557 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.709 271.725C471.914 268.477 463.481 267.135 446.669 270.518"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.473 272.305C525.173 268.594 533.565 267.02 550.464 269.937"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M557 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M439.5 267L438.5 240.5"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_50434)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.84) scale(0.00166667 0.00446667)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_50434"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_50434"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_50434"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_50434"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_50434"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_50434"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_50434"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourInactiveFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_47921)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_47921)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_47921)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_47921)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_47921)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_47921" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_837_47921)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.738C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.161L331.449 279.389L326.468 258.161C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.738L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.161L653.449 279.389L648.468 258.161C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.738L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.141C306.474 306.46 304.703 301.82 303.992 299.455C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.141C356.757 306.46 358.528 301.82 359.24 299.455C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.141C628.474 306.46 626.703 301.82 625.992 299.455C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.141C678.757 306.46 680.528 301.82 681.24 299.455C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_47921)"
              />
              <path
                d="M440.593 324.5L467.105 353.5L480 382L448 364L440.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M547.294 324.5L520.782 353.5L505 383.5L542.5 363L547.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 351.47H521.795V379.551C521.795 379.551 516 398.578 493.714 398.5C471.429 398.423 465.634 378 465.634 378V351.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M550.5 309C544.311 359.895 528 380.5 494.5 380.5C461 380.5 443.134 357.395 435.5 304.5C435.5 263.992 460.965 225.258 493.777 225.258C526.59 225.258 547.311 267.895 550.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M477 270.5L494.257 274.915L511 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 337L471.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 337L517 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 327.5V306.5L500.5 299.5C501 298.167 503.3 295 508.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 315L488 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 301C485.5 299.167 483.7 295 480.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.581 292.131C467.871 288.473 459.473 286.925 442.583 289.894"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.166 292.249C519.856 288.497 528.245 286.902 545.151 289.776"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 234L512 251.5L456 275.5L442.5 313L441 328L444.5 343L422 326.5L415 312L424 293L430.5 260.5L451.5 232L489 220.5L515 222L524 232L539.5 236.5L557.5 260L562.5 287.5L570.5 306L558 336L543 344.5L546.5 315L534.5 270.5L515 251.5L518 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M515 251.5L518.5 232.5L512 251.5L456 275.5L442.5 313L441 328C441 328 443.5 341.885 448.5 351.5C453.5 361.115 462 369.5 462 369.5L459.5 370.5L448 364L444 342.5L422 326.5L415 312L424 293L430.5 260.5L436.5 252.5L494.5 231L522 223L554 255.5L557.5 260L562.5 287L570.5 306L558 336L545 343.5L542.5 363L528.5 370.5H526.5C526.5 370.5 532.5 365 536.5 358.5C540.5 352 543 344.5 543 344.5L546.5 314.5L534.5 270.5L515 251.5Z"
                fill="url(#pattern2)"
              />
              <circle cx="467.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 302.163)"
                fill="#835338"
              />
              <path
                d="M490.118 343.233C485.686 342.6 477.455 352.731 477.455 352.731L478.721 353.364L490.118 350.831L493.917 352.098L498.982 350.831L510.379 353.364C510.379 353.364 501.515 341.967 497.082 343.233C492.65 344.5 494.55 343.867 490.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M483 302.5C474.5 295.5 459.732 294.382 448.153 304.307L444.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 302.5C513.5 295.5 528.268 294.382 539.847 304.307L543.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 362.228C490.371 362.734 482.309 356.952 478.721 353.997L489.485 350.831L493.917 352.097L498.349 350.831L510.379 353.997C506.369 356.529 497.462 361.721 493.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M554 253.509C497.5 238.009 453.833 249.842 434 254.509L431 214.509C437.333 208.842 462.3 197.409 493.5 197.009C524.7 196.609 548.833 209.509 556.5 216.009L554 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 254.509C451 248.176 497.9 239.109 553.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 353.447L489.566 350.598L493.814 352.023L498.063 350.598L509.112 353.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.485 360.729C490.621 361.684 493.732 363.022 497.082 360.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 343C491.698 343.956 494.29 345.293 497.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 334.446L493.903 335.547L503.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 315.5C475.833 315 480 313.2 482 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 315.5C512.167 315 508 313.2 506 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M433 257.5L430.5 260.5L424 293L415 312L422 326.5L443.5 343L448 364L457 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M555.5 257L558 260.5L563 287L571 306.5L558 336L545.5 343.5L542.5 363L531 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_47921)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_47921"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_47921"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_47921"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_47921"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_47921"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_47921"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFEFC" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_47921"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourInactiveAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_830_43872)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_830_43872)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_830_43872)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_830_43872)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_830_43872)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#F8D79A"
              />
              <path
                d="M289 213H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FFFEFC"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_830_43872" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FFFEFC"
                mask="url(#path-22-inside-1_830_43872)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FFFEFC"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="366" cy="201" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FFFEFC"
              />
              <circle cx="304" cy="193" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FFFEFC"
              />
              <circle cx="324" cy="136" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FFFEFC"
              />
              <circle cx="358" cy="87" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FFFEFC"
              />
              <circle cx="407" cy="50" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FFFEFC"
              />
              <circle cx="458" cy="27" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FFFEFC"
              />
              <circle cx="377" cy="161" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FFFEFC"
              />
              <circle cx="399" cy="127" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FFFEFC"
              />
              <circle cx="433" cy="101" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FFFEFC"
              />
              <circle cx="477" cy="82" r="4" fill="#FFFEFC" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FFFEFC"
              />
              <circle cx="493" cy="8" r="4" fill="#FFFEFC" />
              <circle cx="647" cy="172" r="8" fill="#FFFEFC" />
              <circle cx="361" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="625" cy="125" r="8" fill="#FFFEFC" />
              <circle cx="397" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="589" cy="89" r="8" fill="#FFFEFC" />
              <circle cx="443" cy="64" r="8" fill="#FFFEFC" />
              <circle cx="492" cy="46" r="8" fill="#FFFEFC" />
              <circle cx="543" cy="64" r="8" fill="#FFFEFC" />
              <path
                d="M331.449 223.509L336.43 244.737C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.16L331.449 279.389L326.468 258.16C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.737L331.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.16L653.449 279.389L648.468 258.16C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.737L653.449 223.509Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FFFEFC"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#FFFEFC"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FFFEFC"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FFFEFC"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FFFEFC"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.844 382.639L535.789 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#E8AE45"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#F8BF56"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L374 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 355.066H424.018V368.724C424.018 368.724 406.949 385.899 387.128 385.899C367.306 385.899 350.238 368.724 350.238 368.724V355.066Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 286.718C346.018 298.305 340.14 315.963 330.951 317.5C321.762 319.038 312.5 311 310.802 292.286C308.863 280.7 314.741 270.061 323.93 268.523C333.12 266.986 342.141 275.132 344.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.81 300.006C317.202 294.72 321.424 288.994 324.36 286.792C324.544 285.14 323.81 281.176 319.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 291.747C459.5 311.5 451.074 318.74 441.839 317.5C432.605 316.261 426.386 298.901 427.949 287.258C429.512 275.615 438.265 267.181 447.499 268.421C456.733 269.66 462.608 279 461.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 286.234C443.6 307.097 439.5 343 434.5 352C429.5 361 417.461 376.298 386 376C354.539 375.702 343.668 361.5 338 352C332.332 342.5 327.251 307.097 327.251 286.234C327.251 241.532 321.395 198.542 386.099 198.697C450.803 198.852 443.6 241.532 443.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M376.99 278.475C375.869 276.94 372.703 273.688 369 272.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 278.475C395.121 276.94 398.287 273.688 401.99 272.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 296.71C357.798 296.573 366.733 294.968 372.087 289.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 296.71C413.289 296.573 404.354 294.968 399 289.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 317.309L355.184 327.926L351 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M369 246.5L386.257 250.915L403 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M405 317.309L416.555 327.926L420.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 300.006C454.326 294.72 450.105 288.994 447.168 286.792C446.985 285.14 447.719 281.176 452.124 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.072 329.739C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.346L386.027 337.997L393.185 336.346L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.739C388.339 331.06 383.274 330.289 381.072 329.739Z"
                fill="#E7A17C"
              />
              <path
                d="M381.072 329.739C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.346L386.027 337.997L393.185 336.346L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.739C388.339 331.06 383.274 330.289 381.072 329.739Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M381.071 329.739C382.554 330.57 386.611 331.733 390.982 329.739"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.804 340.75L392.634 336.345L386.027 337.997L379.42 336.345L362.351 339.649L359.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 340.75L414.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M411 342L419 343L412.5 325L401 318.5L386.5 321.479L372 318.5L360 325L352 343L362.5 342L379 340.5L386 338L393 340.5L411 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M419 343L412.5 325L400.5 318L386.158 321.253L372 318.5L360 325L352 343L362.5 342L379 340.5L386.158 338L393 340.5L411.5 342L419 343Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 240.359L327.113 270.825L324.5 231.558L328 220.5L333 213L340.67 204.5L354.5 195.5L375.5 190.5L397 189.5L417.5 197.5L434.555 210L442 220.5L444.39 231.558L443.839 270.274L431.621 240.359L434.555 233.025L419.885 227.89H403L386 235.5L368 227.89H349.471L337.736 234.492L340.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.3"
                d="M434 233.501L419.5 228.378H402.5L385.527 236.001L367.5 228.378L334 229.5L340.5 240.5L326.5 271.5L323 222L385.527 226.727L444 220L443.5 271L431 241L434 233.501Z"
                fill="url(#pattern4)"
              />
              <path
                d="M379.97 346.256C381.782 347.087 386.741 348.25 392.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 313L370 317.667L386.15 321L402 317.667L401.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 281.286)"
                fill="#573420"
              />
              <path
                d="M374 282C366 276.5 350.5 270 336.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.174 282C406.174 276.5 421.674 270 435.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M263.795 409.441L269.301 419.902V487.075"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 284.433L378.006 296.119L379.101 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 284.435L393.495 296.109L392.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 236C388 220.5 344.333 232.333 324.5 237L321.5 197C327.833 191.333 352.8 179.9 384 179.5C415.2 179.1 439.333 192 447 198.5L444.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M325 237C341.5 230.667 388.4 221.6 444 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.709 271.725C358.914 268.477 350.481 267.136 333.669 270.518"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.473 272.305C412.173 268.595 420.566 267.021 437.465 269.937"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M444 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M552.593 324.5L579.105 353.5L592 382L560 364L552.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M659.294 324.5L632.782 353.5L617 383.5L654.5 363L659.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M495.045 391.292L576.238 370.754H640.051L716.332 391.292L743.363 503.389L609.569 525.065L468.616 503.389L495.045 391.292Z"
                fill="#E8AE45"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 351.47H633.795V379.55C633.795 379.55 628 398.578 605.714 398.5C583.429 398.422 577.634 378 577.634 378V351.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#F8BF56"
              />
              <path
                d="M662.5 309C656.311 359.895 640 380.5 606.5 380.5C573 380.5 555.134 357.395 547.5 304.5C547.5 263.991 572.965 225.258 605.777 225.258C638.59 225.258 659.311 267.895 662.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M589 270.5L606.257 274.915L623 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 337L583.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 337L629 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 327.5V306.5L612.5 299.5C613 298.166 615.3 295 620.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 315L600 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 301C597.5 299.166 595.7 295 592.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.581 292.131C579.871 288.472 571.473 286.925 554.583 289.894"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.166 292.249C631.856 288.497 640.245 286.902 657.151 289.776"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 234L624 251.5L568 275.5L554.5 313L553 328L556.5 343L534 326.5L527 312L536 293L542.5 260.5L563.5 232L601 220.5L627 222L636 232L651.5 236.5L669.5 260L674.5 287.5L682.5 306L670 336L655 344.5L658.5 315L646.5 270.5L627 251.5L630 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M627 251.5L630.5 232.5L624 251.5L568 275.5L554.5 313L553 328C553 328 555.5 341.884 560.5 351.5C565.5 361.115 574 369.5 574 369.5L571.5 370.5L560 364L556 342.5L534 326.5L527 312L536 293L542.5 260.5L548.5 252.5L606.5 231L634 223L666 255.5L669.5 260L674.5 287L682.5 306L670 336L657 343.5L654.5 363L640.5 370.5H638.5C638.5 370.5 644.5 365 648.5 358.5C652.5 352 655 344.5 655 344.5L658.5 314.5L646.5 270.5L627 251.5Z"
                fill="url(#pattern6)"
              />
              <circle cx="579.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 302.163)"
                fill="#835338"
              />
              <path
                d="M602.118 343.233C597.686 342.6 589.455 352.73 589.455 352.73L590.721 353.364L602.118 350.831L605.917 352.097L610.982 350.831L622.379 353.364C622.379 353.364 613.515 341.967 609.082 343.233C604.65 344.5 606.55 343.866 602.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M595 302.5C586.5 295.5 571.732 294.382 560.153 304.306L556.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 302.5C625.5 295.5 640.268 294.382 651.847 304.306L655.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 362.228C602.371 362.734 594.309 356.951 590.721 353.997L601.485 350.831L605.917 352.097L610.349 350.831L622.379 353.997C618.369 356.529 609.462 361.721 605.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M666 253.509C609.5 238.009 565.833 249.842 546 254.509L543 214.509C549.333 208.842 574.3 197.409 605.5 197.009C636.7 196.609 660.833 209.509 668.5 216.009L666 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 254.509C563 248.176 609.9 239.109 665.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 353.447L601.566 350.598L605.814 352.022L610.063 350.598L621.112 353.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.485 360.728C602.621 361.684 605.732 363.022 609.082 360.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 343C603.698 343.955 606.29 345.293 609.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 334.446L605.903 335.547L615.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 315.5C587.833 315 592 313.2 594 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 315.5C624.167 315 620 313.2 618 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M545 257.5L542.5 260.5L536 293L527 312L534 326.5L555.5 343L560 364L569 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_830_43872)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.84) scale(0.00166667 0.00446667)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern6"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_830_43872"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_830_43872"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF9EF" />
                  <stop offset="1" stopColor="#FFF9EF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_830_43872"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_830_43872"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFF0D7" />
                  <stop offset="1" stopColor="#FFF0D7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_830_43872"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFEAC5" />
                  <stop offset="1" stopColor="#FFEAC5" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_830_43872"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFEFC" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFEFC" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourUnemployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_55455)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_55455)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_55455)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_55455)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_55455)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_55455" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_55455)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.161L331.449 279.389L326.468 258.161C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.161L653.449 279.389L648.468 258.161C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.149 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.149 360.738 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.149 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.149 682.738 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.141C306.474 381.46 304.703 376.82 303.992 374.455C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.141C356.757 381.46 358.528 376.82 359.24 374.455C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.141C628.474 381.46 626.703 376.82 625.992 374.455C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.141C678.757 381.46 680.528 376.82 681.24 374.455C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_55455)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.682L337.702 478.265L361.485 382.638Z"
                fill="#FF6600"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L487 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 355.065H537.018V368.724C537.018 368.724 519.949 385.899 500.128 385.899C480.306 385.899 463.238 368.724 463.238 368.724V355.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 286.718C459.018 298.304 453.14 315.962 443.951 317.5C434.762 319.038 425.5 311 423.802 292.286C421.863 280.7 427.741 270.061 436.93 268.523C446.119 266.985 455.14 275.131 457.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 300.006C430.202 294.72 434.423 288.994 437.36 286.792C437.543 285.14 436.809 281.176 432.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 291.747C572.5 311.5 564.073 318.739 554.839 317.5C545.605 316.261 539.386 298.901 540.949 287.258C542.512 275.615 551.264 267.181 560.499 268.421C569.733 269.66 575.608 279 574.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 286.234C556.6 307.097 552.5 343 547.5 352C542.5 361 530.461 376.298 499 376C467.539 375.702 456.668 361.5 451 352C445.331 342.5 440.25 307.097 440.25 286.234C440.25 241.532 434.395 198.542 499.099 198.697C563.803 198.851 556.6 241.532 556.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M489.989 278.475C488.869 276.94 485.703 273.688 482 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 278.475C508.12 276.94 511.287 273.688 514.989 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 296.71C470.798 296.572 479.733 294.968 485.087 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 296.71C526.289 296.572 517.354 294.968 512 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.739 317.309L468.184 327.926L464 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 246.5L499.257 250.915L516 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M518 317.309L529.555 327.926L533.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 300.006C567.326 294.72 563.104 288.994 560.168 286.792C559.984 285.14 560.719 281.176 565.123 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M494.071 329.738C495.553 330.569 499.611 331.733 503.982 329.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 340.75L505.634 336.345L499.026 337.997L492.419 336.345L475.351 339.649L472.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.803 340.75L527.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M524 342L532 343L525.5 325L514 318.5L499.5 321.479L485 318.5L473 325L465 343L475.5 342L492 340.5L499 338L506 340.5L524 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M532 343L525.5 325L513.5 318L499.157 321.253L485 318.5L473 325L465 343L475.5 342L492 340.5L499.157 338L506 340.5L524.5 342L532 343Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 240.359L440.113 270.824L437.5 231.557L441 220.5L446 213L453.67 204.5L467.5 195.5L488.5 190.5L510 189.5L530.5 197.5L547.555 210L555 220.5L557.389 231.557L556.839 270.274L544.621 240.359L547.555 233.024L532.885 227.89H516L499 235.5L481 227.89H462.471L450.736 234.491L453.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.3"
                d="M547.5 233L533 227.878H516L499.027 235.5L481 227.878L447.5 229L454 240L440 271L436.5 221.5L499.027 226.226L557.5 219.5L557 270.5L544.5 240.5L547.5 233Z"
                fill="url(#pattern4)"
              />
              <path
                d="M492.97 346.256C494.782 347.087 499.741 348.25 505.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 313L483 317.667L499.15 321L515 317.667L514.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 281.286)"
                fill="#573420"
              />
              <path
                d="M487 282C479 276.5 463.5 270 449.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.174 282C519.174 276.5 534.674 270 548.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 284.433L491.005 296.119L492.1 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 284.435L506.495 296.109L505.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 236C501 220.5 457.333 232.333 437.5 237L434.5 197C440.833 191.333 465.8 179.9 497 179.5C528.2 179.1 552.333 192 560 198.5L557.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M438 237C454.5 230.667 501.4 221.6 557 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M488.501 268.857C473.633 271.674 463.613 267.022 446.719 269.967"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.493 269.182C519.368 272.609 533.484 266.963 550.422 269.642"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M557 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M439.5 267L438.5 240.5"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_55455)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.84) scale(0.00166667 0.00446667)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_55455"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_55455"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_55455"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_55455"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_55455"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_55455"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_55455"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourUnemployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_52947)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_52947)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_52947)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_52947)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_52947)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_52947" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_837_52947)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.161L331.449 279.389L326.468 258.161C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.161L653.449 279.389L648.468 258.161C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_52947)"
              />
              <path
                d="M440.593 324.5L467.105 353.5L480 382L448 364L440.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M547.294 324.5L520.782 353.5L505 383.5L542.5 363L547.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.953"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M465.634 346.47H521.795V374.55L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 351.47H521.795V379.551C521.795 379.551 516 398.578 493.714 398.5C471.429 398.423 465.634 378 465.634 378V351.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M400.5 387.5L383.045 391.271L360.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M550.5 309C544.311 359.895 528 380.5 494.5 380.5C461 380.5 443.134 357.395 435.5 304.5C435.5 263.992 460.965 225.258 493.777 225.258C526.59 225.258 547.311 267.895 550.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M477 270.5L494.257 274.915L511 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 337L471.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 337L517 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 327.5V306.5L500.5 299.5C501 298.167 503.3 295 508.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 315L488 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 301C485.5 299.167 483.7 295 480.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.555 291C467.706 293.712 459.438 287.988 442.596 291.217"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.258 290.438C518.806 293.105 528.286 287.997 545.119 291.278"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 234L512 251.5L456 275.5L442.5 313L441 328L444.5 343L422 326.5L415 312L424 293L430.5 260.5L451.5 232L489 220.5L515 222L524 232L539.5 236.5L557.5 260L562.5 287.5L570.5 306L558 336L543 344.5L546.5 315L534.5 270.5L515 251.5L518 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M515 251.5L518.5 232.5L512 251.5L456 275.5L442.5 313L441 328C441 328 443.5 341.885 448.5 351.5C453.5 361.115 462 369.5 462 369.5L459.5 370.5L448 364L444 342.5L422 326.5L415 312L424 293L430.5 260.5L436.5 252.5L494.5 231L522 223L554 255.5L557.5 260L562.5 287L570.5 306L558 336L545 343.5L542.5 363L528.5 370.5H526.5C526.5 370.5 532.5 365 536.5 358.5C540.5 352 543 344.5 543 344.5L546.5 314.5L534.5 270.5L515 251.5Z"
                fill="url(#pattern2)"
              />
              <circle cx="467.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 302.163)"
                fill="#835338"
              />
              <path
                d="M490.118 343.233C485.686 342.6 477.455 352.731 477.455 352.731L478.721 353.364L490.118 350.831L493.917 352.098L498.982 350.831L510.379 353.364C510.379 353.364 501.515 341.967 497.082 343.233C492.65 344.5 494.55 343.867 490.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M483 302.5C474.5 295.5 459.732 294.382 448.153 304.307L444.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 302.5C513.5 295.5 528.268 294.382 539.847 304.307L543.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 362.228C490.371 362.734 482.309 356.952 478.721 353.997L489.485 350.831L493.917 352.097L498.349 350.831L510.379 353.997C506.369 356.529 497.462 361.721 493.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M554 253.509C497.5 238.009 453.833 249.842 434 254.509L431 214.509C437.333 208.842 462.3 197.409 493.5 197.009C524.7 196.609 548.833 209.509 556.5 216.009L554 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 254.509C451 248.176 497.9 239.109 553.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M478.592 353.447L489.566 350.598L493.814 352.023L498.063 350.598L509.112 353.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.485 360.729C490.621 361.684 493.732 363.022 497.082 360.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 343C491.698 343.956 494.29 345.293 497.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 334.446L493.903 335.547L503.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 315.5C475.833 315 480 313.2 482 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 315.5C512.167 315 508 313.2 506 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M433 257.5L430.5 260.5L424 293L415 312L422 326.5L443.5 343L448 364L457 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M555.5 257L558 260.5L563 287L571 306.5L558 336L545.5 343.5L542.5 363L531 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_52947)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_52947"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_52947"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_52947"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_52947"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_52947"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_52947"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#FFFAF4" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_52947"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourUnemployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_833_50693)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_833_50693)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_833_50693)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_833_50693)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_833_50693)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#FFD18C"
              />
              <path
                d="M289 213H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#FCF3E7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_833_50693" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#FCF3E7"
                mask="url(#path-22-inside-1_833_50693)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#FCF3E7"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="366" cy="201" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#FCF3E7"
              />
              <circle cx="304" cy="193" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#FCF3E7"
              />
              <circle cx="324" cy="136" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#FCF3E7"
              />
              <circle cx="358" cy="87" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#FCF3E7"
              />
              <circle cx="407" cy="50" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#FCF3E7"
              />
              <circle cx="458" cy="27" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#FCF3E7"
              />
              <circle cx="377" cy="161" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#FCF3E7"
              />
              <circle cx="399" cy="127" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#FCF3E7"
              />
              <circle cx="433" cy="101" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#FCF3E7"
              />
              <circle cx="477" cy="82" r="4" fill="#FCF3E7" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#FCF3E7"
              />
              <circle cx="493" cy="8" r="4" fill="#FCF3E7" />
              <circle cx="647" cy="172" r="8" fill="#FCF3E7" />
              <circle cx="361" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="625" cy="125" r="8" fill="#FCF3E7" />
              <circle cx="397" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="589" cy="89" r="8" fill="#FCF3E7" />
              <circle cx="443" cy="64" r="8" fill="#FCF3E7" />
              <circle cx="492" cy="46" r="8" fill="#FCF3E7" />
              <circle cx="543" cy="64" r="8" fill="#FCF3E7" />
              <path
                d="M331.449 223.509L336.43 244.738C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.161L331.449 279.389L326.468 258.161C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.738L331.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.102 323.489 266.59C322.295 267.902 320.322 270.449 319.441 273.739C318.56 277.028 318.995 280.221 319.372 281.954C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.102 339.248 266.59C340.441 267.902 342.414 270.449 343.296 273.739C344.177 277.028 343.742 280.221 343.365 281.954C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.738C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.161L653.449 279.389L648.468 258.161C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.738L653.449 223.509Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.102 645.489 266.59C644.295 267.902 642.322 270.449 641.441 273.739C640.56 277.028 640.995 280.221 641.372 281.954C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.102 661.248 266.59C662.441 267.902 664.414 270.449 665.296 273.739C666.177 277.028 665.742 280.221 665.365 281.954C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#FCF3E7"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#FCF3E7"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#FCF3E7"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#FCF3E7"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#FCF3E7"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.844 382.639L535.789 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#FF6600"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#FEB444"
              />
              <path
                d="M350.238 340.066H424.018V359.268L387.128 389.069L350.238 359.268V340.066Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L374 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 355.066H424.018V368.724C424.018 368.724 406.949 385.899 387.128 385.899C367.306 385.899 350.238 368.724 350.238 368.724V355.066Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 286.718C346.018 298.305 340.14 315.962 330.951 317.5C321.762 319.038 312.5 311 310.802 292.286C308.863 280.7 314.741 270.061 323.93 268.523C333.12 266.985 342.141 275.132 344.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.81 300.006C317.202 294.72 321.424 288.994 324.36 286.792C324.544 285.14 323.81 281.176 319.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 291.747C459.5 311.5 451.074 318.74 441.839 317.5C432.605 316.261 426.386 298.901 427.949 287.258C429.512 275.615 438.265 267.181 447.499 268.421C456.733 269.66 462.608 279 461.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 286.234C443.6 307.097 439.5 343 434.5 352C429.5 361 417.461 376.298 386 376C354.539 375.702 343.668 361.5 338 352C332.332 342.5 327.251 307.097 327.251 286.234C327.251 241.532 321.395 198.542 386.099 198.697C450.803 198.851 443.6 241.532 443.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M376.99 278.475C375.869 276.94 372.703 273.688 369 272.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 278.475C395.121 276.94 398.287 273.688 401.99 272.96"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 296.71C357.798 296.573 366.733 294.968 372.087 289.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 296.71C413.289 296.573 404.354 294.968 399 289.649"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 317.309L355.184 327.926L351 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M369 246.5L386.257 250.915L403 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M405 317.309L416.555 327.926L420.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 300.006C454.326 294.72 450.105 288.994 447.168 286.792C446.985 285.14 447.719 281.176 452.124 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.072 329.738C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.346L386.027 337.997L393.185 336.346L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.738C388.339 331.06 383.274 330.289 381.072 329.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.072 329.738C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.346L386.027 337.997L393.185 336.346L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.738C388.339 331.06 383.274 330.289 381.072 329.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M381.071 329.738C382.554 330.569 386.611 331.733 390.982 329.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.804 340.75L392.634 336.345L386.027 337.997L379.42 336.345L362.351 339.649L359.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 340.75L414.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M411 342L419 343L412.5 325L401 318.5L386.5 321.479L372 318.5L360 325L352 343L362.5 342L379 340.5L386 338L393 340.5L411 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M419 343L412.5 325L400.5 318L386.158 321.253L372 318.5L360 325L352 343L362.5 342L379 340.5L386.158 338L393 340.5L411.5 342L419 343Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 240.359L327.113 270.825L324.5 231.558L328 220.5L333 213L340.67 204.5L354.5 195.5L375.5 190.5L397 189.5L417.5 197.5L434.555 210L442 220.5L444.39 231.558L443.839 270.274L431.621 240.359L434.555 233.025L419.885 227.89H403L386 235.5L368 227.89H349.471L337.736 234.492L340.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.3"
                d="M434.5 233L420 227.878H403L386.027 235.5L368 227.878L334.5 229L341 240L327 271L323.5 221.5L386.027 226.227L444.5 219.5L444 270.5L431.5 240.5L434.5 233Z"
                fill="url(#pattern4)"
              />
              <path
                d="M379.97 346.256C381.782 347.087 386.741 348.25 392.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 313L370 317.667L386.15 321L402 317.667L401.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 281.286)"
                fill="#573420"
              />
              <path
                d="M374 282C366 276.5 350.5 270 336.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.174 282C406.174 276.5 421.674 270 435.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M263.795 409.441L269.301 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 284.433L378.006 296.119L379.101 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 284.435L393.495 296.109L392.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 236C388 220.5 344.333 232.333 324.5 237L321.5 197C327.833 191.333 352.8 179.9 384 179.5C415.2 179.1 439.333 192 447 198.5L444.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M325 237C341.5 230.667 388.4 221.6 444 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M375.501 268.857C360.633 271.674 350.613 267.023 333.719 269.967"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.493 269.182C406.368 272.609 420.484 266.963 437.422 269.642"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M444 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M552.593 324.5L579.105 353.5L592 382L560 364L552.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M659.294 324.5L632.782 353.5L617 383.5L654.5 363L659.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#FF6600"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M577.634 346.47H633.795V374.55L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 351.47H633.795V379.55C633.795 379.55 628 398.578 605.714 398.5C583.429 398.422 577.634 378 577.634 378V351.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.074"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#FEB444"
              />
              <path
                d="M662.5 309C656.311 359.895 640 380.5 606.5 380.5C573 380.5 555.134 357.395 547.5 304.5C547.5 263.991 572.965 225.258 605.777 225.258C638.59 225.258 659.311 267.895 662.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M589 270.5L606.257 274.915L623 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 337L583.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 337L629 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 327.5V306.5L612.5 299.5C613 298.166 615.3 295 620.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 315L600 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 301C597.5 299.166 595.7 295 592.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.555 290.999C579.706 293.711 571.438 287.987 554.596 291.217"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.258 290.438C630.806 293.105 640.286 287.997 657.119 291.278"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 234L624 251.5L568 275.5L554.5 313L553 328L556.5 343L534 326.5L527 312L536 293L542.5 260.5L563.5 232L601 220.5L627 222L636 232L651.5 236.5L669.5 260L674.5 287.5L682.5 306L670 336L655 344.5L658.5 315L646.5 270.5L627 251.5L630 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M627 251.5L630.5 232.5L624 251.5L568 275.5L554.5 313L553 328C553 328 555.5 341.884 560.5 351.5C565.5 361.115 574 369.5 574 369.5L571.5 370.5L560 364L556 342.5L534 326.5L527 312L536 293L542.5 260.5L548.5 252.5L606.5 231L634 223L666 255.5L669.5 260L674.5 287L682.5 306L670 336L657 343.5L654.5 363L640.5 370.5H638.5C638.5 370.5 644.5 365 648.5 358.5C652.5 352 655 344.5 655 344.5L658.5 314.5L646.5 270.5L627 251.5Z"
                fill="url(#pattern6)"
              />
              <circle cx="579.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 302.163)"
                fill="#835338"
              />
              <path
                d="M602.118 343.233C597.686 342.6 589.455 352.731 589.455 352.731L590.721 353.364L602.118 350.831L605.917 352.097L610.982 350.831L622.379 353.364C622.379 353.364 613.515 341.967 609.082 343.233C604.65 344.5 606.55 343.866 602.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M595 302.5C586.5 295.5 571.732 294.382 560.153 304.306L556.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 302.5C625.5 295.5 640.268 294.382 651.847 304.306L655.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 362.228C602.371 362.734 594.309 356.951 590.721 353.997L601.485 350.831L605.917 352.097L610.349 350.831L622.379 353.997C618.369 356.529 609.462 361.721 605.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M666 253.509C609.5 238.009 565.833 249.842 546 254.509L543 214.509C549.333 208.842 574.3 197.409 605.5 197.009C636.7 196.609 660.833 209.509 668.5 216.009L666 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 254.509C563 248.176 609.9 239.109 665.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M590.592 353.447L601.566 350.598L605.814 352.023L610.063 350.598L621.112 353.997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.485 360.728C602.621 361.684 605.732 363.022 609.082 360.728"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 343C603.698 343.955 606.29 345.293 609.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 334.446L605.903 335.547L615.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 315.5C587.833 315 592 313.2 594 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 315.5C624.167 315 620 313.2 618 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M545 257.5L542.5 260.5L536 293L527 312L534 326.5L555.5 343L560 364L569 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_833_50693)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.84) scale(0.00166667 0.00446667)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern6"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_833_50693"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_833_50693"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_833_50693"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_833_50693"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FCF3E7" />
                  <stop offset="1" stopColor="#FCF3E7" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_833_50693"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFE4BB" />
                  <stop offset="1" stopColor="#FFE4BB" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_833_50693"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#FFFAF4" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#FFFAF4" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourEmployedMales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_45650)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_45650)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_45650)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_45650)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_45650)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_45650" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_45650)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.16L331.449 279.389L326.468 258.16C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.16L653.449 279.389L648.468 258.16C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_45650)"
              />
              <path
                d="M361.485 382.638L463.102 359.216H536.775L624.843 382.638L648.788 482.119L492.97 493.681L337.702 478.265L361.485 382.638Z"
                fill="#3A7CC5"
              />
              <path
                d="M423 368.5L429 407.5L472.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M573.5 369.5L567.5 408.5L524 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500.5 388.5L463 359V400L500.5 443.5L538 400V362L537 359L500.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M463.238 340.065H537.018V359.267L500.128 389.068L463.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M463 359.5L487 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M500 389L500 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M500 444L500 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M538 359.5L513.5 408.5L500 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M463.238 355.065H537.018V368.724C537.018 368.724 519.949 385.899 500.128 385.899C480.306 385.899 463.238 368.724 463.238 368.724V355.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M457.079 286.718C459.018 298.304 453.14 315.962 443.951 317.5C434.762 319.038 425.5 311 423.802 292.286C421.863 280.7 427.741 270.061 436.93 268.523C446.119 266.985 455.14 275.131 457.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M436.809 300.006C430.202 294.72 434.423 288.994 437.36 286.792C437.543 285.14 436.809 281.176 432.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M574.389 291.747C572.5 311.5 564.073 318.739 554.839 317.5C545.605 316.261 539.386 298.901 540.949 287.258C542.512 275.615 551.264 267.181 560.499 268.421C569.733 269.66 575.608 279 574.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M556.6 286.234C556.6 307.097 552.5 343 547.5 352C542.5 361 530.461 376.298 499 376C467.539 375.702 456.668 361.5 451 352C445.331 342.5 440.25 307.097 440.25 286.234C440.25 241.532 434.395 198.542 499.099 198.697C563.803 198.851 556.6 241.532 556.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M489.989 278.475C488.869 276.94 485.703 273.688 482 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M507 278.475C508.12 276.94 511.287 273.688 514.989 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M467 296.71C470.798 296.572 479.733 294.968 485.087 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M530.087 296.71C526.289 296.572 517.354 294.968 512 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.739 317.309L468.184 327.926L464 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M482 246.5L499.257 250.915L516 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M518 317.309L529.555 327.926L533.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M560.719 300.006C567.326 294.72 563.104 288.994 560.168 286.792C559.984 285.14 560.719 281.176 565.123 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="#E7A17C"
              />
              <path
                d="M494.071 329.738C485.262 331.06 477.921 337.263 475.351 340.2L492.42 336.345L499.027 337.997L506.184 336.345L523.803 340.75C514.994 333.262 506.919 330.289 503.982 329.738C501.339 331.06 496.274 330.289 494.071 329.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M488.708 268.74C471.915 265.48 463.483 264.132 446.668 267.502"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M508.446 268.997C525.198 265.532 533.613 264.081 550.467 267.245"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M494.071 329.738C495.553 330.569 499.611 331.733 503.982 329.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M523.803 340.75L505.634 336.345L499.026 337.997L492.419 336.345L475.351 339.649L472.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M523.803 340.75L527.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M524 342L532 338L525.5 325L514 318.5L499.5 321.479L485 318.5L473 325L465 338L475.5 342L492 340.5L499 338L506 340.5L524 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M532 338L525.5 325L513.5 318L499.157 321.253L485 318.5L473 325L465 338L475.5 342L492 340.5L499.157 338L506 340.5L524.5 342L532 338Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M453.67 240.359L440.113 270.824L437.5 231.557L441 220.5L446 213L453.67 204.5L467.5 195.5L488.5 190.5L510 189.5L530.5 197.5L547.555 210L555 220.5L557.389 231.557L556.839 270.274L544.621 240.359L547.555 233.024L532.885 227.89H516L499 235.5L481 227.89H462.471L450.736 234.491L453.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.3"
                d="M547.5 233L533 227.878H516L499.027 235.5L481 227.878L447.5 229L454 240L440 271L436.5 221.5L499.027 226.226L557.5 219.5L557 270.5L544.5 240.5L547.5 233Z"
                fill="url(#pattern4)"
              />
              <path
                d="M492.97 346.256C494.782 347.087 499.741 348.25 505.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M484.443 313L483 317.667L499.15 321L515 317.667L514.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="469.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 527.29 281.286)"
                fill="#573420"
              />
              <path
                d="M487 282C479 276.5 463.5 270 449.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M511.174 282C519.174 276.5 534.674 270 548.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M376.794 409.44L382.3 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M492.399 284.433L491.005 296.119L492.1 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M505.011 284.435L506.495 296.109L505.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557.5 236C501 220.5 457.333 232.333 437.5 237L434.5 197C440.833 191.333 465.8 179.9 497 179.5C528.2 179.1 552.333 192 560 198.5L557.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M438 237C454.5 230.667 501.4 221.6 557 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M557 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M439.5 267L438.5 240.5"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_45650)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.895833) scale(0.00166667 0.00465278)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_45650"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_45650"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_45650"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_45650"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_45650"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_45650"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_45650"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourEmployedFemales: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_837_43387)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_837_43387)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_837_43387)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_837_43387)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_837_43387)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_837_43387" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_837_43387)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.16L331.449 279.389L326.468 258.16C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.225C333.898 248.559 334.153 248.823 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.076 333.898 254.34 333.82 254.674L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.674C329.001 254.34 328.745 254.076 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.823 329.001 248.559 329.078 248.225L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.057C318.359 268.376 320.131 263.736 320.842 261.371C318.477 262.083 313.838 263.854 310.156 267.535C306.474 271.217 304.703 275.857 303.992 278.221C306.357 277.51 310.996 275.739 314.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.322 309.982 242.295 311.294 243.489C311.782 243.933 311.584 244.673 310.939 244.814C309.206 245.191 306.014 245.626 302.724 244.745C299.434 243.863 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.994 300.856 238.559 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.723 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.565 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.723 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.565 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.322 351.612 242.295 350.3 243.489C349.812 243.933 350.01 244.673 350.655 244.814C352.388 245.191 355.58 245.626 358.87 244.745C362.16 243.863 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.994 360.738 238.559 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.057C344.872 268.376 343.101 263.736 342.389 261.371C344.754 262.083 349.394 263.854 353.075 267.535C356.757 271.217 358.528 275.857 359.24 278.221C356.875 277.51 352.235 275.739 348.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.16L653.449 279.389L648.468 258.16C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.225C655.898 248.559 656.153 248.823 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.076 655.898 254.34 655.82 254.674L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.674C651.001 254.34 650.745 254.076 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.823 651.001 248.559 651.078 248.225L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.057C640.359 268.376 642.131 263.736 642.842 261.371C640.477 262.083 635.838 263.854 632.156 267.535C628.474 271.217 626.703 275.857 625.992 278.221C628.357 277.51 632.996 275.739 636.678 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.322 631.982 242.295 633.294 243.489C633.782 243.933 633.584 244.673 632.939 244.814C631.206 245.191 628.014 245.626 624.724 244.745C621.434 243.863 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.994 622.856 238.559 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.723 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.565 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.723 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.565 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.322 673.612 242.295 672.3 243.489C671.812 243.933 672.01 244.673 672.655 244.814C674.388 245.191 677.58 245.626 680.87 244.745C684.16 243.863 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.994 682.738 238.559 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.057C666.872 268.376 665.101 263.736 664.389 261.371C666.754 262.083 671.394 263.854 675.075 267.535C678.757 271.217 680.528 275.857 681.24 278.221C678.875 277.51 674.235 275.739 670.554 272.057Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.205 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.366 330.767 336.366 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.205 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.142 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.916 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.103C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.898 323.489 309.41C322.295 308.098 320.322 305.551 319.441 302.261C318.56 298.972 318.995 295.779 319.372 294.046C319.513 293.401 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.55 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.898 339.248 309.41C340.441 308.098 342.414 305.551 343.296 302.261C344.177 298.972 343.742 295.779 343.365 294.046C343.224 293.401 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.55 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.103C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.142 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.916 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.205 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.366 652.767 336.366 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.205 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.142 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.916 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.103C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.898 645.489 309.41C644.295 308.098 642.322 305.551 641.441 302.261C640.56 298.972 640.995 295.779 641.372 294.046C641.513 293.401 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.55 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.898 661.248 309.41C662.441 308.098 664.414 305.551 665.296 302.261C666.177 298.972 665.742 295.779 665.365 294.046C665.224 293.401 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.55 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.103C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.142 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.916 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.205 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.366 330.767 411.366 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.205 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.142 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.916 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.103C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.898 323.489 384.41C322.295 383.098 320.322 380.551 319.441 377.261C318.56 373.972 318.995 370.779 319.372 369.046C319.513 368.401 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.55 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.898 339.248 384.41C340.441 383.098 342.414 380.551 343.296 377.261C344.177 373.972 343.742 370.779 343.365 369.046C343.224 368.401 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.55 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.103C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.142 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.916 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.205 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.366 652.767 411.366 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.205 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.142 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.916 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.103C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.898 645.489 384.41C644.295 383.098 642.322 380.551 641.441 377.261C640.56 373.972 640.995 370.779 641.372 369.046C641.513 368.401 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.55 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.898 661.248 384.41C662.441 383.098 664.414 380.551 665.296 377.261C666.177 373.972 665.742 370.779 665.365 369.046C665.224 368.401 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.55 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.103C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.142 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.916 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <rect
                x="288"
                y="287"
                width="409"
                height="167"
                fill="url(#paint5_linear_837_43387)"
              />
              <path
                d="M440.593 324.5L467.105 353.5L480 382L448 364L440.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M547.294 324.5L520.782 353.5L505 383.5L542.5 363L547.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M383.045 391.292L464.238 370.755H528.051L604.332 391.292L631.363 503.39L497.569 525.066L356.616 503.39L383.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M398.461 413.643L404.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M465.634 346.47H521.795V374.551L535.5 413.5L493.714 428.5L451 413.5L465 373L465.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M465.634 351.47H521.795V379.551C521.795 379.551 516 398.578 493.714 398.5C471.429 398.423 465.634 378 465.634 378V351.47Z"
                fill="url(#pattern1)"
              />
              <path
                d="M446.5 423.5L482.5 437L484 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M539 425L505.5 437L504 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M494 428L494 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M445 453.5L466 368.5L458.5 370.5L450 372L433.5 377.5L407 449.5L397.5 488.5L443 493L445 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M542 453.5L521.5 374.5L522 370L536 371L553.5 375.5L580 449.5L589.5 488.5L544 493L542 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M550.5 309C544.311 359.895 528 380.5 494.5 380.5C461 380.5 443.134 357.395 435.5 304.5C435.5 263.992 460.965 225.258 493.777 225.258C526.59 225.258 547.311 267.895 550.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M477 270.5L494.257 274.915L511 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M479.5 337L471.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M509 337L517 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M499.5 327.5V306.5L500.5 299.5C501 298.167 503.3 295 508.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M488 315L488 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.598 288.941C467.855 285.434 459.444 283.963 442.581 287.085"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M503.168 289.267C519.854 285.501 528.242 283.899 545.151 286.758"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M518 234L512 251.5L456 275.5L442.5 313L441 328L444.5 343L422 326.5L415 312L424 293L430.5 260.5L451.5 232L489 220.5L515 222L524 232L539.5 236.5L557.5 260L562.5 287.5L570.5 306L558 336L543 344.5L546.5 315L534.5 270.5L515 251.5L518 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M515 251.5L518.5 232.5L512 251.5L456 275.5L442.5 313L441 328C441 328 443.5 341.885 448.5 351.5C453.5 361.115 462 369.5 462 369.5L459.5 370.5L448 364L444 342.5L422 326.5L415 312L424 293L430.5 260.5L436.5 252.5L494.5 231L522 223L554 255.5L557.5 260L562.5 287L570.5 306L558 336L545 343.5L542.5 363L528.5 370.5H526.5C526.5 370.5 532.5 365 536.5 358.5C540.5 352 543 344.5 543 344.5L546.5 314.5L534.5 270.5L515 251.5Z"
                fill="url(#pattern2)"
              />
              <circle cx="467.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 520.451 302.163)"
                fill="#835338"
              />
              <path
                d="M490.118 343.233C485.686 342.6 477.455 352.731 477.455 352.731L478.721 353.364L490.118 350.831L493.917 352.098L498.982 350.831L510.379 353.364C510.379 353.364 501.515 341.967 497.082 343.233C492.65 344.5 494.55 343.867 490.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M483 302.5C474.5 295.5 459.732 294.382 448.153 304.307L444.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M505 302.5C513.5 295.5 528.268 294.382 539.847 304.307L543.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M493.917 362.228C490.371 362.734 482.309 356.952 478.721 353.997L489.485 350.831L493.917 352.097L498.349 350.831L510.379 353.997C506.369 356.529 497.462 361.721 493.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M554 253.509C497.5 238.009 453.833 249.842 434 254.509L431 214.509C437.333 208.842 462.3 197.409 493.5 197.009C524.7 196.609 548.833 209.509 556.5 216.009L554 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M434.5 254.509C451 248.176 497.9 239.109 553.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M476.822 352.023L478.592 353.447L489.566 350.598L493.814 352.023L498.063 350.598L509.112 353.997L511.012 352.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M489.485 360.729C490.621 361.684 493.732 363.022 497.082 360.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M490.751 343C491.698 343.956 494.29 345.293 497.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M484.455 334.446L493.903 335.547L503.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M587.866 413.643L581.81 423.554V511.852"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M486 301C485.5 299.167 483.7 295 480.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M474 315.5C475.833 315 480 313.2 482 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M514 315.5C512.167 315 508 313.2 506 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M433 257.5L430.5 260.5L424 293L415 312L422 326.5L443.5 343L448 364L457 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M555.5 257L558 260.5L563 287L571 306.5L558 336L545.5 343.5L542.5 363L531 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint6_radial_837_43387)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_837_43387"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_837_43387"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_837_43387"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_837_43387"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_837_43387"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_837_43387"
                  x1="492.5"
                  y1="287"
                  x2="492.5"
                  y2="407.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="white" stopOpacity="0" />
                  <stop offset="1" stopColor="#F3FBFF" />
                </linearGradient>
                <radialGradient
                  id="paint6_radial_837_43387"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          FivtyfiveToSixtyfourEmployedAllgenders: (
            <svg
              css={cssHeroSectionImage}
              width={size}
              viewBox="0 0 951 614"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint0_linear_814_40121)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.1562 99.3125L101.41 136.125H106.875V182.438H160.312V162.25H160.319C160.393 158.944 161.079 155.678 162.346 152.619C163.689 149.377 165.657 146.432 168.138 143.951C170.619 141.47 173.565 139.502 176.806 138.159C180.048 136.816 183.522 136.125 187.031 136.125C190.54 136.125 194.014 136.816 197.256 138.159C200.498 139.502 203.443 141.47 205.924 143.951C208.405 146.432 210.373 149.377 211.716 152.619C212.983 155.678 213.67 158.944 213.743 162.25H213.75V209.75H267.188V237.062H319.438V270.312H491.625V237.062H491.632C491.705 233.756 492.392 230.49 493.659 227.431C495.002 224.19 496.97 221.244 499.451 218.763C501.932 216.282 504.877 214.314 508.119 212.971C511.361 211.629 514.835 210.938 518.344 210.938C521.853 210.938 525.327 211.629 528.569 212.971C531.81 214.314 534.756 216.282 537.237 218.763C539.718 221.244 541.686 224.19 543.029 227.431C543.348 228.202 543.63 228.985 543.875 229.779V209.75H597.312V162.25H650.75V182.438H704.188V136.125H709.653L730.906 99.3125L752.16 136.125H757.625V203.654C757.87 202.86 758.152 202.077 758.471 201.306C759.814 198.065 761.782 195.119 764.263 192.638C766.744 190.157 769.69 188.189 772.931 186.846C776.173 185.504 779.648 184.812 783.156 184.812C786.665 184.812 790.139 185.504 793.381 186.846C796.623 188.189 799.568 190.157 802.049 192.638C804.53 195.119 806.498 198.065 807.841 201.306C809.108 204.365 809.795 207.631 809.868 210.938H809.875V381.938H53.4375V136.125H58.9025L80.1562 99.3125ZM799.657 210.938C799.586 208.972 799.165 207.033 798.411 205.213C797.581 203.209 796.365 201.389 794.831 199.856C793.298 198.323 791.478 197.107 789.475 196.277C787.472 195.447 785.325 195.02 783.156 195.02C780.988 195.02 778.841 195.447 776.838 196.277C774.834 197.107 773.014 198.323 771.481 199.856C769.948 201.389 768.732 203.209 767.902 205.213C767.148 207.033 766.726 208.972 766.656 210.938H799.657ZM533.598 231.338C534.352 233.158 534.774 235.097 534.844 237.062H501.843C501.914 235.097 502.335 233.158 503.089 231.338C503.919 229.334 505.135 227.514 506.669 225.981C508.202 224.448 510.022 223.232 512.025 222.402C514.028 221.572 516.175 221.145 518.344 221.145C520.512 221.145 522.659 221.572 524.662 222.402C526.666 223.232 528.486 224.448 530.019 225.981C531.552 227.514 532.768 229.334 533.598 231.338ZM203.532 162.25C203.461 160.284 203.04 158.345 202.286 156.525C201.456 154.522 200.24 152.702 198.706 151.169C197.173 149.635 195.353 148.419 193.35 147.589C191.347 146.76 189.2 146.332 187.031 146.332C184.863 146.332 182.716 146.76 180.713 147.589C178.709 148.419 176.889 149.635 175.356 151.169C173.823 152.702 172.607 154.522 171.777 156.525C171.023 158.345 170.601 160.284 170.531 162.25H203.532Z"
                fill="url(#paint1_linear_814_40121)"
              />
              <path
                d="M305.906 58.9375H126L134.906 1.9375H154.5L168.156 6.6875L183 16.1875H198.438L210.312 22.125L222.188 29.8438L249.5 36.9688L264.938 47.0625L305.906 58.9375Z"
                fill="url(#paint2_linear_814_40121)"
              />
              <path
                d="M912.594 71.4062H769.5L797.406 56.5625L817 41.125L828.281 48.25L843.125 54.1875L859.156 44.0938L891.219 56.5625L898.344 63.6875L912.594 71.4062Z"
                fill="url(#paint3_linear_814_40121)"
              />
              <path
                d="M62.3438 351.656L38 359.375V365.906L33.8438 382.531L833.031 381.938L818.188 351.656H798.594L786.125 337.406L772.469 329.094L757.625 335.031L749.312 342.75H732.094L722.594 335.031H700.031L663.219 342.75L569.406 326.719L551 316.031H535.562L520.125 320.781H507.062L494 307.719H478.562L461.938 320.781H399.594L382.375 310.688L310.531 335.031L286.188 342.75L265.406 335.031H251.156L235.125 342.75H220.281L208.406 335.031L194.75 326.719H182.281L169.812 338.594L152.594 342.75L139.531 335.031H125.875L107.469 342.75L89.6562 326.719H77.1875L62.3438 351.656Z"
                fill="url(#paint4_linear_814_40121)"
              />
              <ellipse
                cx="84.3125"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="130.625"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="190"
                cy="342.75"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="228"
                cy="336.812"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="260.062"
                cy="328.5"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="486.875"
                cy="320.188"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="514.188"
                cy="315.438"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="542.688"
                cy="307.125"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="718.438"
                cy="327.312"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <ellipse
                cx="771.875"
                cy="343.938"
                rx="8.3125"
                ry="10.6875"
                fill="white"
              />
              <path
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="#9ACDF2"
              />
              <path
                d="M289 213H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 213H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 288H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 288H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M289 363H374.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611 363H696.5"
                stroke="#DEF1FF"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <mask id="path-22-inside-1_814_40121" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512.611 69.156C507.133 74.0353 499.913 77 492 77C484.874 77 478.309 74.5955 473.073 70.5534C469.701 84.0236 457.515 94 443 94C437.53 94 432.391 92.5834 427.93 90.097C426.852 106.24 413.416 119 397 119C395.057 119 393.157 118.821 391.313 118.48C391.763 120.582 392 122.763 392 125C392 140.637 380.422 153.571 365.37 155.694C368.305 160.431 370 166.018 370 172C370 184.123 363.041 194.621 352.9 199.717C356.964 203.636 360.037 208.596 361.673 214H302.327C304.782 205.896 310.466 198.789 317.882 194.694C311.802 189.035 308 180.961 308 172C308 156.363 319.578 143.429 334.63 141.306C331.695 136.569 330 130.982 330 125C330 107.879 343.879 94 361 94C362.943 94 364.843 94.1787 366.687 94.5205C366.237 92.4181 366 90.2367 366 88C366 70.8792 379.879 57 397 57C402.47 57 407.609 58.4166 412.07 60.903C413.148 44.7601 426.584 32 443 32C450.126 32 456.691 34.4046 461.927 38.4466C465.299 24.9764 477.485 15 492 15C507.013 15 519.534 25.6722 522.389 39.844C527.867 34.9647 535.087 32 543 32C559.416 32 572.852 44.7601 573.93 60.903C578.391 58.4166 583.53 57 589 57C606.121 57 620 70.8792 620 88C620 90.2367 619.763 92.4181 619.313 94.5205C621.157 94.1787 623.057 94 625 94C642.121 94 656 107.879 656 125C656 130.982 654.305 136.569 651.37 141.306C666.422 143.429 678 156.363 678 172C678 180.961 674.198 189.035 668.118 194.694C675.534 198.789 681.219 205.896 683.673 214H624.327C625.963 208.596 629.036 203.636 633.1 199.717C622.959 194.621 616 184.123 616 172C616 166.018 617.695 160.431 620.63 155.694C605.578 153.571 594 140.637 594 125C594 122.763 594.237 120.582 594.687 118.48C592.843 118.821 590.943 119 589 119C572.584 119 559.148 106.24 558.07 90.097C553.609 92.5834 548.47 94 543 94C527.987 94 515.466 83.3278 512.611 69.156Z"
                />
              </mask>
              <path
                d="M512.611 69.156L514.572 68.761L513.883 65.3444L511.281 67.6625L512.611 69.156ZM473.073 70.5534L474.295 68.9703L471.876 67.1022L471.133 70.0677L473.073 70.5534ZM427.93 90.097L428.904 88.35L426.145 86.8125L425.935 89.9637L427.93 90.097ZM391.313 118.48L391.678 116.513L388.73 115.966L389.357 118.898L391.313 118.48ZM365.37 155.694L365.091 153.714L362.056 154.142L363.67 156.748L365.37 155.694ZM352.9 199.717L352.002 197.93L349.48 199.197L351.511 201.156L352.9 199.717ZM361.673 214V216H364.369L363.587 213.42L361.673 214ZM302.327 214L300.413 213.42L299.631 216H302.327V214ZM317.882 194.694L318.849 196.445L321.265 195.111L319.245 193.231L317.882 194.694ZM334.63 141.306L334.909 143.286L337.944 142.858L336.33 140.252L334.63 141.306ZM366.687 94.5205L366.322 96.487L369.27 97.0335L368.643 94.1018L366.687 94.5205ZM412.07 60.903L411.096 62.65L413.855 64.1875L414.065 61.0363L412.07 60.903ZM461.927 38.4466L460.705 40.0297L463.124 41.8978L463.867 38.9323L461.927 38.4466ZM522.389 39.844L520.428 40.239L521.117 43.6556L523.719 41.3375L522.389 39.844ZM573.93 60.903L571.935 61.0363L572.145 64.1875L574.904 62.65L573.93 60.903ZM619.313 94.5205L617.357 94.1018L616.73 97.0335L619.678 96.487L619.313 94.5205ZM651.37 141.306L649.67 140.252L648.056 142.858L651.091 143.286L651.37 141.306ZM668.118 194.694L666.755 193.231L664.735 195.111L667.151 196.445L668.118 194.694ZM683.673 214V216H686.369L685.587 213.42L683.673 214ZM624.327 214L622.413 213.42L621.631 216H624.327V214ZM633.1 199.717L634.489 201.156L636.52 199.197L633.998 197.93L633.1 199.717ZM620.63 155.694L622.33 156.748L623.944 154.142L620.909 153.714L620.63 155.694ZM594.687 118.48L596.643 118.898L597.27 115.966L594.322 116.513L594.687 118.48ZM558.07 90.097L560.065 89.9637L559.855 86.8125L557.096 88.35L558.07 90.097ZM511.281 67.6625C506.155 72.2282 499.404 75 492 75V79C500.422 79 508.112 75.8423 513.941 70.6494L511.281 67.6625ZM492 75C485.331 75 479.194 72.7516 474.295 68.9703L471.851 72.1366C477.425 76.4393 484.416 79 492 79V75ZM471.133 70.0677C467.978 82.6691 456.576 92 443 92V96C458.455 96 471.423 85.3781 475.013 71.0392L471.133 70.0677ZM443 92C437.88 92 433.075 90.6748 428.904 88.35L426.957 91.844C431.708 94.492 437.181 96 443 96V92ZM425.935 89.9637C424.926 105.063 412.356 117 397 117V121C414.476 121 428.778 107.417 429.926 90.2303L425.935 89.9637ZM397 117C395.18 117 393.402 116.833 391.678 116.513L390.948 120.446C392.912 120.81 394.935 121 397 121V117ZM389.357 118.898C389.778 120.864 390 122.905 390 125H394C394 122.622 393.748 120.3 393.269 118.061L389.357 118.898ZM390 125C390 139.627 379.169 151.728 365.091 153.714L365.65 157.675C381.674 155.414 394 141.648 394 125H390ZM363.67 156.748C366.415 161.177 368 166.401 368 172H372C372 165.635 370.196 159.685 367.07 154.641L363.67 156.748ZM368 172C368 183.338 361.494 193.16 352.002 197.93L353.798 201.504C364.588 196.082 372 184.908 372 172H368ZM351.511 201.156C355.336 204.845 358.224 209.511 359.759 214.58L363.587 213.42C361.849 207.682 358.592 202.428 354.288 198.277L351.511 201.156ZM361.673 212H302.327V216H361.673V212ZM304.241 214.58C306.547 206.966 311.896 200.284 318.849 196.445L316.915 192.944C309.035 197.294 303.016 204.825 300.413 213.42L304.241 214.58ZM319.245 193.231C313.555 187.933 310 180.383 310 172H306C306 181.539 310.05 190.136 316.519 196.158L319.245 193.231ZM310 172C310 157.373 320.831 145.272 334.909 143.286L334.35 139.325C318.326 141.586 306 155.352 306 172H310ZM336.33 140.252C333.585 135.823 332 130.599 332 125H328C328 131.365 329.804 137.315 332.93 142.359L336.33 140.252ZM332 125C332 108.984 344.984 96 361 96V92C342.775 92 328 106.775 328 125H332ZM361 96C362.82 96 364.598 96.1673 366.322 96.487L367.052 92.554C365.088 92.19 363.065 92 361 92V96ZM368.643 94.1018C368.222 92.1362 368 90.0951 368 88H364C364 90.3783 364.252 92.7 364.731 94.9391L368.643 94.1018ZM368 88C368 71.9837 380.984 59 397 59V55C378.775 55 364 69.7746 364 88H368ZM397 59C402.12 59 406.925 60.3253 411.096 62.65L413.043 59.156C408.292 56.508 402.819 55 397 55V59ZM414.065 61.0363C415.074 45.9368 427.644 34 443 34V30C425.524 30 411.222 43.5834 410.074 60.7697L414.065 61.0363ZM443 34C449.669 34 455.806 36.2484 460.705 40.0297L463.149 36.8634C457.575 32.5607 450.584 30 443 30V34ZM463.867 38.9323C467.022 26.331 478.424 17 492 17V13C476.545 13 463.577 23.6219 459.987 37.9608L463.867 38.9323ZM492 17C506.042 17 517.757 26.9824 520.428 40.239L524.349 39.449C521.31 24.362 507.984 13 492 13V17ZM523.719 41.3375C528.845 36.7718 535.596 34 543 34V30C534.578 30 526.888 33.1577 521.059 38.3506L523.719 41.3375ZM543 34C558.356 34 570.926 45.9368 571.935 61.0363L575.926 60.7697C574.778 43.5834 560.476 30 543 30V34ZM574.904 62.65C579.075 60.3253 583.88 59 589 59V55C583.181 55 577.708 56.508 572.957 59.156L574.904 62.65ZM589 59C605.016 59 618 71.9837 618 88H622C622 69.7746 607.225 55 589 55V59ZM618 88C618 90.0951 617.778 92.1362 617.357 94.1018L621.269 94.9391C621.748 92.7 622 90.3783 622 88H618ZM619.678 96.487C621.402 96.1673 623.18 96 625 96V92C622.935 92 620.912 92.19 618.948 92.554L619.678 96.487ZM625 96C641.016 96 654 108.984 654 125H658C658 106.775 643.225 92 625 92V96ZM654 125C654 130.599 652.415 135.823 649.67 140.252L653.07 142.359C656.196 137.315 658 131.365 658 125H654ZM651.091 143.286C665.169 145.272 676 157.373 676 172H680C680 155.352 667.674 141.586 651.65 139.325L651.091 143.286ZM676 172C676 180.383 672.445 187.933 666.755 193.231L669.481 196.158C675.95 190.136 680 181.539 680 172H676ZM667.151 196.445C674.104 200.284 679.453 206.966 681.759 214.58L685.587 213.42C682.984 204.825 676.965 197.294 669.085 192.944L667.151 196.445ZM683.673 212H624.327V216H683.673V212ZM626.241 214.58C627.776 209.511 630.664 204.845 634.489 201.156L631.712 198.277C627.408 202.428 624.151 207.682 622.413 213.42L626.241 214.58ZM633.998 197.93C624.506 193.16 618 183.338 618 172H614C614 184.908 621.412 196.082 632.202 201.504L633.998 197.93ZM618 172C618 166.401 619.585 161.177 622.33 156.748L618.93 154.641C615.804 159.685 614 165.635 614 172H618ZM620.909 153.714C606.831 151.728 596 139.627 596 125H592C592 141.648 604.326 155.414 620.35 157.675L620.909 153.714ZM596 125C596 122.905 596.222 120.864 596.643 118.898L592.731 118.061C592.252 120.3 592 122.622 592 125H596ZM594.322 116.513C592.598 116.833 590.82 117 589 117V121C591.065 121 593.088 120.81 595.052 120.446L594.322 116.513ZM589 117C573.644 117 561.074 105.063 560.065 89.9637L556.074 90.2303C557.222 107.417 571.524 121 589 121V117ZM557.096 88.35C552.925 90.6747 548.12 92 543 92V96C548.819 96 554.292 94.492 559.043 91.844L557.096 88.35ZM543 92C528.958 92 517.243 82.0176 514.572 68.761L510.651 69.551C513.69 84.638 527.016 96 543 96V92Z"
                fill="#DEF1FF"
                mask="url(#path-22-inside-1_814_40121)"
              />
              <circle
                cx="339"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M346.969 213H317.031C320.261 208.174 325.761 205 332 205C338.24 205 343.739 208.174 346.969 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <path
                d="M670.706 213H640.768C643.998 208.174 649.498 205 655.737 205C661.977 205 667.476 208.174 670.706 213Z"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="647"
                cy="172"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="361"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="625"
                cy="125"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="397"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="589"
                cy="89"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="443"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="492"
                cy="46"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle
                cx="543"
                cy="64"
                r="18"
                stroke="#DEF1FF"
                strokeWidth="2"
              />
              <circle cx="339" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="366" cy="201" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 618 201)"
                fill="#DEF1FF"
              />
              <circle cx="304" cy="193" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 682 193)"
                fill="#DEF1FF"
              />
              <circle cx="324" cy="136" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 662 136)"
                fill="#DEF1FF"
              />
              <circle cx="358" cy="87" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 628 87)"
                fill="#DEF1FF"
              />
              <circle cx="407" cy="50" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 579 50)"
                fill="#DEF1FF"
              />
              <circle cx="458" cy="27" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 528 27)"
                fill="#DEF1FF"
              />
              <circle cx="377" cy="161" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 607 161)"
                fill="#DEF1FF"
              />
              <circle cx="399" cy="127" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 585 127)"
                fill="#DEF1FF"
              />
              <circle cx="433" cy="101" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 551 101)"
                fill="#DEF1FF"
              />
              <circle cx="477" cy="82" r="4" fill="#DEF1FF" />
              <circle
                r="4"
                transform="matrix(-1 0 0 1 507 82)"
                fill="#DEF1FF"
              />
              <circle cx="493" cy="8" r="4" fill="#DEF1FF" />
              <circle cx="647" cy="172" r="8" fill="#DEF1FF" />
              <circle cx="361" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="625" cy="125" r="8" fill="#DEF1FF" />
              <circle cx="397" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="589" cy="89" r="8" fill="#DEF1FF" />
              <circle cx="443" cy="64" r="8" fill="#DEF1FF" />
              <circle cx="492" cy="46" r="8" fill="#DEF1FF" />
              <circle cx="543" cy="64" r="8" fill="#DEF1FF" />
              <path
                d="M331.449 223.509L336.43 244.737C336.586 245.405 337.099 245.932 337.762 246.107L357.965 251.449L337.762 256.791C337.099 256.966 336.586 257.493 336.43 258.16L331.449 279.389L326.468 258.16C326.312 257.493 325.799 256.966 325.136 256.791L304.933 251.449L325.136 246.107C325.799 245.932 326.312 245.405 326.468 244.737L331.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 241.896C330.767 240.939 332.131 240.939 332.353 241.896L333.82 248.224C333.898 248.558 334.153 248.822 334.484 248.911L340.621 250.553C341.539 250.798 341.539 252.1 340.621 252.345L334.484 253.987C334.153 254.075 333.898 254.339 333.82 254.673L332.353 261.002C332.131 261.959 330.767 261.959 330.545 261.002L329.078 254.673C329.001 254.339 328.745 254.075 328.414 253.987L322.277 252.345C321.36 252.1 321.36 250.798 322.277 250.553L328.414 248.911C328.745 248.822 329.001 248.558 329.078 248.224L330.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 231.213C318.359 234.895 320.131 239.535 320.842 241.899C318.477 241.188 313.838 239.417 310.156 235.735C306.474 232.054 304.703 227.414 303.992 225.049C306.357 225.761 310.996 227.532 314.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 272.058C318.359 268.376 320.131 263.736 320.842 261.372C318.477 262.083 313.838 263.854 310.156 267.536C306.474 271.217 304.703 275.857 303.992 278.222C306.357 277.51 310.996 275.739 314.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 263.296C307.435 262.414 309.982 260.441 311.294 259.248C311.782 258.804 311.584 258.063 310.939 257.923C309.206 257.545 306.014 257.11 302.724 257.992C299.434 258.873 296.887 260.846 295.575 262.04C295.087 262.484 295.285 263.224 295.93 263.365C297.663 263.742 300.856 264.177 304.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 239.441C307.435 240.323 309.982 242.296 311.294 243.489C311.782 243.933 311.584 244.674 310.939 244.814C309.206 245.192 306.014 245.627 302.724 244.745C299.434 243.864 296.887 241.891 295.575 240.697C295.087 240.253 295.285 239.513 295.93 239.372C297.663 238.995 300.856 238.56 304.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 226.434C325.627 229.724 325.192 232.916 324.814 234.649C324.673 235.294 323.933 235.492 323.489 235.004C322.295 233.692 320.322 231.145 319.441 227.855C318.56 224.566 318.995 221.373 319.372 219.64C319.513 218.995 320.253 218.797 320.697 219.285C321.891 220.597 323.864 223.144 324.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 275.16C325.627 271.87 325.192 268.678 324.814 266.945C324.673 266.3 323.933 266.101 323.489 266.59C322.295 267.901 320.322 270.449 319.441 273.738C318.56 277.028 318.995 280.221 319.372 281.953C319.513 282.598 320.253 282.797 320.697 282.309C321.891 280.997 323.864 278.449 324.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 226.434C337.11 229.724 337.545 232.916 337.923 234.649C338.063 235.294 338.804 235.492 339.248 235.004C340.441 233.692 342.414 231.145 343.296 227.855C344.177 224.566 343.742 221.373 343.365 219.64C343.224 218.995 342.484 218.797 342.04 219.285C340.846 220.597 338.873 223.144 337.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 275.16C337.11 271.87 337.545 268.678 337.923 266.945C338.063 266.3 338.804 266.101 339.248 266.59C340.441 267.901 342.414 270.449 343.296 273.738C344.177 277.028 343.742 280.221 343.365 281.953C343.224 282.598 342.484 282.797 342.04 282.309C340.846 280.997 338.873 278.449 337.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 263.296C354.159 262.414 351.612 260.441 350.3 259.248C349.812 258.804 350.01 258.063 350.655 257.923C352.388 257.545 355.58 257.11 358.87 257.992C362.16 258.873 364.707 260.846 366.019 262.04C366.507 262.484 366.309 263.224 365.664 263.365C363.931 263.742 360.738 264.177 357.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 239.441C354.159 240.323 351.612 242.296 350.3 243.489C349.812 243.933 350.01 244.674 350.655 244.814C352.388 245.192 355.58 245.627 358.87 244.745C362.16 243.864 364.707 241.891 366.019 240.697C366.507 240.253 366.309 239.513 365.664 239.372C363.931 238.995 360.738 238.56 357.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 231.213C344.872 234.895 343.101 239.535 342.389 241.899C344.754 241.188 349.394 239.417 353.075 235.735C356.757 232.054 358.528 227.414 359.24 225.049C356.875 225.761 352.235 227.532 348.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 272.058C344.872 268.376 343.101 263.736 342.389 261.372C344.754 262.083 349.394 263.854 353.075 267.536C356.757 271.217 358.528 275.857 359.24 278.222C356.875 277.51 352.235 275.739 348.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 223.509L658.43 244.737C658.586 245.405 659.099 245.932 659.762 246.107L679.965 251.449L659.762 256.791C659.099 256.966 658.586 257.493 658.43 258.16L653.449 279.389L648.468 258.16C648.312 257.493 647.799 256.966 647.136 256.791L626.933 251.449L647.136 246.107C647.799 245.932 648.312 245.405 648.468 244.737L653.449 223.509Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 241.896C652.767 240.939 654.131 240.939 654.353 241.896L655.82 248.224C655.898 248.558 656.153 248.822 656.484 248.911L662.621 250.553C663.539 250.798 663.539 252.1 662.621 252.345L656.484 253.987C656.153 254.075 655.898 254.339 655.82 254.673L654.353 261.002C654.131 261.959 652.767 261.959 652.545 261.002L651.078 254.673C651.001 254.339 650.745 254.075 650.414 253.987L644.277 252.345C643.36 252.1 643.36 250.798 644.277 250.553L650.414 248.911C650.745 248.822 651.001 248.558 651.078 248.224L652.545 241.896Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 231.213C640.359 234.895 642.131 239.535 642.842 241.899C640.477 241.188 635.838 239.417 632.156 235.735C628.474 232.054 626.703 227.414 625.992 225.049C628.357 225.761 632.996 227.532 636.678 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 272.058C640.359 268.376 642.131 263.736 642.842 261.372C640.477 262.083 635.838 263.854 632.156 267.536C628.474 271.217 626.703 275.857 625.992 278.222C628.357 277.51 632.996 275.739 636.678 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 263.296C629.435 262.414 631.982 260.441 633.294 259.248C633.782 258.804 633.584 258.063 632.939 257.923C631.206 257.545 628.014 257.11 624.724 257.992C621.434 258.873 618.887 260.846 617.575 262.04C617.087 262.484 617.285 263.224 617.93 263.365C619.663 263.742 622.856 264.177 626.145 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 239.441C629.435 240.323 631.982 242.296 633.294 243.489C633.782 243.933 633.584 244.674 632.939 244.814C631.206 245.192 628.014 245.627 624.724 244.745C621.434 243.864 618.887 241.891 617.575 240.697C617.087 240.253 617.285 239.513 617.93 239.372C619.663 238.995 622.856 238.56 626.145 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 226.434C647.627 229.724 647.192 232.916 646.814 234.649C646.673 235.294 645.933 235.492 645.489 235.004C644.295 233.692 642.322 231.145 641.441 227.855C640.56 224.566 640.995 221.373 641.372 219.64C641.513 218.995 642.253 218.797 642.697 219.285C643.891 220.597 645.864 223.144 646.745 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 275.16C647.627 271.87 647.192 268.678 646.814 266.945C646.673 266.3 645.933 266.101 645.489 266.59C644.295 267.901 642.322 270.449 641.441 273.738C640.56 277.028 640.995 280.221 641.372 281.953C641.513 282.598 642.253 282.797 642.697 282.309C643.891 280.997 645.864 278.449 646.745 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 226.434C659.11 229.724 659.545 232.916 659.923 234.649C660.063 235.294 660.804 235.492 661.248 235.004C662.441 233.692 664.414 231.145 665.296 227.855C666.177 224.566 665.742 221.373 665.365 219.64C665.224 218.995 664.484 218.797 664.04 219.285C662.846 220.597 660.873 223.144 659.992 226.434Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 275.16C659.11 271.87 659.545 268.678 659.923 266.945C660.063 266.3 660.804 266.101 661.248 266.59C662.441 267.901 664.414 270.449 665.296 273.738C666.177 277.028 665.742 280.221 665.365 281.953C665.224 282.598 664.484 282.797 664.04 282.309C662.846 280.997 660.873 278.449 659.992 275.16Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 263.296C676.159 262.414 673.612 260.441 672.3 259.248C671.812 258.804 672.01 258.063 672.655 257.923C674.388 257.545 677.58 257.11 680.87 257.992C684.16 258.873 686.707 260.846 688.019 262.04C688.507 262.484 688.309 263.224 687.664 263.365C685.931 263.742 682.738 264.177 679.449 263.296Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 239.441C676.159 240.323 673.612 242.296 672.3 243.489C671.812 243.933 672.01 244.674 672.655 244.814C674.388 245.192 677.58 245.627 680.87 244.745C684.16 243.864 686.707 241.891 688.019 240.697C688.507 240.253 688.309 239.513 687.664 239.372C685.931 238.995 682.738 238.56 679.449 239.441Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 231.213C666.872 234.895 665.101 239.535 664.389 241.899C666.754 241.188 671.394 239.417 675.075 235.735C678.757 232.054 680.528 227.414 681.24 225.049C678.875 225.761 674.235 227.532 670.554 231.213Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 272.058C666.872 268.376 665.101 263.736 664.389 261.372C666.754 262.083 671.394 263.854 675.075 267.536C678.757 271.217 680.528 275.857 681.24 278.222C678.875 277.51 674.235 275.739 670.554 272.058Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 297.916L336.43 319.144C336.586 319.811 337.099 320.338 337.762 320.513L357.965 325.855L337.762 331.197C337.099 331.372 336.586 331.899 336.43 332.567L331.449 353.795L326.468 332.567C326.312 331.899 325.799 331.372 325.136 331.197L304.933 325.855L325.136 320.513C325.799 320.338 326.312 319.811 326.468 319.144L331.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 316.302C330.767 315.345 332.131 315.345 332.353 316.302L333.82 322.631C333.898 322.965 334.153 323.229 334.484 323.317L340.621 324.959C341.539 325.204 341.539 326.506 340.621 326.751L334.484 328.393C334.153 328.482 333.898 328.746 333.82 329.08L332.353 335.408C332.131 336.365 330.767 336.365 330.545 335.408L329.078 329.08C329.001 328.746 328.745 328.482 328.414 328.393L322.277 326.751C321.36 326.506 321.36 325.204 322.277 324.959L328.414 323.317C328.745 323.229 329.001 322.965 329.078 322.631L330.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 305.62C318.359 309.301 320.131 313.941 320.842 316.306C318.477 315.594 313.838 313.823 310.156 310.142C306.474 306.46 304.703 301.82 303.992 299.456C306.357 300.167 310.996 301.938 314.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 346.464C318.359 342.782 320.131 338.143 320.842 335.778C318.477 336.489 313.838 338.26 310.156 341.942C306.474 345.623 304.703 350.263 303.992 352.628C306.357 351.917 310.996 350.145 314.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 337.702C307.435 336.821 309.982 334.848 311.294 333.654C311.782 333.21 311.584 332.47 310.939 332.329C309.206 331.951 306.014 331.516 302.724 332.398C299.434 333.279 296.887 335.252 295.575 336.446C295.087 336.89 295.285 337.63 295.93 337.771C297.663 338.148 300.856 338.583 304.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 313.847C307.435 314.729 309.982 316.702 311.294 317.895C311.782 318.339 311.584 319.08 310.939 319.22C309.206 319.598 306.014 320.033 302.724 319.151C299.434 318.27 296.887 316.297 295.575 315.104C295.087 314.659 295.285 313.919 295.93 313.778C297.663 313.401 300.856 312.966 304.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 300.84C325.627 304.13 325.192 307.322 324.814 309.055C324.673 309.7 323.933 309.899 323.489 309.41C322.295 308.099 320.322 305.551 319.441 302.262C318.56 298.972 318.995 295.779 319.372 294.047C319.513 293.402 320.253 293.203 320.697 293.691C321.891 295.003 323.864 297.551 324.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 349.566C325.627 346.276 325.192 343.084 324.814 341.351C324.673 340.706 323.933 340.508 323.489 340.996C322.295 342.308 320.322 344.855 319.441 348.145C318.56 351.434 318.995 354.627 319.372 356.36C319.513 357.005 320.253 357.203 320.697 356.715C321.891 355.403 323.864 352.856 324.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 300.84C337.11 304.13 337.545 307.322 337.923 309.055C338.063 309.7 338.804 309.899 339.248 309.41C340.441 308.099 342.414 305.551 343.296 302.262C344.177 298.972 343.742 295.779 343.365 294.047C343.224 293.402 342.484 293.203 342.04 293.691C340.846 295.003 338.873 297.551 337.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 349.566C337.11 346.276 337.545 343.084 337.923 341.351C338.063 340.706 338.804 340.508 339.248 340.996C340.441 342.308 342.414 344.855 343.296 348.145C344.177 351.434 343.742 354.627 343.365 356.36C343.224 357.005 342.484 357.203 342.04 356.715C340.846 355.403 338.873 352.856 337.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 337.702C354.159 336.821 351.612 334.848 350.3 333.654C349.812 333.21 350.01 332.47 350.655 332.329C352.388 331.951 355.58 331.516 358.87 332.398C362.16 333.279 364.707 335.252 366.019 336.446C366.507 336.89 366.309 337.63 365.664 337.771C363.931 338.148 360.738 338.583 357.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 313.847C354.159 314.729 351.612 316.702 350.3 317.895C349.812 318.339 350.01 319.08 350.655 319.22C352.388 319.598 355.58 320.033 358.87 319.151C362.16 318.27 364.707 316.297 366.019 315.104C366.507 314.659 366.309 313.919 365.664 313.778C363.931 313.401 360.738 312.966 357.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 305.62C344.872 309.301 343.101 313.941 342.389 316.306C344.754 315.594 349.394 313.823 353.075 310.142C356.757 306.46 358.528 301.82 359.24 299.456C356.875 300.167 352.235 301.938 348.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 346.464C344.872 342.782 343.101 338.143 342.389 335.778C344.754 336.489 349.394 338.26 353.075 341.942C356.757 345.623 358.528 350.263 359.24 352.628C356.875 351.917 352.235 350.145 348.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 297.916L658.43 319.144C658.586 319.811 659.099 320.338 659.762 320.513L679.965 325.855L659.762 331.197C659.099 331.372 658.586 331.899 658.43 332.567L653.449 353.795L648.468 332.567C648.312 331.899 647.799 331.372 647.136 331.197L626.933 325.855L647.136 320.513C647.799 320.338 648.312 319.811 648.468 319.144L653.449 297.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 316.302C652.767 315.345 654.131 315.345 654.353 316.302L655.82 322.631C655.898 322.965 656.153 323.229 656.484 323.317L662.621 324.959C663.539 325.204 663.539 326.506 662.621 326.751L656.484 328.393C656.153 328.482 655.898 328.746 655.82 329.08L654.353 335.408C654.131 336.365 652.767 336.365 652.545 335.408L651.078 329.08C651.001 328.746 650.745 328.482 650.414 328.393L644.277 326.751C643.36 326.506 643.36 325.204 644.277 324.959L650.414 323.317C650.745 323.229 651.001 322.965 651.078 322.631L652.545 316.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 305.62C640.359 309.301 642.131 313.941 642.842 316.306C640.477 315.594 635.838 313.823 632.156 310.142C628.474 306.46 626.703 301.82 625.992 299.456C628.357 300.167 632.996 301.938 636.678 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 346.464C640.359 342.782 642.131 338.143 642.842 335.778C640.477 336.489 635.838 338.26 632.156 341.942C628.474 345.623 626.703 350.263 625.992 352.628C628.357 351.917 632.996 350.145 636.678 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 337.702C629.435 336.821 631.982 334.848 633.294 333.654C633.782 333.21 633.584 332.47 632.939 332.329C631.206 331.951 628.014 331.516 624.724 332.398C621.434 333.279 618.887 335.252 617.575 336.446C617.087 336.89 617.285 337.63 617.93 337.771C619.663 338.148 622.856 338.583 626.145 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 313.847C629.435 314.729 631.982 316.702 633.294 317.895C633.782 318.339 633.584 319.08 632.939 319.22C631.206 319.598 628.014 320.033 624.724 319.151C621.434 318.27 618.887 316.297 617.575 315.104C617.087 314.659 617.285 313.919 617.93 313.778C619.663 313.401 622.856 312.966 626.145 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 300.84C647.627 304.13 647.192 307.322 646.814 309.055C646.673 309.7 645.933 309.899 645.489 309.41C644.295 308.099 642.322 305.551 641.441 302.262C640.56 298.972 640.995 295.779 641.372 294.047C641.513 293.402 642.253 293.203 642.697 293.691C643.891 295.003 645.864 297.551 646.745 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 349.566C647.627 346.276 647.192 343.084 646.814 341.351C646.673 340.706 645.933 340.508 645.489 340.996C644.295 342.308 642.322 344.855 641.441 348.145C640.56 351.434 640.995 354.627 641.372 356.36C641.513 357.005 642.253 357.203 642.697 356.715C643.891 355.403 645.864 352.856 646.745 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 300.84C659.11 304.13 659.545 307.322 659.923 309.055C660.063 309.7 660.804 309.899 661.248 309.41C662.441 308.099 664.414 305.551 665.296 302.262C666.177 298.972 665.742 295.779 665.365 294.047C665.224 293.402 664.484 293.203 664.04 293.691C662.846 295.003 660.873 297.551 659.992 300.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 349.566C659.11 346.276 659.545 343.084 659.923 341.351C660.063 340.706 660.804 340.508 661.248 340.996C662.441 342.308 664.414 344.855 665.296 348.145C666.177 351.434 665.742 354.627 665.365 356.36C665.224 357.005 664.484 357.203 664.04 356.715C662.846 355.403 660.873 352.856 659.992 349.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 337.702C676.159 336.821 673.612 334.848 672.3 333.654C671.812 333.21 672.01 332.47 672.655 332.329C674.388 331.951 677.58 331.516 680.87 332.398C684.16 333.279 686.707 335.252 688.019 336.446C688.507 336.89 688.309 337.63 687.664 337.771C685.931 338.148 682.738 338.583 679.449 337.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 313.847C676.159 314.729 673.612 316.702 672.3 317.895C671.812 318.339 672.01 319.08 672.655 319.22C674.388 319.598 677.58 320.033 680.87 319.151C684.16 318.27 686.707 316.297 688.019 315.104C688.507 314.659 688.309 313.919 687.664 313.778C685.931 313.401 682.738 312.966 679.449 313.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 305.62C666.872 309.301 665.101 313.941 664.389 316.306C666.754 315.594 671.394 313.823 675.075 310.142C678.757 306.46 680.528 301.82 681.24 299.456C678.875 300.167 674.235 301.938 670.554 305.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 346.464C666.872 342.782 665.101 338.143 664.389 335.778C666.754 336.489 671.394 338.26 675.075 341.942C678.757 345.623 680.528 350.263 681.24 352.628C678.875 351.917 674.235 350.145 670.554 346.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M331.449 372.916L336.43 394.144C336.586 394.811 337.099 395.338 337.762 395.513L357.965 400.855L337.762 406.197C337.099 406.372 336.586 406.899 336.43 407.567L331.449 428.795L326.468 407.567C326.312 406.899 325.799 406.372 325.136 406.197L304.933 400.855L325.136 395.513C325.799 395.338 326.312 394.811 326.468 394.144L331.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M330.545 391.302C330.767 390.345 332.131 390.345 332.353 391.302L333.82 397.631C333.898 397.965 334.153 398.229 334.484 398.317L340.621 399.959C341.539 400.204 341.539 401.506 340.621 401.751L334.484 403.393C334.153 403.482 333.898 403.746 333.82 404.08L332.353 410.408C332.131 411.365 330.767 411.365 330.545 410.408L329.078 404.08C329.001 403.746 328.745 403.482 328.414 403.393L322.277 401.751C321.36 401.506 321.36 400.204 322.277 399.959L328.414 398.317C328.745 398.229 329.001 397.965 329.078 397.631L330.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M314.678 380.62C318.359 384.301 320.131 388.941 320.842 391.306C318.477 390.594 313.838 388.823 310.156 385.142C306.474 381.46 304.703 376.82 303.992 374.456C306.357 375.167 310.996 376.938 314.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M314.678 421.464C318.359 417.782 320.131 413.143 320.842 410.778C318.477 411.489 313.838 413.26 310.156 416.942C306.474 420.623 304.703 425.263 303.992 427.628C306.357 426.917 310.996 425.145 314.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M304.145 412.702C307.435 411.821 309.982 409.848 311.294 408.654C311.782 408.21 311.584 407.47 310.939 407.329C309.206 406.951 306.014 406.516 302.724 407.398C299.434 408.279 296.887 410.252 295.575 411.446C295.087 411.89 295.285 412.63 295.93 412.771C297.663 413.148 300.856 413.583 304.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M304.145 388.847C307.435 389.729 309.982 391.702 311.294 392.895C311.782 393.339 311.584 394.08 310.939 394.22C309.206 394.598 306.014 395.033 302.724 394.151C299.434 393.27 296.887 391.297 295.575 390.104C295.087 389.659 295.285 388.919 295.93 388.778C297.663 388.401 300.856 387.966 304.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 375.84C325.627 379.13 325.192 382.322 324.814 384.055C324.673 384.7 323.933 384.899 323.489 384.41C322.295 383.099 320.322 380.551 319.441 377.262C318.56 373.972 318.995 370.779 319.372 369.047C319.513 368.402 320.253 368.203 320.697 368.691C321.891 370.003 323.864 372.551 324.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M324.745 424.566C325.627 421.276 325.192 418.084 324.814 416.351C324.673 415.706 323.933 415.508 323.489 415.996C322.295 417.308 320.322 419.855 319.441 423.145C318.56 426.434 318.995 429.627 319.372 431.36C319.513 432.005 320.253 432.203 320.697 431.715C321.891 430.403 323.864 427.856 324.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 375.84C337.11 379.13 337.545 382.322 337.923 384.055C338.063 384.7 338.804 384.899 339.248 384.41C340.441 383.099 342.414 380.551 343.296 377.262C344.177 373.972 343.742 370.779 343.365 369.047C343.224 368.402 342.484 368.203 342.04 368.691C340.846 370.003 338.873 372.551 337.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M337.992 424.566C337.11 421.276 337.545 418.084 337.923 416.351C338.063 415.706 338.804 415.508 339.248 415.996C340.441 417.308 342.414 419.855 343.296 423.145C344.177 426.434 343.742 429.627 343.365 431.36C343.224 432.005 342.484 432.203 342.04 431.715C340.846 430.403 338.873 427.856 337.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 412.702C354.159 411.821 351.612 409.848 350.3 408.654C349.812 408.21 350.01 407.47 350.655 407.329C352.388 406.951 355.58 406.516 358.87 407.398C362.16 408.279 364.707 410.252 366.019 411.446C366.507 411.89 366.309 412.63 365.664 412.771C363.931 413.148 360.738 413.583 357.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M357.449 388.847C354.159 389.729 351.612 391.702 350.3 392.895C349.812 393.339 350.01 394.08 350.655 394.22C352.388 394.598 355.58 395.033 358.87 394.151C362.16 393.27 364.707 391.297 366.019 390.104C366.507 389.659 366.309 388.919 365.664 388.778C363.931 388.401 360.738 387.966 357.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M348.554 380.62C344.872 384.301 343.101 388.941 342.389 391.306C344.754 390.594 349.394 388.823 353.075 385.142C356.757 381.46 358.528 376.82 359.24 374.456C356.875 375.167 352.235 376.938 348.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M348.554 421.464C344.872 417.782 343.101 413.143 342.389 410.778C344.754 411.489 349.394 413.26 353.075 416.942C356.757 420.623 358.528 425.263 359.24 427.628C356.875 426.917 352.235 425.145 348.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M653.449 372.916L658.43 394.144C658.586 394.811 659.099 395.338 659.762 395.513L679.965 400.855L659.762 406.197C659.099 406.372 658.586 406.899 658.43 407.567L653.449 428.795L648.468 407.567C648.312 406.899 647.799 406.372 647.136 406.197L626.933 400.855L647.136 395.513C647.799 395.338 648.312 394.811 648.468 394.144L653.449 372.916Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M652.545 391.302C652.767 390.345 654.131 390.345 654.353 391.302L655.82 397.631C655.898 397.965 656.153 398.229 656.484 398.317L662.621 399.959C663.539 400.204 663.539 401.506 662.621 401.751L656.484 403.393C656.153 403.482 655.898 403.746 655.82 404.08L654.353 410.408C654.131 411.365 652.767 411.365 652.545 410.408L651.078 404.08C651.001 403.746 650.745 403.482 650.414 403.393L644.277 401.751C643.36 401.506 643.36 400.204 644.277 399.959L650.414 398.317C650.745 398.229 651.001 397.965 651.078 397.631L652.545 391.302Z"
                fill="#DEF1FF"
              />
              <path
                d="M636.678 380.62C640.359 384.301 642.131 388.941 642.842 391.306C640.477 390.594 635.838 388.823 632.156 385.142C628.474 381.46 626.703 376.82 625.992 374.456C628.357 375.167 632.996 376.938 636.678 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M636.678 421.464C640.359 417.782 642.131 413.143 642.842 410.778C640.477 411.489 635.838 413.26 632.156 416.942C628.474 420.623 626.703 425.263 625.992 427.628C628.357 426.917 632.996 425.145 636.678 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M626.145 412.702C629.435 411.821 631.982 409.848 633.294 408.654C633.782 408.21 633.584 407.47 632.939 407.329C631.206 406.951 628.014 406.516 624.724 407.398C621.434 408.279 618.887 410.252 617.575 411.446C617.087 411.89 617.285 412.63 617.93 412.771C619.663 413.148 622.856 413.583 626.145 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M626.145 388.847C629.435 389.729 631.982 391.702 633.294 392.895C633.782 393.339 633.584 394.08 632.939 394.22C631.206 394.598 628.014 395.033 624.724 394.151C621.434 393.27 618.887 391.297 617.575 390.104C617.087 389.659 617.285 388.919 617.93 388.778C619.663 388.401 622.856 387.966 626.145 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 375.84C647.627 379.13 647.192 382.322 646.814 384.055C646.673 384.7 645.933 384.899 645.489 384.41C644.295 383.099 642.322 380.551 641.441 377.262C640.56 373.972 640.995 370.779 641.372 369.047C641.513 368.402 642.253 368.203 642.697 368.691C643.891 370.003 645.864 372.551 646.745 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M646.745 424.566C647.627 421.276 647.192 418.084 646.814 416.351C646.673 415.706 645.933 415.508 645.489 415.996C644.295 417.308 642.322 419.855 641.441 423.145C640.56 426.434 640.995 429.627 641.372 431.36C641.513 432.005 642.253 432.203 642.697 431.715C643.891 430.403 645.864 427.856 646.745 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 375.84C659.11 379.13 659.545 382.322 659.923 384.055C660.063 384.7 660.804 384.899 661.248 384.41C662.441 383.099 664.414 380.551 665.296 377.262C666.177 373.972 665.742 370.779 665.365 369.047C665.224 368.402 664.484 368.203 664.04 368.691C662.846 370.003 660.873 372.551 659.992 375.84Z"
                fill="#DEF1FF"
              />
              <path
                d="M659.992 424.566C659.11 421.276 659.545 418.084 659.923 416.351C660.063 415.706 660.804 415.508 661.248 415.996C662.441 417.308 664.414 419.855 665.296 423.145C666.177 426.434 665.742 429.627 665.365 431.36C665.224 432.005 664.484 432.203 664.04 431.715C662.846 430.403 660.873 427.856 659.992 424.566Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 412.702C676.159 411.821 673.612 409.848 672.3 408.654C671.812 408.21 672.01 407.47 672.655 407.329C674.388 406.951 677.58 406.516 680.87 407.398C684.16 408.279 686.707 410.252 688.019 411.446C688.507 411.89 688.309 412.63 687.664 412.771C685.931 413.148 682.738 413.583 679.449 412.702Z"
                fill="#DEF1FF"
              />
              <path
                d="M679.449 388.847C676.159 389.729 673.612 391.702 672.3 392.895C671.812 393.339 672.01 394.08 672.655 394.22C674.388 394.598 677.58 395.033 680.87 394.151C684.16 393.27 686.707 391.297 688.019 390.104C688.507 389.659 688.309 388.919 687.664 388.778C685.931 388.401 682.738 387.966 679.449 388.847Z"
                fill="#DEF1FF"
              />
              <path
                d="M670.554 380.62C666.872 384.301 665.101 388.941 664.389 391.306C666.754 390.594 671.394 388.823 675.075 385.142C678.757 381.46 680.528 376.82 681.24 374.456C678.875 375.167 674.235 376.938 670.554 380.62Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                d="M670.554 421.464C666.872 417.782 665.101 413.143 664.389 410.778C666.754 411.489 671.394 413.26 675.075 416.942C678.757 420.623 680.528 425.263 681.24 427.628C678.875 426.917 674.235 425.145 670.554 421.464Z"
                stroke="#DEF1FF"
                strokeWidth="1.85508"
              />
              <path
                opacity="0.1"
                d="M680.81 138.783C690.514 162.211 695.753 187.234 696.27 212.562H696.313L696.312 396H610.812L610.813 216.719H610.739C610.739 201.212 607.684 185.857 601.75 171.531C595.816 157.204 587.118 144.187 576.153 133.222C565.188 122.257 552.171 113.559 537.844 107.625C523.518 101.691 492.656 85.5738 492.656 85.5738C492.656 85.5738 461.795 101.691 447.468 107.625C433.142 113.559 420.124 122.257 409.159 133.222C398.194 144.187 389.497 157.204 383.562 171.531C377.628 185.857 374.574 201.212 374.574 216.719H374.5L374.5 398.375H289L289 214.938H289.008C289.236 188.799 294.495 162.943 304.502 138.783C314.737 114.074 329.738 91.6233 348.65 72.712C367.561 53.8008 390.012 38.7996 414.72 28.5649C439.429 18.3302 492.656 0 492.656 0C492.656 0 545.883 18.3302 570.592 28.5649C595.301 38.7996 617.752 53.8008 636.663 72.712C655.574 91.6233 670.575 114.074 680.81 138.783Z"
                fill="url(#pattern0)"
              />
              <path
                d="M248.485 382.639L350.102 359.216H423.775L511.844 382.639L535.789 482.119L379.97 493.682L224.702 478.265L248.485 382.639Z"
                fill="#3A7CC5"
              />
              <path
                d="M310 368.5L316 407.5L359.5 451V463"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M460.5 369.5L454.5 408.5L411 452V464"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387.5 388.5L350 359V400L387.5 443.5L425 400V362L424 359L387.5 388.5Z"
                fill="#5B9ADF"
              />
              <path
                d="M350.238 340.065H424.018V359.267L387.128 389.068L350.238 359.267V340.065Z"
                fill="#EFB799"
              />
              <path
                d="M350 359.5L374 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M387 389L387 418"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M387 444L387 473"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M425 359.5L400.5 408.5L387 389"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.5"
                d="M350.238 355.065H424.018V368.724C424.018 368.724 406.949 385.899 387.128 385.899C367.306 385.899 350.238 368.724 350.238 368.724V355.065Z"
                fill="url(#pattern1)"
              />
              <path
                d="M344.079 286.718C346.018 298.304 340.14 315.962 330.951 317.5C321.762 319.038 312.5 311 310.802 292.286C308.863 280.7 314.741 270.061 323.93 268.523C333.12 266.985 342.141 275.131 344.079 286.718Z"
                fill="#E7A17C"
              />
              <path
                d="M323.81 300.006C317.202 294.72 321.424 288.994 324.36 286.792C324.544 285.14 323.81 281.176 319.405 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M461.389 291.747C459.5 311.5 451.074 318.739 441.839 317.5C432.605 316.261 426.386 298.901 427.949 287.258C429.512 275.615 438.265 267.181 447.499 268.421C456.733 269.66 462.608 279 461.389 291.747Z"
                fill="#E7A17C"
              />
              <path
                d="M443.6 286.234C443.6 307.097 439.5 343 434.5 352C429.5 361 417.461 376.298 386 376C354.539 375.702 343.668 361.5 338 352C332.332 342.5 327.251 307.097 327.251 286.234C327.251 241.532 321.395 198.542 386.099 198.697C450.803 198.851 443.6 241.532 443.6 286.234Z"
                fill="#EFB799"
              />
              <path
                d="M376.99 278.475C375.869 276.94 372.703 273.688 369 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M394 278.475C395.121 276.94 398.287 273.688 401.99 272.959"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M354 296.71C357.798 296.572 366.733 294.968 372.087 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M417.087 296.71C413.289 296.572 404.354 294.968 399 289.648"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M366.74 317.309L355.184 327.926L351 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M369 246.5L386.257 250.915L403 246.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M405 317.309L416.555 327.926L420.74 341.809"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M447.719 300.006C454.326 294.72 450.105 288.994 447.168 286.792C446.985 285.14 447.719 281.176 452.124 278.533"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M381.072 329.738C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.345L386.027 337.997L393.185 336.345L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.738C388.339 331.06 383.274 330.289 381.072 329.738Z"
                fill="#E7A17C"
              />
              <path
                d="M381.072 329.738C372.262 331.06 364.921 337.263 362.351 340.2L379.42 336.345L386.027 337.997L393.185 336.345L410.804 340.75C401.994 333.262 393.919 330.289 390.982 329.738C388.339 331.06 383.274 330.289 381.072 329.738Z"
                fill="url(#pattern2)"
                fillOpacity="0.5"
              />
              <path
                d="M375.708 268.74C358.915 265.48 350.483 264.132 333.668 267.502"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M395.446 268.997C412.198 265.532 420.613 264.081 437.468 267.245"
                stroke="#959090"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M381.071 329.738C382.554 330.569 386.611 331.733 390.982 329.738"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M410.804 340.75L392.634 336.345L386.027 337.997L379.42 336.345L362.351 339.649L359.598 337.997"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M410.804 340.75L414.107 339.098"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M411 342L419 338L412.5 325L401 318.5L386.5 321.479L372 318.5L360 325L352 338L362.5 342L379 340.5L386 338L393 340.5L411 342Z"
                fill="#FFF5EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M419 338L412.5 325L400.5 318L386.158 321.253L372 318.5L360 325L352 338L362.5 342L379 340.5L386.158 338L393 340.5L411.5 342L419 338Z"
                fill="url(#pattern3)"
                fillOpacity="0.4"
              />
              <path
                d="M340.67 240.359L327.113 270.824L324.5 231.557L328 220.5L333 213L340.67 204.5L354.5 195.5L375.5 190.5L397 189.5L417.5 197.5L434.555 210L442 220.5L444.39 231.557L443.839 270.274L431.621 240.359L434.555 233.024L419.885 227.89H403L386 235.5L368 227.89H349.471L337.736 234.491L340.67 240.359Z"
                fill="#FFF5EF"
              />
              <path
                d="M379.97 346.256C381.782 347.087 386.741 348.25 392.083 346.256"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
              />
              <path
                d="M371.443 313L370 317.667L386.15 321L402 317.667L401.004 313"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="356.5" cy="281.5" r="5.5" fill="#573420" />
              <circle
                r="5.50595"
                transform="matrix(-1 0 0 1 414.29 281.286)"
                fill="#573420"
              />
              <path
                d="M374 282C366 276.5 350.5 270 336.5 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M398.174 282C406.174 276.5 421.674 270 435.674 285.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                opacity="0.3"
                d="M434.5 233L420 227.878H403L386.027 235.5L368 227.878L334.5 229L341 240L327 271L323.5 221.5L386.027 226.226L444.5 219.5L444 270.5L431.5 240.5L434.5 233Z"
                fill="url(#pattern4)"
              />
              <path
                d="M444 267.5V240"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M263.795 409.44L269.301 419.902V487.074"
                stroke="black"
                strokeWidth="2.20238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M379.399 284.433L378.006 296.119L379.101 307.567"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M392.011 284.435L393.495 296.109L392.489 307.565"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M444.5 236C388 220.5 344.333 232.333 324.5 237L321.5 197C327.833 191.333 352.8 179.9 384 179.5C415.2 179.1 439.333 192 447 198.5L444.5 236Z"
                fill="#F56E6E"
              />
              <path
                d="M325 237C341.5 230.667 388.4 221.6 444 236"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M552.593 324.5L579.105 353.5L592 382L560 364L552.593 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M659.294 324.5L632.782 353.5L617 383.5L654.5 363L659.294 324.5Z"
                fill="#FFE6D8"
              />
              <path
                d="M495.045 391.292L576.238 370.755H640.051L716.332 391.292L743.363 503.39L609.569 525.066L468.616 503.39L495.045 391.292Z"
                fill="#3A7CC5"
              />
              <path
                d="M510.461 413.643L516.518 423.553V512.952"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M577.634 346.47H633.795V374.551L647.5 413.5L605.714 428.5L563 413.5L577 373L577.634 346.47Z"
                fill="#E7A17C"
              />
              <path
                opacity="0.5"
                d="M577.634 351.47H633.795V379.551C633.795 379.551 628 398.578 605.714 398.5C583.429 398.423 577.634 378 577.634 378V351.47Z"
                fill="url(#pattern5)"
              />
              <path
                d="M558.5 423.5L594.5 437L596 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M651 425L617.5 437L616 470"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M512.5 387.5L495.045 391.271L472.47 487.075"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M606 428L606 481"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M557 453.5L578 368.5L570.5 370.5L562 372L545.5 377.5L519 449.5L509.5 488.5L555 493L557 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M654 453.5L633.5 374.5L634 370L648 371L665.5 375.5L692 449.5L701.5 488.5L656 493L654 453.5Z"
                fill="#89B7E9"
              />
              <path
                d="M662.5 309C656.311 359.895 640 380.5 606.5 380.5C573 380.5 555.134 357.395 547.5 304.5C547.5 263.992 572.965 225.258 605.777 225.258C638.59 225.258 659.311 267.895 662.5 309Z"
                fill="#EFB799"
              />
              <path
                d="M589 270.5L606.257 274.915L623 270.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M591.5 337L583.5 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M621 337L629 350.5V365"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M611.5 327.5V306.5L612.5 299.5C613 298.167 615.3 295 620.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M600 315L600 328"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.598 288.941C579.855 285.434 571.444 283.963 554.581 287.085"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M615.168 289.267C631.854 285.501 640.242 283.899 657.151 286.758"
                stroke="#959090"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M630 234L624 251.5L568 275.5L554.5 313L553 328L556.5 343L534 326.5L527 312L536 293L542.5 260.5L563.5 232L601 220.5L627 222L636 232L651.5 236.5L669.5 260L674.5 287.5L682.5 306L670 336L655 344.5L658.5 315L646.5 270.5L627 251.5L630 234Z"
                fill="#FFF5EF"
              />
              <path
                opacity="0.2"
                d="M627 251.5L630.5 232.5L624 251.5L568 275.5L554.5 313L553 328C553 328 555.5 341.885 560.5 351.5C565.5 361.115 574 369.5 574 369.5L571.5 370.5L560 364L556 342.5L534 326.5L527 312L536 293L542.5 260.5L548.5 252.5L606.5 231L634 223L666 255.5L669.5 260L674.5 287L682.5 306L670 336L657 343.5L654.5 363L640.5 370.5H638.5C638.5 370.5 644.5 365 648.5 358.5C652.5 352 655 344.5 655 344.5L658.5 314.5L646.5 270.5L627 251.5Z"
                fill="url(#pattern6)"
              />
              <path
                d="M545 257.5L542.5 260.5L536 293L527 312L534 326.5L555.5 343L560 364L569 369"
                stroke="#C9C9C9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="579.286" cy="302.163" r="4.95536" fill="#835338" />
              <circle
                r="4.95536"
                transform="matrix(-1 0 0 1 632.451 302.163)"
                fill="#835338"
              />
              <path
                d="M602.118 343.233C597.686 342.6 589.455 352.731 589.455 352.731L590.721 353.364L602.118 350.831L605.917 352.098L610.982 350.831L622.379 353.364C622.379 353.364 613.515 341.967 609.082 343.233C604.65 344.5 606.55 343.867 602.118 343.233Z"
                fill="#E68054"
              />
              <path
                d="M595 302.5C586.5 295.5 571.732 294.382 560.153 304.307L556.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M617 302.5C625.5 295.5 640.268 294.382 651.847 304.307L655.5 303.755"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M605.917 362.228C602.371 362.734 594.309 356.952 590.721 353.997L601.485 350.831L605.917 352.097L610.349 350.831L622.379 353.997C618.369 356.529 609.462 361.721 605.917 362.228Z"
                fill="#E49278"
              />
              <path
                d="M666 253.509C609.5 238.009 565.833 249.842 546 254.509L543 214.509C549.333 208.842 574.3 197.409 605.5 197.009C636.7 196.609 660.833 209.509 668.5 216.009L666 253.509Z"
                fill="#F56E6E"
              />
              <path
                d="M546.5 254.509C563 248.176 609.9 239.109 665.5 253.509"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M588.822 352.023L590.592 353.447L601.566 350.598L605.814 352.023L610.063 350.598L621.112 353.997L623.012 352.023"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M601.485 360.729C602.621 361.684 605.732 363.022 609.082 360.729"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M602.751 343C603.698 343.956 606.29 345.293 609.082 343"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M596.455 334.446L605.903 335.547L615.176 334.446"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M699.866 413.643L693.81 423.553V511.851"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M598 301C597.5 299.167 595.7 295 592.5 293"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M586 315.5C587.833 315 592 313.2 594 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M626 315.5C624.167 315 620 313.2 618 310"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <ellipse
                cx="500"
                cy="372.5"
                rx="451"
                ry="241.5"
                fill="url(#paint5_radial_814_40121)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0112175) scale(0.00166667 0.00170406)" />
                </pattern>
                <pattern
                  id="pattern1"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.696429) scale(0.00166667 0.0039881)" />
                </pattern>
                <pattern
                  id="pattern2"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -1.7) scale(0.00166667 0.00733333)" />
                </pattern>
                <pattern
                  id="pattern3"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.895833) scale(0.00166667 0.00465278)" />
                </pattern>
                <pattern
                  id="pattern4"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.674757) scale(0.00166667 0.00391586)" />
                </pattern>
                <pattern
                  id="pattern5"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0970684) scale(0.00166667 0.00199023)" />
                </pattern>
                <pattern
                  id="pattern6"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use transform="translate(0 -0.0271186) scale(0.00166667 0.00175706)" />
                </pattern>
                <linearGradient
                  id="paint0_linear_814_40121"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_814_40121"
                  x1="498"
                  y1="292.5"
                  x2="498"
                  y2="354.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_814_40121"
                  x1="215.894"
                  y1="76.9963"
                  x2="215.894"
                  y2="1.7022"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_814_40121"
                  x1="841"
                  y1="81"
                  x2="841"
                  y2="41"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#DEF1FF" />
                  <stop offset="1" stopColor="#DEF1FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_814_40121"
                  x1="433"
                  y1="345"
                  x2="433"
                  y2="374"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#C2E4FC" />
                  <stop offset="1" stopColor="#C2E4FC" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                  id="paint5_radial_814_40121"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(500 208.606) rotate(90) scale(354.924 662.818)"
                >
                  <stop offset="0.533974" stopColor="#F2FAFF" stopOpacity="0" />
                  <stop offset="0.74976" stopColor="#F2FAFF" />
                </radialGradient>
              </defs>
            </svg>
          ),
          arrow: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.99993 2.10378e-05C2.23359 -0.000435322 2.46002 0.0809393 2.63993 0.230021L7.99994 4.71002L13.3699 0.39002C13.4722 0.306954 13.5899 0.244922 13.7163 0.207491C13.8426 0.170059 13.9751 0.157965 14.1061 0.171904C14.2371 0.185844 14.3641 0.22554 14.4798 0.288714C14.5954 0.351888 14.6974 0.437293 14.7799 0.54002C14.863 0.642307 14.925 0.760003 14.9625 0.886343C14.9999 1.01268 15.012 1.14517 14.9981 1.2762C14.9841 1.40723 14.9444 1.53421 14.8812 1.64985C14.8181 1.76549 14.7327 1.8675 14.6299 1.95002L8.62994 6.78002C8.451 6.9271 8.22656 7.00751 7.99494 7.00751C7.76331 7.00751 7.53887 6.9271 7.35994 6.78002L1.35994 1.78002C1.25868 1.69607 1.17497 1.59297 1.11362 1.47662C1.05227 1.36028 1.01447 1.23297 1.0024 1.10199C0.990322 0.971016 1.0042 0.838944 1.04325 0.71334C1.08229 0.587736 1.14573 0.471069 1.22993 0.370021C1.32299 0.255308 1.4403 0.162634 1.57344 0.0986587C1.70657 0.0346838 1.85223 0.000997617 1.99993 2.10378e-05Z"
                fill={fill ? theme`colors.white` : theme`colors.blue.400`}
              />
            </svg>
          ),
          AllSectors: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="2.5" y="4.5" width="11" height="8" stroke={fill} />
              <path d="M3 5C3 6 4 9 8 9C12 9 13 6 13 5" stroke={fill} />
              <path d="M5 3V2H11V3" stroke={fill} />
            </svg>
          ),
          Agriculture: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.61541 4.82915C6.41373 5.24672 6.89477 6.08598 7.17578 6.9006C7.31331 7.29926 7.39539 7.67066 7.44291 7.94259C7.44685 7.96514 7.45054 7.98696 7.45401 8.00803C7.42139 8.01984 7.38675 8.03216 7.35019 8.04488C7.06207 8.1451 6.65952 8.26841 6.20171 8.36146C5.26294 8.55227 4.19445 8.59445 3.38459 8.17085C2.58627 7.75328 2.10523 6.91402 1.82422 6.0994C1.68669 5.70074 1.60461 5.32934 1.55709 5.05741C1.55315 5.03486 1.54946 5.01304 1.54599 4.99197C1.57861 4.98016 1.61325 4.96784 1.64981 4.95512C1.93793 4.8549 2.34048 4.73159 2.79829 4.63854C3.73706 4.44773 4.80555 4.40555 5.61541 4.82915Z"
                stroke={fill}
                strokeLinejoin="round"
              />
              <path
                d="M10.3846 4.82915C9.58627 5.24672 9.10523 6.08598 8.82422 6.9006C8.68669 7.29926 8.60461 7.67066 8.55709 7.94259C8.55315 7.96514 8.54946 7.98696 8.54599 8.00803C8.57861 8.01984 8.61325 8.03216 8.64981 8.04488C8.93793 8.1451 9.34048 8.26841 9.79829 8.36146C10.7371 8.55227 11.8056 8.59445 12.6154 8.17085C13.4137 7.75328 13.8948 6.91402 14.1758 6.0994C14.3133 5.70074 14.3954 5.32934 14.4429 5.05741C14.4468 5.03486 14.4505 5.01304 14.454 4.99197C14.4214 4.98016 14.3867 4.96784 14.3502 4.95512C14.0621 4.8549 13.6595 4.73159 13.2017 4.63854C12.2629 4.44773 11.1944 4.40555 10.3846 4.82915Z"
                stroke={fill}
                strokeLinejoin="round"
              />
              <path d="M8 9L8 14" stroke={fill} />
            </svg>
          ),
          Industry: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6.5 6H4L2 13H4" stroke={fill} />
              <path d="M12.2727 5L15 14H5L7.72727 5H12.2727Z" stroke={fill} />
              <path
                d="M2.00008 6.00028C1.83341 5.50028 1.80008 4.40028 3.00008 4.00028C3.00012 2.99996 3.50012 1.99996 5.00012 2.00028C5.50012 1.33353 7.00012 1 8.00012 2.00004C8.50012 1.50002 9.80012 0.799964 11.0001 1.99996C11.6668 1.66663 13.2001 1.39996 14.0001 2.99996C14.6668 3.3333 15.6001 4.39996 14.0001 5.99996"
                stroke={fill}
              />
              <path d="M7 7.5H13M3.5 8H6" stroke={fill} />
            </svg>
          ),
          'Public sector': (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.21601 1.00053L6.74058 1.39729C6.17869 1.86599 5.42911 2.49095 4.67936 3.11594L2.61733 4.83466L1.9377 5.40105L1.74729 5.55974L1.69712 5.60155L1.68426 5.61227L1.681 5.61498L1.68018 5.61566L1.67998 5.61583L2 6L7.21601 1.00053ZM12.6119 5.5H3.38094H12.6119Z"
                stroke={fill}
              />
              <path d="M1 14L15 14" stroke={fill} />
              <path d="M2 12H14" stroke={fill} />
              <path d="M4 7L4 11" stroke={fill} />
              <path d="M6 7L6 11" stroke={fill} />
              <path d="M10 7L10 11" stroke={fill} />
              <path d="M8 7L8 11" stroke={fill} />
              <path d="M12 7L12 11" stroke={fill} />
            </svg>
          ),
          Services: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="5" r="2.5" stroke={fill} />
              <path
                d="M2.71647 13.5H2.70262C3.65718 11.0991 5.69907 9.5 7.9961 9.5C10.2931 9.5 12.335 11.0991 13.2896 13.5H13.2725H13.2542H13.2357H13.2171H13.1982H13.1792H13.1599H13.1405H13.1208H13.101H13.081H13.0608H13.0404H13.0199H12.9991H12.9782H12.9571H12.9358H12.9143H12.8927H12.8709H12.8489H12.8267H12.8043H12.7818H12.7591H12.7363H12.7132H12.69H12.6667H12.6431H12.6194H12.5956H12.5716H12.5474H12.523H12.4985H12.4739H12.4491H12.4241H12.399H12.3737H12.3483H12.3227H12.297H12.2711H12.2451H12.2189H12.1926H12.1661H12.1395H12.1128H12.0859H12.0588H12.0317H12.0044H11.9769H11.9494H11.9216H11.8938H11.8658H11.8377H11.8095H11.7811H11.7526H11.724H11.6953H11.6664H11.6374H11.6083H11.5791H11.5497H11.5203H11.4907H11.461H11.4311H11.4012H11.3712H11.341H11.3107H11.2804H11.2499H11.2193H11.1886H11.1578H11.1269H11.0959H11.0647H11.0335H11.0022H10.9708H10.9393H10.9077H10.876H10.8442H10.8123H10.7803H10.7483H10.7161H10.6839H10.6515H10.6191H10.5866H10.554H10.5214H10.4886H10.4558H10.4229H10.3899H10.3568H10.3237H10.2905H10.2572H10.2238H10.1904H10.1569H10.1233H10.0897H10.056H10.0222H9.98835H9.95445H9.92048H9.88646H9.85237H9.81823H9.78403H9.74977H9.71545H9.68108H9.64666H9.61218H9.57766H9.54308H9.50846H9.47378H9.43906H9.4043H9.36949H9.33463H9.29974H9.2648H9.22982H9.19481H9.15975H9.12466H9.08954H9.05438H9.01918H8.98396H8.9487H8.91341H8.8781H8.84276H8.80739H8.77199H8.73657H8.70113H8.66566H8.63018H8.59467H8.55915H8.52361H8.48805H8.45248H8.41689H8.38129H8.34567H8.31005H8.27442H8.23877H8.20312H8.16747H8.13181H8.09614H8.06047H8.0248H7.98913H7.95346H7.91779H7.88213H7.84646H7.8108H7.77515H7.73951H7.70387H7.66824H7.63263H7.59702H7.56143H7.52585H7.49028H7.45473H7.4192H7.38369H7.3482H7.31272H7.27727H7.24184H7.20644H7.17106H7.13571H7.10038H7.06508H7.02981H6.99458H6.95937H6.9242H6.88906H6.85395H6.81888H6.78385H6.74886H6.71391H6.679H6.64413H6.6093H6.57452H6.53978H6.50509H6.47044H6.43585H6.4013H6.3668H6.33236H6.29797H6.26363H6.22935H6.19513H6.16096H6.12685H6.0928H6.05881H6.02489H5.99103H5.95723H5.92349H5.88983H5.85623H5.8227H5.78924H5.75585H5.72253H5.68928H5.65611H5.62302H5.59H5.55706H5.5242H5.49142H5.45871H5.4261H5.39356H5.36111H5.32874H5.29646H5.26427H5.23217H5.20016H5.16824H5.13641H5.10467H5.07303H5.04149H5.01004H4.97869H4.94743H4.91628H4.88523H4.85428H4.82344H4.7927H4.76206H4.73154H4.70112H4.67081H4.6406H4.61052H4.58054H4.55067H4.52093H4.49129H4.46178H4.43238H4.4031H4.37394H4.3449H4.31599H4.2872H4.25853H4.22999H4.20158H4.17329H4.14514H4.11711H4.08922H4.06145H4.03382H4.00633H3.97897H3.95175H3.92467H3.89773H3.87093H3.84427H3.81775H3.79137H3.76514H3.73906H3.71312H3.68734H3.6617H3.63621H3.61087H3.58569H3.56066H3.53578H3.51107H3.4865H3.4621H3.43786H3.41377H3.38985H3.36609H3.3425H3.31907H3.29581H3.27271H3.24978H3.22703H3.20444H3.18202H3.15978H3.13771H3.11582H3.0941H3.07256H3.0512H3.03002H3.00902H2.9882H2.96757H2.94712H2.92685H2.90677H2.88688H2.86717H2.84766H2.82834H2.80921H2.79027H2.77152H2.75298H2.73462H2.71647Z"
                stroke={fill}
              />
            </svg>
          ),
          Falling: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 24"
              css={cssDirection}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.66666 1.61594e-06L6.66667 18.8933L1.88 14.12L-3.49691e-07 16L8 24L16 16L14.12 14.12L9.33333 18.8933L9.33333 1.49938e-06L6.66666 1.61594e-06Z"
                fill="#FE9900"
              />
            </svg>
          ),
          Rising: (
            <svg
              width={size}
              height={size}
              css={cssDirection}
              viewBox="0 0 16 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.33333 24L9.33333 5.10667L14.12 9.88L16 8L8 -3.49691e-07L1.55766e-06 8L1.88 9.88L6.66667 5.10667L6.66667 24L9.33333 24Z"
                fill="#69D2B5"
              />
            </svg>
          ),
          FemaleGender: (
            <svg
              width={size}
              height={size}
              css={cssGender}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="7.99984"
                cy="6.66671"
                r="4.66667"
                stroke={fill}
                strokeWidth="1.33333"
              />
              <path
                d="M8.66667 11.3334C8.66667 10.9652 8.36819 10.6667 8 10.6667C7.63181 10.6667 7.33333 10.9652 7.33333 11.3334H8.66667ZM7.33333 15.3334C7.33333 15.7016 7.63181 16 8 16C8.36819 16 8.66667 15.7016 8.66667 15.3334H7.33333ZM7.33333 11.3334V15.3334H8.66667V11.3334H7.33333Z"
                fill={fill}
              />
              <path
                d="M10 14C10.3682 14 10.6667 13.7016 10.6667 13.3334C10.6667 12.9652 10.3682 12.6667 10 12.6667L10 14ZM6 12.6667C5.6318 12.6667 5.33333 12.9652 5.33333 13.3334C5.33333 13.7016 5.6318 14 6 14L6 12.6667ZM10 12.6667L6 12.6667L6 14L10 14L10 12.6667Z"
                fill={fill}
              />
            </svg>
          ),
          MaleGender: (
            <svg
              width={size}
              height={size}
              css={cssGender}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="6.66684"
                cy="9.33334"
                r="4.66667"
                stroke={fill}
                strokeWidth="1.33333"
              />
              <path
                d="M13.9998 5.33338C13.9998 5.70157 14.2983 6.00005 14.6665 6.00005C15.0347 6.00005 15.3332 5.70157 15.3332 5.33338H13.9998ZM14.6665 1.33337H15.3332C15.3332 0.965184 15.0347 0.666707 14.6665 0.666707V1.33337ZM10.6665 0.666707C10.2983 0.666707 9.99984 0.965184 9.99984 1.33337C9.99984 1.70156 10.2983 2.00004 10.6665 2.00004V0.666707ZM15.3332 5.33338V1.33337H13.9998V5.33338H15.3332ZM14.6665 0.666707H10.6665V2.00004H14.6665V0.666707Z"
                fill={fill}
              />
              <path
                d="M14.6667 1.33337L10 6.00005"
                stroke={fill}
                strokeWidth="1.33333"
              />
            </svg>
          ),
          Student: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99935 10.2895L1.41158 6.8019L7.99935 3.70177L14.5871 6.8019L7.99935 10.2895Z"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M3.33398 8V10.9167C3.33398 11.2388 5.42332 12.6667 8.00065 12.6667C10.578 12.6667 12.6673 11.2388 12.6673 10.9167V8"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M8 7H14.6667V7.33333V10.6667"
                stroke={fill}
                strokeWidth="0.666667"
              />
            </svg>
          ),
          Disabled: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="6.66663"
                cy="2.6665"
                r="1.66667"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M9.33329 13.648C8.62562 14.2814 7.6911 14.6665 6.66663 14.6665C4.45749 14.6665 2.66663 12.8757 2.66663 10.6665C2.66663 9.18597 3.47102 7.89328 4.66663 7.20166"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M9.20515 9.64086L9.03488 9.56991L9.00455 9.38796L8.38433 5.6665L5.7058 5.6665L6.31019 11.1063L9.1354 12.3619L9.17994 12.3817L9.21695 12.4134L11.2802 14.1819L12.8855 12.0415L11.1512 10.4517L9.20515 9.64086Z"
                stroke={fill}
                strokeWidth="0.666667"
              />
            </svg>
          ),
          Discouraged: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="8.00004"
                cy="8.00016"
                r="6.33333"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M3.99996 6.66672C3.99996 7.28037 4.59691 7.77783 5.33329 7.77783C6.06967 7.77783 6.66663 7.28037 6.66663 6.66672"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M9.33333 6.66672C9.33333 7.28037 9.93029 7.77783 10.6667 7.77783C11.403 7.77783 12 7.28037 12 6.66672"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M9.33329 11.3333C9.33329 10.597 8.73634 10 7.99996 10C7.26358 10 6.66663 10.597 6.66663 11.3333"
                stroke={fill}
                strokeWidth="0.666667"
              />
            </svg>
          ),
          Other: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="3.33337"
                cy="8"
                r="1.66667"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <circle
                cx="8"
                cy="8"
                r="1.66667"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <circle
                cx="12.6666"
                cy="8"
                r="1.66667"
                stroke={fill}
                strokeWidth="0.666667"
              />
            </svg>
          ),
          Retired: (
            <svg
              width={size}
              height={size}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10"
                cy="3.33337"
                r="1.66667"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M11.3327 9.11111C11.3327 8.49746 10.7357 8 9.99935 8C9.26297 8 8.66602 8.49746 8.66602 9.11111V14.6667"
                stroke={fill}
                strokeWidth="0.666667"
              />
              <path
                d="M6.98985 4.47167L8.87387 6.35569L5.76498 9.42964L5.66601 9.52749V9.66667V14.3333L2.99935 14.3333L2.99935 8.47118L6.98985 4.47167Z"
                stroke={fill}
                strokeWidth="0.666667"
              />
            </svg>
          ),
          'Care-giver': (
            <svg
              width={size}
              height={size}
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_2659_27797" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 0H4V4L0 4V8H4V12H8V8H12V4L8 4V0Z"
                />
              </mask>
              <path
                d="M4 0V-0.666667H3.33333V0H4ZM8 0H8.66667V-0.666667H8V0ZM4 4V4.66667H4.66667V4H4ZM0 4L3.97364e-08 3.33333H-0.666667V4H0ZM0 8H-0.666667V8.66667H0V8ZM4 8H4.66667V7.33333H4V8ZM4 12H3.33333V12.6667H4V12ZM8 12V12.6667H8.66667V12H8ZM8 8V7.33333H7.33333V8H8ZM12 8V8.66667H12.6667V8H12ZM12 4H12.6667V3.33333H12V4ZM8 4H7.33333V4.66667H8V4ZM4 0.666667H8V-0.666667H4V0.666667ZM4.66667 4V0H3.33333V4H4.66667ZM-3.97364e-08 4.66667L4 4.66667V3.33333L3.97364e-08 3.33333L-3.97364e-08 4.66667ZM0.666667 8V4H-0.666667V8H0.666667ZM4 7.33333H0V8.66667H4V7.33333ZM4.66667 12V8H3.33333V12H4.66667ZM8 11.3333H4V12.6667H8V11.3333ZM7.33333 8V12H8.66667V8H7.33333ZM12 7.33333H8V8.66667H12V7.33333ZM11.3333 4V8H12.6667V4H11.3333ZM8 4.66667H12V3.33333L8 3.33333V4.66667ZM7.33333 0V4H8.66667V0H7.33333Z"
                fill={fill}
                mask="url(#path-1-inside-1_2659_27797)"
              />
            </svg>
          ),
        }[iconName]
      }
    </span>
  );
};

export default DynamicSvg;
